{
  "locales": { "en": "English", "zh-TW": "繁體中文", "ja": "日本語" },
  "common": {
    "titles": {
      "error": "Alert",
      "warning": "Warning",
      "remind": "Remind",
      "hint": "Hint",
      "checkYourSettings": "Check Your Setting"
    },
    "buttons": {
      "ok": "Ok",
      "confirm": "Confirm",
      "cancel": "Cancel",
      "submit": "Submit",
      "publish": "Publish",
      "delete": "Delete",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "replace": "Replace",
      "close": "Close",
      "leave": "Leave",
      "apply": "Apply",
      "edit": "Edit",
      "search": "Search",
      "save": "Save",
      "completeAndCheck": "Complete and Check",
      "back": "Back",
      "next": "Next",
      "nextPage": "Next Page",
      "reject": "Reject",
      "goSummary": "Summary",
      "backModify": "Back to Modify",
      "review": "Review",
      "archive": "Archive",
      "restore": "Restore",
      "download": "Download",
      "goBack": "Back"
    },
    "messages": {
      "succeeded": "Succeeded",
      "failed": "Failed",
      "loading": "Loading... Please wait",
      "permissionDenied": "You don't have permission to do this"
    },
    "units": {
      "seconds": "seconds",
      "secs": "secs",
      "device": "device",
      "devices": "devices",
      "day": "day",
      "days": "days",
      "hour": "hour",
      "hours": "hours",
      "minutes": "minutes"
    },
    "timeZone": {
      "taipei": "Asia/Taipei",
      "tokyo": "Asia/Tokyo",
      "hochiminh": "Asia/UTC+7 (Ho_Chi_Ming, Jakarta, etc.)"
    },
    "currency": {
      "twd": "TWD",
      "ntd": "NTD",
      "usd": "USD",
      "myr": "MYR",
      "jpy": "JPY",
      "vnd": "VND",
      "idr": "IDR",
      "eur": "EUR"
    },
    "language": {
      "zhtw": "Traditional Chinese",
      "enus": "English",
      "jajp": "Japanese"
    },
    "placeholder": { "pleaseSelect": "Please Choose", "all": "ALL" },
    "labels": {
      "noData": "No data",
      "yes": "Yes",
      "no": "No",
      "can": "Can",
      "cannot": "Cannot",
      "default": "Default",
      "copyToClipBoard": "Copy to clipboard",
      "total": "Total",
      "showMore": "Show more",
      "open": "Open",
      "close": "Close",
      "optional": "optional",
      "edit": "Edit"
    },
    "notice": "Notice",
    "valuePerDay": "{{value}} / day",
    "day": "day",
    "duration": "{{start}}<1/>to<3/>{{end}}",
    "warning": "Warning"
  },
  "actor": {
    "types": {
      "system": "System",
      "agency": "Agency",
      "advertiser": "Advertiser"
    },
    "roles": {
      "admin": "Admin",
      "manager": "Manager",
      "account": "Account",
      "sales": "Sales",
      "report": "Report"
    },
    "roleNames": {
      "admin": "System Admin",
      "agencyAdmin": "Agency | Admin",
      "agencyManager": "Agency | AM Manager",
      "agencyOperator": "Agency | AD Operator",
      "agencySales": "Agency | AE Manager",
      "agencyReport": "Agency | Report",
      "advertiserAdmin": "Advertiser | Account Manager",
      "advertiserSales": "Advertiser | Account Executive",
      "advertiserReport": "Advertiser | AD Client",
      "reconciliationOfficer": "Financial Personnel",
      "beaconAdmin": "Beacon Admin",
      "beaconExecutive": "Beacon Executive"
    },
    "descriptions": {
      "agencyAdmin": "Create accounts and assing permissions",
      "agencyManager": "Review and manage ads created by sales",
      "agencyOperator": "Operate campaigns and provide performance report to client",
      "agencyAccount": "Create advertisers and assign agency to advertisers",
      "agencySales": "Create and manage advertiser's campaigns",
      "agencyReport": "Review order details and performance report only",
      "advertiserAdmin": "Have all the rights of the advertiser",
      "advertiserSales": "Create and manage ads",
      "advertiserReport": "View reports only",
      "reconciliationOfficer": "Reconciliation Personnel",
      "beaconAdmin": "System Admin",
      "beaconExecutive": "Focused on ad delivery and beacon maintenance, responsible for setting up push content."
    }
  },
  "appHeader": {
    "logout": "Log out",
    "changePassword": "Change password",
    "sudo": { "title": "Sudo" },
    "changeLanguage": {
      "message": "Changing the language will require a page refresh, are you sure you want to continue?"
    }
  },
  "login": {
    "form": {
      "title": "Login PerforMax",
      "placeholders": {
        "email": "Your email",
        "password": "Your password",
        "confirmPassword": "Confirm password again"
      },
      "buttons": { "login": "Login" }
    }
  },
  "agencies": {
    "home": {
      "title": "Agencies",
      "addAgency": "+ Agency",
      "searchPlaceholder": "Search Agency"
    },
    "status": { "all": "All", "active": "Active", "archived": "Archived" },
    "headers": {
      "id": "ID",
      "name": "Agency Name",
      "loginTitle": "Login Title",
      "loginDomain": "Login Domain",
      "oemAgency": "OEM Agency",
      "currency": "Currency",
      "timeZone": "Time Zone",
      "status": "Status"
    },
    "filter": {
      "statusFilter": "Agency Status",
      "statusTag": "Status",
      "statusFilterMenuTitle": "Select Status"
    },
    "noDataAvailable": "No matched agencies"
  },
  "accounts": {
    "home": {
      "searchPlaceholder": "Search Account",
      "title": "Account Setting",
      "addAccount": "+ Account"
    },
    "headers": {
      "email": "Email",
      "name": "Name",
      "status": "Status",
      "isAdmin": "Administrator",
      "companyName": "Agency",
      "company": "Company",
      "permission": "Permission",
      "pending": "Pending"
    },
    "tabs": { "agencies": "Agencies", "advertisers": "Advertisers" },
    "summary": {
      "title": "Account",
      "labels": {
        "email": "Email",
        "name": "Name",
        "status": "Status",
        "isAdmin": "Administrator",
        "edit": "Edit",
        "isPending": "Pending"
      }
    },
    "detail": { "title": "Account Detail" },
    "inactive": "Disable",
    "active": "Enable",
    "placeholder": {
      "noDataAvailable": "No available data",
      "pleaseSearch": "Please search for the account you want to transform"
    },
    "form": {
      "titles": {
        "new": "Add Account",
        "edit": "Edit Account",
        "permission": "Permission Setting"
      },
      "labels": {
        "email": "Email",
        "name": "Name",
        "currentPassword": "Current Password",
        "status": "Status",
        "activated": "Enable",
        "isAdmin": "Administrator",
        "account-email": "Account Email",
        "permission": "Permission",
        "agency": "Agency:",
        "role": "Account Role",
        "password": "New Password",
        "confirmPassword": "Confirm password again"
      },
      "messages": {
        "nameRequired": "Name is required",
        "emailRequired": "Email is required",
        "invalidEmail": "Invalid email address",
        "currentPasswordRequired": "Current Password is required",
        "passwordRequired": "Password is required",
        "confirmPasswordRequired": "Please confirm the password",
        "passwordNotMatched": "The passwords do not match"
      },
      "buttons": { "deletePermission": "Delete Permisssion" },
      "hints": {
        "assignRole": "<1>Note: </1>The user is not able to login before assigned as Agency or Advertiser roles."
      }
    },
    "labels": { "activate": "Activate", "deactivate": "Deactivate" },
    "messages": {
      "activateSuccess": "Activate Account Success",
      "deactivateSuccess": "Deactivate Account Success"
    }
  },
  "agencyDetail": {
    "archiveModal": {
      "content": "Archiving this agency will pause its running and pending campaigns and remove the roles of all its members. Are you sure you want to archive it?",
      "title": "Archive Agency"
    },
    "labels": {
      "editAgency": "Edit Agency",
      "otherSettingsTab": "Other Settings",
      "auditLogTab": "AuditLog",
      "adDeclarationTab": "Ad Declaration",
      "priceModelTab": "Price Model",
      "bidPriceSettingsTab": "Bid Price Setting",
      "adTypeTab": "Campaign type",
      "title": "Agency",
      "basicTab": "Basic",
      "addonFeatureTab": "Addon Features",
      "campaignTargetingTab": "Campaign Targeting",
      "memberTab": "Member",
      "adLogoTab": "Ad Logo"
    },
    "buttons": { "back": "Back", "edit": "Edit Agency" }
  },
  "serverResponse": {
    "400000": "Bad request",
    "400010": "Email already in use",
    "400013": "Please check your email's spam or junk folder for the email with a password reset link. You'll need to wait 24 hours before trying to reset your password again.",
    "400030": "Invalid operation of Agency",
    "400031": "Wrong value for agency",
    "400033": "This agency has been archived. Member roles cannot be added or changed.",
    "400050": "No enough credit",
    "400061": "Campaign is start and binding creative, can not delete",
    "400070": "Invaild argument of Creative",
    "400071": "Unsupported creative dimension",
    "400072": "Creative size large than 2M",
    "400073": "Creative content type is not allow",
    "400075": "OutDoor creatives contain illegal digital signature and video content, please reupload the video.",
    "400076": "Detected video codec is {{codec}}; this channel only accepts {{allowed}}",
    "400077": "The creative display size setting is invalid. Please ask a system administrator to check the sales channel settings.",
    "400080": "The data of creative review is incomplete",
    "400100": "File media type not support",
    "400106": "Account is disabled",
    "400120": "Campaign Group cannot delete if it has campaign",
    "400150": "Please enter an API token name",
    "400151": "API token name cannot exceed 50 characters",
    "400152": "Please select an expiration date",
    "400153": "Invalid expiration date format",
    "400154": "The expiration date must be later than today",
    "400155": "You have reached the limit of 10 tokens. Delete one first.",
    "400156": "API token not found. It may have been deleted.",
    "400157": "Invalid request format",
    "400600": "Invalid operation",
    "401000": "Unauthorized",
    "401010": "Account not login",
    "401500": "Function not authorized",
    "401900": "3thParty API authorize fail",
    "401950": "Yahoo API authorize fail",
    "401970": "Azure authentication fail",
    "402500": "No actor in used or using invalid actor",
    "403000": "Forbidden",
    "403010": "Account cannot access the resource",
    "403030": "This agency has been archived and is no longer available. You will be logged out.",
    "403150": "API tokens cannot be created or deleted while using Sudo.",
    "404000": "Cannot find the specified resource",
    "404010": "This account does not exist",
    "404012": "This account does not exist",
    "404020": "Company not found",
    "404030": "Agency not found",
    "404040": "Advertiser not found",
    "404050": "Order not found",
    "404060": "Campaign not found",
    "404062": "Campaign AdLogo not found",
    "404070": "Creative not found",
    "404090": "Segment Not Found",
    "404091": "Segment is not base segment",
    "404110": "Conversion type is not allow",
    "404111": "Conversion Not Found",
    "404120": "Campaign Group not found",
    "404600": "Resource not found",
    "405000": "Request method not allowed",
    "406010": "Account is disable",
    "408000": "Connection Time out",
    "408080": "Review connection fail",
    "409000": "Conflict",
    "409050": "Order external id duplicate",
    "500000": "Unknown Error",
    "500080": "Process Json Fail",
    "500081": "Process Url Fail",
    "500910": "An unknown PVMax error occurred",
    "500920": "IMax API login fail",
    "500921": "IMax API create segment fail",
    "500922": "IMax API create collector fail",
    "500923": "IMax API get code fail",
    "500951": "Yahoo API connection fail",
    "500952": "Yahoo Report fetch fail",
    "500960": "Google API connection fail",
    "500961": "Google Drive file not found",
    "500970": "Azure service connection fail",
    "500971": "Azure MediaService connection fail",
    "500980": "DMP create segment fail",
    "500981": "DMP update segment fail",
    "500982": "DMP delete segment fail",
    "500983": "DMP import segment fail",
    "500984": "DMP export segment fail",
    "500985": "DMP segment get code fail",
    "500986": "DMP segment get report fail",
    "500987": "Conversion get code fail",
    "4001605": "The brand name is invalid. Please check the content and try again.",
    "4001606": "The brand link is invalid. Please enter a valid URL starting with http:// or https://.",
    "4001607": "The map marker image must be in SVG or PNG format. Please upload it again.",
    "4001608": "The map marker image must be smaller than 200KB.",
    "4001609": "The map marker image (SVG) contains content that is not allowed, such as scripts or external links. Please remove it and upload again.",
    "4001700": "The format of the hardware ID is incorrect, please recheck the settings.",
    "4001701": "The format of the channel access token is incorrect, please recheck the settings."
  },
  "auditLog": {
    "company": {
      "archiveAgency": "Archive Agency",
      "restoreAgency": "Restore Agency",
      "createAgency": "Create Agency",
      "updateAgency": "Update Agency"
    },
    "headers": {
      "ctime": "Date",
      "srcID": "Operation Target",
      "email": "User Email",
      "funcType": "Event"
    },
    "adsOrder": {
      "create": "Create Order",
      "update": "Update Order",
      "approve": "Approve Order",
      "reject": "Reject Order"
    },
    "l1Object": { "create": "Create L1Object", "update": "Update L1Object" },
    "campaign": {
      "create": "Create Campaign",
      "update": "Update Campaign",
      "delete": "Delete Campaign",
      "activate": "Activate Campaign",
      "deactivate": "Deactivate Campaign",
      "saveCampaign": "Save Campaign",
      "bindCreatives": "Bind Creatives",
      "bindedCreatives": {
        "activate": "Activate Creatives",
        "deactivate": "Deactivate Creatives"
      },
      "split": "Split Campaign",
      "paused": "Campaign Deactivated"
    },
    "agency": { "updateRebateRate": "Update Rebate Rate" },
    "companyRoleMap": {
      "createAgencyRole": "Create Agency Role",
      "updateAgencyRole": "Update Agency Role",
      "suspendAgencyRole": "Suspend Agency Role",
      "agencyArchivedSuspendAgencyRole": "Suspend Agency Role (Agency Archived)"
    },
    "labels": {
      "srcAdsOrder": "Order",
      "srcL1Object": "L1 Object",
      "srcCampaign": "Campaign",
      "srcAdAgency": "Agency",
      "srcCompanyRoleMap": "Role",
      "from": "From",
      "to": "To",
      "l1ObjectFilterTitle": "L1 Object",
      "campaignFilterTitle": "Campaign",
      "frequencyNoEnable": "No items allowed",
      "fieldFilterTitle": "Field",
      "autoOptimise": "CBO",
      "channel": "Channel",
      "l1ChannelId": "L1 Channel ID",
      "l1ObjectLifetimeBudget": "Budget",
      "dealIds": "Deal ID",
      "frequency": "Frequency Setting",
      "viewTrackingCodes": "Third-Party Tracking",
      "adType": "AdType",
      "bidPrice": "Price Cap",
      "camName": "Campaign Name",
      "convTrackEvent": "Convertion Mode",
      "deliverType": "Deliver Type",
      "endDate": "End Date",
      "id": "ID",
      "optimize": "Optimize Mode",
      "planType": "Price Model",
      "startDate": "Start Date",
      "tags": "Tags",
      "targetBudget": "Budget",
      "dayPart": "Daypart Setting",
      "advertiserId": "Advertiser ID",
      "budget": "Order Budget",
      "orderMargin": "Agency Margin",
      "projectName": "Order Name",
      "agcPercent": "Agency Margin",
      "sysPercent": "System Margin",
      "state": "Status",
      "spentCheckpoints": "Check Point",
      "currencyRate": "Exchange Rate",
      "selfBuyOnly": "Self Buy",
      "bindCreatives": "Bind Creatives",
      "stopping": "Campaign Stopping",
      "dailyTargetBudget": "Daily Target Budget",
      "videoProgressTrackingCode": "Retarget Tracking",
      "adLogo": "Ad Logo",
      "conversionTracking": "Tracking Data",
      "orderPrice": "Order Price",
      "videoAdViewObjective": "Video Ad Objective",
      "externalId": "External ID",
      "checkpoints": "Check Points",
      "expectedSpent": "Expected Spent",
      "daterange": "Date Range",
      "dealID": "Deal ID",
      "creativeDeliverType": "Creative Deliver Type",
      "changeBudget": "Pending Budget",
      "changeOrderMargin": "Pending Order Margin",
      "modifyReason": "Modify Reason",
      "ageMin": "Min Age",
      "ageMax": "Max Age",
      "gender": "Gender",
      "creativeDuration": "Creative Duration",
      "finalReportTargetType": "Target Type",
      "finalReportTargetValue": "Target Value",
      "finalReportAdvertiserName": "Advertiser Name",
      "targetImpressions": "Target Impressions",
      "goGanGroupId": "Camapign Group ID",
      "orderNumber": "Order Number",
      "outdoorDeliverType": "Outdoor Deliver Type",
      "adminBidPrice": "Bid Price Setting",
      "Magnification": "Weight",
      "compositePixelWidth": "Actual display width",
      "compositePixelHeight": "Actual display height",
      "clicks": "Clicks",
      "impres": "Impression",
      "lastHourOlapActualSpent": "Last Hour Spent",
      "olapActualSpent": "Actual Spent",
      "olapExpectedSpent": "Expected Spent",
      "olapExpectSpent": "Expected Spent",
      "spent": "Spent",
      "uniqueUser": "Unique User",
      "viewable": "Viewable Impression",
      "priceModel": "Price Model",
      "spents": "Spent",
      "isMonitorEnable": "Monitor behind progress campaigns",
      "name": "Name",
      "createDate": "Create Date",
      "campaignId": "Campaign ID",
      "uniqueUsers": "Unique User",
      "orderId": "Order ID",
      "agencyId": "Agency ID",
      "bidPriceMin": "Minimum Bid Price",
      "campaignConstraint": "Campaign Constraint",
      "externalType": "External Type",
      "timezone": "Timezone",
      "comments": "Comments",
      "currency": "Currency",
      "monitorEnable": "Monitor behind progress campaigns",
      "rebateRate": "Rebate Rate",
      "companyId": "Company ID",
      "companyName": "Company Name",
      "comComment": "Notes",
      "language": "Language",
      "loginEmail": "Login Email",
      "loginDomain": "Login Domain",
      "sysPercentIn": "Internal Margin",
      "sysPercentOut": "External Margin",
      "maxOrderProfit": "Max Agency Margin",
      "taxPercent": "Tax",
      "providerId": "Provider ID",
      "oem": "OEM Agency",
      "logoUrl": "Logo",
      "priority": "Priority",
      "limitPublisher": "Publisher ID",
      "limitPublisherCountry": "Publisher Country",
      "limitAdx": "Ad Exchange",
      "defaultCountry": "Country",
      "defaultSpace": "Space",
      "segmentCountry": "Segment Country",
      "segmentLabel": "Segment Label",
      "defaultCountryOp": "Country Op",
      "defaultSpaceOp": "Space Op",
      "limitAdxOp": "Ad Exchange Op",
      "interstitial": "Allow Interstitail",
      "credit": "Credit",
      "noLimitSelfBuyStatus": "Not Limited SelfBuy Inventory",
      "selfBuy": "Self Buy",
      "timeZone": "Time Zone",
      "roleName": "Role",
      "account": "Account",
      "agencyID": "auditLog.labels.agencyID",
      "rate": "Future Rebate Rate",
      "effectDate": "Future Rebate Effect date",
      "effectiveArchived": "Channel Deactivation Status",
      "pmaxArchiveReason": "PMax Deactivation Reason",
      "pmaxArchived": "PMax Deactivation Status",
      "rmaxArchiveReason": "RMax Deactivation Reason",
      "srcChannelGroup": "Channel Group",
      "channelGroupStatus": "RMax Channel Group Status",
      "channelGroupId": "Channel Group ID",
      "channelGroupType": "Channel Group Type",
      "campaignAdTypeSettings": "Ad Type Settings",
      "reportIgnoredDV360Items": "DV360 Items Excluded from Report",
      "campaignBidPrice": "Bid Price Settings",
      "screenPixelWidth": "Screen Width (px)",
      "screenPixelHeight": "Screen Height (px)",
      "alertEmails": "Alert Emails"
    },
    "placeholders": {
      "l1ObjectFilter": "Please select a l1 object to check",
      "campaignFilter": "Please select a campaign to check",
      "fieldFilter": "Please select a field to check"
    },
    "limitation": { "create": "Save Limitation" },
    "channelGroup": {
      "pmaxArchive": "Deactivate Channel Group",
      "pmaxUnarchive": "Reactivate Channel Group",
      "update": "Update Channel Group"
    }
  },
  "appMenus": {
    "report": {
      "title": "Report",
      "items": {
        "performance": "Performance Report",
        "dataMarketplace": "Data Marketplace",
        "video": "Video Performance",
        "campaignDashboard": "Campaign Dashboard",
        "reconciliation": "Agency Revenue Report",
        "credit": "Credit Info",
        "storedValue": "Stored Value",
        "salesChannelReconciliation": "Sales Channel Reconciliation"
      }
    },
    "comapnyManagement": {
      "title": "Company",
      "items": {
        "agencies": "Agencies",
        "advertisers": "Advertisers",
        "accounts": "Accounts",
        "newAccount": "Create Account",
        "oemAccounts": "Oem Accounts",
        "pmp": "PMP Order"
      }
    },
    "system": {
      "title": "System",
      "items": {
        "productGroups": "Product Groups",
        "roles": "Roles",
        "currencyRate": "Exchange Rate",
        "auditLog": "Audit Log",
        "channelGroups": "Channel Groups Management",
        "streamingStatus": "Streaming Status"
      }
    },
    "ads": {
      "title": "Advertisement",
      "items": {
        "orders": "Orders & Campaigns",
        "creatives": "Creative",
        "creativeTemplates": "Creative Studio",
        "conversion": "Conversion Tracking"
      }
    },
    "data": {
      "title": "Data",
      "items": {
        "audienceSegments": "Audience Segment",
        "marketplace": "Data Marketplace",
        "tenmaxSegments": "TenMax Segment",
        "customLayouts": "Custom Layout",
        "deviceManagement": "Device Management"
      }
    },
    "eCommerce": {
      "title": "e-Commerce",
      "items": {
        "products": "Product Feed",
        "conversion": "Sales Funnel",
        "events": "Event Logs",
        "strategies": "Programmatic Strategy"
      }
    },
    "other": {
      "title": "Other",
      "items": {
        "doctor": "Check delivery restrictions",
        "outdoorMonitor": "Outdoor Traffic Monitor"
      }
    },
    "beaconComapnyManagement": {
      "title": "Beacon Management",
      "items": { "merchants": "Official Account", "restaurants": "Merchant" }
    },
    "beaconMessageManagement": {
      "title": "Beacon Message Management",
      "items": { "beaconMessages": "Beacon Message Setting" }
    },
    "announcement": {
      "title": "Announcements",
      "items": { "siteAnnouncement": "Site Announcement" }
    },
    "apiIntegration": {
      "items": { "apiDocs": "API Docs", "apiTokens": "API Token" },
      "title": "API Integration"
    }
  },
  "agency": {
    "companyAttribute": "Company Attribute",
    "currentRebateRate": "Current rebate rate",
    "futureEffectDate": "Effect date",
    "futureRebateRate": "Future rebate rate",
    "id": "Agency ID",
    "companyName": "Company Name",
    "language": "Language",
    "currency": "Currency",
    "timeZone": "Time Zone",
    "targetBudgetMinimum": "Target Budget Minimum",
    "taxPercent": "Tax",
    "priority": "Priority",
    "limitPublisherCountryStr": "Publisher Country",
    "selfBuy": "Self Buy",
    "limitPublisherStr": "Publisher ID",
    "noLimitSelfBuyStatus": "Not Limited SelfBuy Inventory",
    "limitAdxStr": "Ad Exchange",
    "defaultCountryStr": "Country",
    "defaultSpaceStr": "Space",
    "segmentCountryStr": "Segment Country",
    "segmentLabelStr": "Segment Label",
    "campaignBudgetMinimum": "Campaign Budget Minimum",
    "interstitial": "Allow Interstitail",
    "comComment": "Notes",
    "sysPercentIn": "Internal Margin",
    "sysPercentOut": "External Margin",
    "margin": "Margin",
    "information": "Agency Infomation",
    "marginSetting": "Margin Setting",
    "agcPercent": "Default Agency Margin",
    "logo": "Logo",
    "yes": "Yes",
    "no": "No",
    "form": {
      "titles": {
        "new": "Create Agency",
        "edit": "Edit Agency",
        "deliverySetting": "Delivery Setting",
        "rtbDeliverySetting": "RTB Delivery Setting",
        "generalDeliverySetting": "General Delivery Setting"
      }
    },
    "member": {
      "addMember": "+ Member",
      "addAccount": "+ Account",
      "headers": {
        "index": "No.",
        "email": "Email",
        "name": "Name",
        "status": "Status",
        "permission": "Permission"
      },
      "active": "Enable",
      "inactive": "Disable",
      "permissions": {
        "AGENCY_ADMIN": "Agency Admin",
        "AGENCY_MANAGER": "Agency Manager",
        "AGENCY_OPERATOR": "Agency Operator",
        "AGENCY_SALES": "Agency Sales",
        "AGENCY_REPORT": "Agency Report",
        "BEACON_EXECUTIVE": "Beacon Executive"
      },
      "noDataAvailable": "No data, let ’s add a new member"
    },
    "addonProps": { "maxOrderProfit": "Max Agency Margin" },
    "addonGroup": {
      "channel": "Channels & Delivery",
      "creatives": "Creative Types",
      "company": "Company",
      "adsOrder": "Order Type",
      "order": "Order Type",
      "campaign": "Campaign",
      "creative-studio": "Creative Studio",
      "conversiontracking": "Conversion Tracking",
      "report": "Report",
      "monitor": "Monitor",
      "campaignLimitation": "Campaign Limitation",
      "creativeLimitation": "Creative Targeting",
      "reconciliationAndBudget": "Reconciliation Reports & Order Budget Control",
      "creativeReview": "Creative Approval Management",
      "adTypes": "Ad Types",
      "alertMail": "Alert Notification Emails"
    },
    "addonItem": {
      "channel": {
        "openRTB": "OpenRTB",
        "pic": "PIC Outdoor",
        "salesChannelMargin": "Agency Margin",
        "fridge": "WI Fridge",
        "matsukiyo": "Retail Beacon Network",
        "hwacom": "HwaCom",
        "salesChannelExpressPass": "Can the creatives use the express pass?"
      },
      "creatives": {
        "option_image": "Image Ads",
        "option_html5": "HTML Ads",
        "option_native": "Native Ads",
        "option_video": "Video Ads",
        "option_dynamic": "Dynamic Ads",
        "option_flash": "Flash Ads",
        "option_thirdParty": "Third Party Ads",
        "option_combo": "Video + Image Ads",
        "option_oneForAll": "One For All Ads",
        "option_oneForAllDisplay": "One For All Display Ads",
        "option_oneForAllVideo": "One For All Video Ads",
        "option_ctv": "CTV Ads",
        "option_customRectangle": "Custom Rectangle Ads",
        "option_customBottom": "Custom Bottom Ads",
        "option_edimax": "EdiMax Outdoor Ads",
        "option_picShort": "PIC Outdoor 15s Ads",
        "option_picLong": "PIC Outdoor 30s Ads",
        "option_picExtended": "PIC Outdoor 60s Ads",
        "option_picBroad": "PIC Outdoor 60+s Ads",
        "option_fridgeBroad": "WI Fridge 60+s Ads",
        "option_fridgeLong": "WI Fridge 30s Ads",
        "option_fridgeExtended": "WI Fridge 60s Ads",
        "option_outdoorLineMessage": "Outdoor Line Message Ads",
        "option_lineMessage": "Line Message Ads",
        "option_sandboxOutdoor": "Sandbox Outdoor Ads",
        "option_hwacomShort": "HwaCom 15s Ads",
        "option_hwacomLong": "HwaCom 30s Ads",
        "option_hwacomExtended": "HwaCom 60s Ads",
        "option_hwacomBroad": "HwaCom 60+s Ads",
        "adType_one_for_all_display": "One For All Display Ad",
        "adType_display": "Display Ad",
        "adType_third_party": "Third Party Ads",
        "adType_third_party_bottom": "Mobile Footer Ads",
        "adType_third_party_rectangle": "Medium Rectangle Ads",
        "adType_video": "Video Ad",
        "adType_combo": "Video + Image Ad",
        "adType_ctv": "CTV Ads",
        "adType_keyword": "Keyword Ads",
        "adType_pic_short": "PIC Outdoor 15s Ads",
        "adType_pic_long": "PIC Outdoor 30s Ads",
        "adType_pic_extended": "PIC Outdoor 60s Ads",
        "adType_pic_broad": "PIC Outdoor 60+s Ads",
        "adType_fridge_broad": "WI Fridge 60+s Ads",
        "adType_fridge_long": "WI Fridge 30s Ads",
        "adType_fridge_extended": "WI Fridge 60s Ads",
        "adType_pmp_pic": "PMP PIC Outdoor Ads",
        "adType_pmp_fridge": "PMP WI Fridge Ads",
        "adType_sandbox_outdoor": "Sandbox Outdoor Ad",
        "adType_outdoor_line_message": "Outdoor Line Message Ads",
        "adType_line_message": "Line Message Ads",
        "adType_sandbox_movable_outdoor": "Sandbox Movable Outdoor Ad",
        "adType_hwacom_short": "HwaCom 15s Ads",
        "adType_hwacom_long": "HwaCom 30s Ads",
        "adType_hwacom_extended": "HwaCom 60s Ads",
        "adType_hwacom_broad": "HwaCom 60+s Ads",
        "landingPage": "Landing Page",
        "customizeAdLogo": "Custom AD Logo"
      },
      "order": { "showOrderExternalType": "External order type list" },
      "company": {
        "agencyProfit": "Agency Margin Setting",
        "rebate": "Rebate",
        "incentive": "Incentive",
        "provideReportToWorkflow": "Agency Revenue Report",
        "singleOrderBudgetConstraint": "Order Budget Limit",
        "productGroup": "Product Group",
        "orderBudgetMaximum": "Maximum",
        "useAgencyProfitOnRebateReport": "Use agency margin on rebate report",
        "showOutComeOnRebateReport": "Show out come on rebate report",
        "creditLimit": "Credit Limit",
        "creditLimitMaximum": "Credit Limit Maximum",
        "allowOrderSettlement": "Allow order settlement",
        "allowOrderAutoSettlement": "Allow order auto settlement",
        "modifyOrderBudgetAfterSettlement": "Allow modify order budget when settling",
        "fixedExchangeRate": "Using a fixed exchange rate to create Ads order",
        "ExchangeRate": "Exchange Rate",
        "showOrderExternalType": "Show external type list in order create and edit page",
        "advertiserViewSpentInReport": "Advertiser View Spent In Report Page",
        "lookalikeAudienceCreation": "Allow to Create Lookalike Audience",
        "allowBidPriceMoreThenContractPrice": "Allow bid pirce more than contract price",
        "outdoorAgency": "Outdoor Agency",
        "outdoorMachineCount": "Outdoor Machine Count",
        "storedValue": "Stored Value",
        "advAdminInfoRestriction": "Advertiser Admin is restricted to check individual information only",
        "directlyApproveCreative": "Allow RMax reviewing creative is directly approved",
        "agencySegment": "Use Agency Segment",
        "agencySegmentLimitationName": "Agency Segment Limitation Title"
      },
      "dependenceHint": "Must depend on: {{addon}}",
      "campaign": {
        "bid_weight_setting": "Bid Weight Setting",
        "admin_bid_price_setting": "Bid Price Setting",
        "orderAgcProfitSetting": "Config agency margin when create an order",
        "bidPriceMin": "Minimum {{type}} bid price",
        "enableOptimizedPrice": "Enable optimized price",
        "revenueSharing": "can use revenue sharing pricing model for campaign",
        "budgetDominate": "Can use Daily Budget",
        "roadblock": "RoadBlock",
        "videoAdViewObjective": "Video Ad View Objective",
        "thirdparty_tracking": "Third-Party Tracking",
        "retargeting_tracker": "Retargeting Tracker",
        "ignoreVideoAdViewConstraint": "Ignore View Percentage",
        "fix_cpc": "can use fixed CPC pricing model for campaign",
        "fix_cpm": "can use fixed CPM pricing model for campaign",
        "fix_cpv": "can use fixed CPV pricing model for campaign",
        "fix_vcpm": "can use fixed vCPM pricing model for campaign",
        "fix_acpm": "can use fixed aCPM pricing model for campaign",
        "fix_wcpm": "can use fixed wCPM pricing model for campaign",
        "bidPriceConstraint": "Constraint of bid price",
        "dynamic_cpm": "can use dynamic CPM pricing model for campaign",
        "frequencyCapping": "Can use frequency capping"
      },
      "creative-studio": { "creative-studio": "Creative Studio" },
      "product": { "index": "Product Feed" },
      "conversiontracking": { "TrackingList": "Conversion Tracking" },
      "report": {
        "viewableCtr": "Use Viewable Impression Calculate",
        "campaign_dashboard": "Campaign Dashboard",
        "booking_calendar": "Native Ad Booking Calendar",
        "yahooAd": "Verizon Report Sync",
        "closingReport": "Closing Report",
        "restrictFinalReport": "Close Final Report",
        "campaignDashboard": "Campaign Dashboard",
        "bookingCalendar": "Ad Schedule",
        "orderCustom": "Custom Order Report",
        "cantDownloadOutdoorFinalReport": "Outdoor Final Report",
        "deliveryBriefReport": "Delivery Data Brief Report"
      },
      "monitor": {
        "campaignUnderBidFloor": "Monitor Under bid floor campaigns",
        "campaignBehindProgress": "Monitor behind progress campaigns"
      },
      "creativeLimitation": {
        "country": "Country",
        "spaceType": "Space Type",
        "device": "Device",
        "target_audience": "Audience Segment",
        "habits": "Consumer Habits",
        "adexchange": "Ad Exchange",
        "asiamax_space": "Asiamax Space",
        "domain": "Domain",
        "space_category": "Website Category",
        "tenmax_audience": "TenMax Segment",
        "city": "City",
        "gender": "Gender",
        "age": "Age",
        "carrier": "Carrier",
        "enablePMPDeal": "PMP Deal",
        "keyword": "Keyword",
        "unicornkeywords": "Unicorn Keyword",
        "content_language": "Content Language",
        "content_category": "Content Category"
      },
      "campaignLimitation": {
        "country": "Country",
        "spaceType": "Space Type",
        "device": "Device",
        "target_audience": "Audience Segment",
        "habits": "Consumer Habits",
        "adexchange": "Ad Exchange",
        "asiamax_space": "Asiamax Space",
        "domain": "Domain",
        "space_category": "Website Category",
        "tenmax_audience": "TenMax Segment",
        "city": "City",
        "gender": "Gender",
        "age": "Age",
        "carrier": "Carrier",
        "enablePMPDeal": "PMP Deal",
        "testMode": "Test Mode",
        "keyword": "Keyword",
        "unicornkeywords": "Unicorn Keyword",
        "content_language": "Content Language",
        "content_category": "Content Category",
        "storeNum": "Stores Information",
        "cityGroup": "Location",
        "administrativeArea": "District",
        "outdoorPlaceCategories": "Local Feature",
        "deviceCharacteristic": "Device Information",
        "systemRecommendOutdoorDevice": "System Recommendations"
      },
      "alertMail": {
        "creativeReview": "Creative review result notification",
        "campaignNoCreative": "Alert: campaign has no available creative bound",
        "orderNoCampaign": "Alert: order starting soon with no campaign set up",
        "orderBudgetRemain": "Alert: order ending soon with campaign budget remaining",
        "orderBudgetUnspent": "Alert: campaign ended with unspent budget while order is still running"
      }
    },
    "placeholders": {
      "addon": "Please enable the corresponding {{parent}} before you can set {{child}}."
    },
    "currentRate": "Current Rebate Rate",
    "effectDate": "Future Rebate Effect date",
    "futureRate": "Future Rebate Rate",
    "rebateRate": "Rebate Setting",
    "gogan": {
      "targetBudgetMinimum": "Campaign Budget Minimum Per Day",
      "addonItem": {
        "campaignLimitation": { "target_audience": "Custom Audience Segment" }
      },
      "addonGroup": { "campaignLimitation": "RTB Campaign Limitation" }
    },
    "labels": {
      "role_agency_admin": "Agency Admin - create accounts and assing permissions",
      "role_agency_operator": "Agency Operator - operate campaigns and provide performance report to client",
      "role_agency_manager": "Agency AM Manager - review and manage ads created by sales",
      "role_agency_sales": "Agency AE Manager - create and manage advertiser's campaigns",
      "role_agency_report": "Agency Report - review order details and performance report only"
    }
  },
  "geography": {
    "country": {
      "vnm": "Vietnam",
      "twn": "Taiwan",
      "usa": "United States",
      "tha": "Thailand",
      "can": "Canada",
      "sgp": "Singapore",
      "mys": "Malaysia",
      "hkg": "Hong Kong",
      "kor": "Korea",
      "jpn": "Japan",
      "idn": "Indonesia",
      "chn": "China",
      "phl": "Philippines"
    },
    "region": {
      "twn": {
        "changhua": "Changhua",
        "chiayi": "Chiayi",
        "chiayi_county": "Chiayi County",
        "hsinchu": "Hsinchu",
        "hsinchu_county": "Hsinchu County",
        "hualien": "Hualien",
        "kaohsiung": "Kaohsiung",
        "keelung": "Keelung",
        "miaoli": "Miaoli",
        "nantou": "Nantou",
        "new_taipei": "New Taipei",
        "penghu": "Penghu",
        "pingtung": "Pingtung",
        "taichung_city": "Taichung City",
        "tainan": "Tainan",
        "taipei_city": "Taipei City",
        "taitung": "Taitung",
        "taoyuan": "Taoyuan",
        "yilan": "Yilan",
        "yunlin_county": "Yunlin County"
      },
      "vnm": {
        "an_giang": "An Giang",
        "dak_nong": "Dak Nong",
        "gia_lai": "Gia Lai",
        "hau_giang": "Hau Giang",
        "ho_chi_minh_city": "Ho Chi Minh City",
        "kon_tum": "Kon Tum",
        "long_an": "Long An",
        "thanh_pho_can_tho": "Thanh Pho Can Tho",
        "thanh_pho_gja_nang": "Thanh Pho GJa Nang",
        "thanh_pho_ha_noi": "Thanh Pho Ha Noi",
        "thanh_pho_hai_phong": "Thanh Pho Hai Phong",
        "tinh_ba_ria-vung_tau": "Tinh Ba Ria-Vung Tau",
        "tinh_bac_giang": "Tinh Bac Giang",
        "tinh_bac_kan": "Tinh Bac Kan",
        "tinh_bac_lieu": "Tinh Bac Lieu",
        "tinh_bac_ninh": "Tinh Bac Ninh",
        "tinh_ben_tre": "Tinh Ben Tre",
        "tinh_binh_duong": "Tinh Binh Duong",
        "tinh_binh_gjinh": "Tinh Binh GJinh",
        "tinh_binh_phuoc": "Tinh Binh Phuoc",
        "tinh_binh_thuan": "Tinh Binh Thuan",
        "tinh_ca_mau": "Tinh Ca Mau",
        "tinh_cao_bang": "Tinh Cao Bang",
        "tinh_dien_bien": "Tinh Dien Bien",
        "tinh_gjak_lak": "Tinh GJak Lak",
        "tinh_gjong_nai": "Tinh GJong Nai",
        "tinh_gjong_thap": "Tinh GJong Thap",
        "tinh_ha_giang": "Tinh Ha Giang",
        "tinh_ha_nam": "Tinh Ha Nam",
        "tinh_ha_tinh": "Tinh Ha Tinh",
        "tinh_hai_duong": "Tinh Hai Duong",
        "tinh_hoa_binh": "Tinh Hoa Binh",
        "tinh_hung_yen": "Tinh Hung Yen",
        "tinh_khanh_hoa": "Tinh Khanh Hoa",
        "tinh_kien_giang": "Tinh Kien Giang",
        "tinh_lai_chau": "Tinh Lai Chau",
        "tinh_lam_gjong": "Tinh Lam GJong",
        "tinh_lang_son": "Tinh Lang Son",
        "tinh_lao_cai": "Tinh Lao Cai",
        "tinh_nam_gjinh": "Tinh Nam GJinh",
        "tinh_nghe_an": "Tinh Nghe An",
        "tinh_ninh_binh": "Tinh Ninh Binh",
        "tinh_ninh_thuan": "Tinh Ninh Thuan",
        "tinh_phu_tho": "Tinh Phu Tho",
        "tinh_phu_yen": "Tinh Phu Yen",
        "tinh_quang_binh": "Tinh Quang Binh",
        "tinh_quang_nam": "Tinh Quang Nam",
        "tinh_quang_ngai": "Tinh Quang Ngai",
        "tinh_quang_ninh": "Tinh Quang Ninh",
        "tinh_quang_tri": "Tinh Quang Tri",
        "tinh_soc_trang": "Tinh Soc Trang",
        "tinh_son_la": "Tinh Son La",
        "tinh_tay_ninh": "Tinh Tay Ninh",
        "tinh_thai_binh": "Tinh Thai Binh",
        "tinh_thai_nguyen": "Tinh Thai Nguyen",
        "tinh_thanh_hoa": "Tinh Thanh Hoa",
        "tinh_thua_thien-hue": "Tinh Thua Thien-Hue",
        "tinh_tien_giang": "Tinh Tien Giang",
        "tinh_tra_vinh": "Tinh Tra Vinh",
        "tinh_tuyen_quang": "Tinh Tuyen Quang",
        "tinh_vinh_long": "Tinh Vinh Long",
        "tinh_vinh_phuc": "Tinh Vinh Phuc",
        "tinh_yen_bai": "Tinh Yen Bai",
        "thanh_pho_da_nang": "Thanh Pho Da Nang"
      },
      "mys": {
        "johor": "Johor",
        "kedah": "Kedah",
        "kelantan": "Kelantan",
        "kuala_lumpur": "Kuala Lumpur",
        "labuan": "Labuan",
        "melaka": "Melaka",
        "negeri_sembilan": "Negeri Sembilan",
        "pahang": "Pahang",
        "penang": "Penang",
        "perak": "Perak",
        "perlis": "Perlis",
        "putrajaya": "Putrajaya",
        "sabah": "Sabah",
        "sarawak": "Sarawak",
        "selangor": "Selangor",
        "terengganu": "Terengganu"
      },
      "jpn": {
        "aichi": "Aichi",
        "akita": "Akita",
        "aomori": "Aomori",
        "chiba": "Chiba",
        "ehime": "Ehime",
        "fukui": "Fukui",
        "fukuoka": "Fukuoka",
        "fukushima-ken": "Fukushima-ken",
        "gifu": "Gifu",
        "gunma": "Gunma",
        "hiroshima": "Hiroshima",
        "hokkaido": "Hokkaido",
        "hyōgo": "Hyōgo",
        "ibaraki": "Ibaraki",
        "ishikawa": "Ishikawa",
        "iwate": "Iwate",
        "kagawa": "Kagawa",
        "kagoshima": "Kagoshima",
        "kanagawa": "Kanagawa",
        "kochi": "Kochi",
        "kumamoto": "Kumamoto",
        "kyoto": "Kyoto",
        "mie": "Mie",
        "miyagi": "Miyagi",
        "miyazaki": "Miyazaki",
        "nagano": "Nagano",
        "nagasaki": "Nagasaki",
        "nara": "Nara",
        "niigata": "Niigata",
        "oita": "Oita",
        "okayama": "Okayama",
        "okinawa": "Okinawa",
        "Ōsaka": "Ōsaka",
        "saga": "Saga",
        "saitama": "Saitama",
        "shiga": "Shiga",
        "shimane": "Shimane",
        "shizuoka": "Shizuoka",
        "tochigi": "Tochigi",
        "tokushima": "Tokushima",
        "tokyo": "Tokyo",
        "tottori": "Tottori",
        "toyama": "Toyama",
        "wakayama": "Wakayama",
        "yamagata": "Yamagata",
        "yamaguchi": "Yamaguchi",
        "yamanashi": "Yamanashi"
      },
      "armm": "ARMM",
      "bicol": "Bicol",
      "cagayan_valley": "Cagayan Valley",
      "calabarzon": "Calabarzon",
      "caraga": "Caraga",
      "central_luzon": "Central Luzon",
      "central_visayas": "Central Visayas",
      "cordillera": "Cordillera",
      "davao": "Davao",
      "eastern_visayas": "Eastern Visayas",
      "ilocos": "Ilocos",
      "mimaropa": "Mimaropa",
      "national_capital_region": "National Capital Region",
      "northern_mindanao": "Northern Mindanao",
      "province_of_negros_occidental": "Province of Negros Occidental",
      "province_of_negros_oriental": "Province of Negros Oriental",
      "soccsksargen": "Soccsksargen",
      "western_visayas": "Western Visayas",
      "zamboanga_peninsula": "Zamboanga Peninsula",
      "idn": {
        "aceh": {
          "banda_aceh": "Banda Aceh",
          "bireun": "Bireun",
          "langsa": "Langsa",
          "lhokseumawe": "Lhokseumawe",
          "pasir": "Pasir",
          "pondok": "Pondok",
          "sigli": "Sigli",
          "tanjung_balai": "Tanjung Balai"
        },
        "bali": {
          "badung": "Badung",
          "bangli": "Bangli",
          "banjar_asem": "Banjar Asem",
          "candi_dasa": "Candi Dasa",
          "canggu": "Canggu",
          "denpasar": "Denpasar",
          "gianyar": "Gianyar",
          "karangasem": "Karangasem",
          "kartika": "Kartika",
          "kecamatan_buleleng": "Kecamatan Buleleng",
          "kedunganan": "Kedunganan",
          "kerobokan": "Kerobokan",
          "klungkung": "Klungkung",
          "padang": "Padang",
          "padangsambian": "Padangsambian",
          "sanur": "Sanur",
          "seminyak_town": "Seminyak town",
          "singaraja": "Singaraja",
          "tabanan": "Tabanan",
          "ubud": "Ubud"
        },
        "bangka–belitung_islands": {
          "kotawaringin": "Kotawaringin",
          "pangkalpinang": "Pangkalpinang"
        },
        "banten": {
          "baratjaya": "Baratjaya",
          "cakung": "Cakung",
          "cibubur": "Cibubur",
          "cilegon": "Cilegon",
          "cipare": "Cipare",
          "kramatwatu": "Kramatwatu",
          "pandeglang": "Pandeglang",
          "pasir": "Pasir",
          "rangkasbitung": "Rangkasbitung",
          "serang": "Serang",
          "tangerang": "Tangerang"
        },
        "bengkulu": { "bengkulu": "Bengkulu" },
        "central_java": {
          "adiwarno": "Adiwarno",
          "asinan": "Asinan",
          "badran": "Badran",
          "bandung": "Bandung",
          "bandungrejo": "Bandungrejo",
          "bangkok": "Bangkok",
          "bangkong": "Bangkong",
          "banguntapan": "Banguntapan",
          "banjarnegara": "Banjarnegara",
          "bantarwuni": "Bantarwuni",
          "banyuasin": "Banyuasin",
          "banyumas": "Banyumas",
          "banyuurip": "Banyuurip",
          "baru": "Baru",
          "beji": "Beji",
          "bintaro": "Bintaro",
          "blora": "Blora",
          "blorong": "Blorong",
          "bojongsalaman": "Bojongsalaman",
          "boyolali": "Boyolali",
          "brebes": "Brebes",
          "bringin": "Bringin",
          "bulupayung": "Bulupayung",
          "buniayu": "Buniayu",
          "cilacap": "Cilacap",
          "comal": "Comal",
          "demak": "Demak",
          "donoharjo": "Donoharjo",
          "duren": "Duren",
          "gajahan": "Gajahan",
          "grobogan": "Grobogan",
          "grogol": "Grogol",
          "jati": "Jati",
          "jepara": "Jepara",
          "kalimantan": "Kalimantan",
          "karanganyar": "Karanganyar",
          "kartasura": "Kartasura",
          "kebon": "Kebon",
          "kebumen": "Kebumen",
          "kendal": "Kendal",
          "klaten": "Klaten",
          "kudus": "Kudus",
          "kuta": "Kuta",
          "lebak": "Lebak",
          "magelang": "Magelang",
          "malang": "Malang",
          "manggung": "Manggung",
          "menteng": "Menteng",
          "mungkid": "Mungkid",
          "pati": "Pati",
          "pekalongan": "Pekalongan",
          "pemalang": "Pemalang",
          "plalangan": "Plalangan",
          "purbalingga": "Purbalingga",
          "purwodadi_grobogan": "Purwodadi Grobogan",
          "purwokerto": "Purwokerto",
          "purworejo": "Purworejo",
          "salatiga": "Salatiga",
          "sawahbesar": "Sawahbesar",
          "sedayu": "Sedayu",
          "semarang": "Semarang",
          "slawi": "Slawi",
          "sragen": "Sragen",
          "sukoharjo": "Sukoharjo",
          "surakarta": "Surakarta",
          "tegal": "Tegal",
          "tlogosari": "Tlogosari",
          "umbulharjo": "Umbulharjo",
          "ungaran": "Ungaran",
          "weleri": "Weleri",
          "wonogiri": "Wonogiri",
          "wonosobo": "Wonosobo"
        },
        "central_kalimantan": {
          "lampeong": "Lampeong",
          "palangkaraya": "Palangkaraya",
          "sampit": "Sampit"
        },
        "central_sulawesi": {
          "palu": "Palu",
          "pengawu": "Pengawu",
          "tolitoli": "Tolitoli"
        },
        "east_java": {
          "alassumur": "Alassumur",
          "andongrejo": "Andongrejo",
          "ardirejo": "Ardirejo",
          "argosari": "Argosari",
          "babat": "Babat",
          "bacem": "Bacem",
          "badal": "Badal",
          "bajang": "Bajang",
          "bajulan": "Bajulan",
          "bakalan": "Bakalan",
          "baleturi": "Baleturi",
          "balongdowo": "Balongdowo",
          "balung": "Balung",
          "bandulan": "Bandulan",
          "bandung_barat": "Bandung Barat",
          "bangil": "Bangil",
          "bangkal": "Bangkal",
          "bangkalan": "Bangkalan",
          "banjarejo": "Banjarejo",
          "banjarsari": "Banjarsari",
          "banyuwangi": "Banyuwangi",
          "baratan": "Baratan",
          "bataan": "Bataan",
          "batokan": "Batokan",
          "batu": "Batu",
          "bayeman": "Bayeman",
          "bebekan": "Bebekan",
          "bedah": "Bedah",
          "bendo": "Bendo",
          "beton": "Beton",
          "blimbing": "Blimbing",
          "blitar": "Blitar",
          "bojonegoro": "Bojonegoro",
          "bondowoso": "Bondowoso",
          "bulukerto": "Bulukerto",
          "dukuh_kupang": "Dukuh Kupang",
          "genteng": "Genteng",
          "glenmore": "Glenmore",
          "gresik": "Gresik",
          "gubeng": "Gubeng",
          "indragiri": "Indragiri",
          "jatirejo": "Jatirejo",
          "jember": "Jember",
          "jombang": "Jombang",
          "kademangan": "Kademangan",
          "kanigaran": "Kanigaran",
          "karang": "Karang",
          "kauman": "Kauman",
          "kebonsari": "Kebonsari",
          "kebonsari_kulon": "Kebonsari Kulon",
          "kediri": "Kediri",
          "kembangbilo": "Kembangbilo",
          "ketanon": "Ketanon",
          "ketintang": "Ketintang",
          "kutai": "Kutai",
          "lamongan": "Lamongan",
          "lawang": "Lawang",
          "legian": "Legian",
          "lumajang": "Lumajang",
          "madiun": "Madiun",
          "magetan": "Magetan",
          "malang": "Malang",
          "medokan": "Medokan",
          "mojo": "Mojo",
          "mojokerto": "Mojokerto",
          "nganjuk": "Nganjuk",
          "ngronggot": "Ngronggot",
          "nyamplungan": "Nyamplungan",
          "pacitan": "Pacitan",
          "pare": "Pare",
          "pasuruan": "Pasuruan",
          "polerejo": "Polerejo",
          "ponorogo": "Ponorogo",
          "probolinggo": "Probolinggo",
          "puri": "Puri",
          "rungkut_kidul": "Rungkut Kidul",
          "sanur": "Sanur",
          "selatan": "Selatan",
          "senori": "Senori",
          "sidoarjo": "Sidoarjo",
          "sidomoro": "Sidomoro",
          "situbondo": "Situbondo",
          "sumenep": "Sumenep",
          "surabaya": "Surabaya",
          "tebas": "Tebas",
          "trenggalek": "Trenggalek",
          "tuban": "Tuban",
          "tulungagung": "Tulungagung",
          "tulungrejo": "Tulungrejo",
          "utara": "Utara",
          "waru": "Waru",
          "wates": "Wates",
          "yosowilangun": "Yosowilangun"
        },
        "east_kalimantan": {
          "balikpapan": "Balikpapan",
          "bontang": "Bontang",
          "nunukan": "Nunukan",
          "samarinda": "Samarinda"
        },
        "east_nusa_tenggara": {
          "ende": "Ende",
          "fontein": "Fontein",
          "kota": "Kota",
          "kupang": "Kupang",
          "maumere": "Maumere",
          "naikolan": "Naikolan"
        },
        "gorontalo": { "damai": "Damai", "gorontalo": "Gorontalo" },
        "jakarta": {
          "batuampar": "Batuampar",
          "bendungan_hilir": "Bendungan Hilir",
          "bintaro": "Bintaro",
          "cawang": "Cawang",
          "cempaka_baru": "Cempaka Baru",
          "cengkareng": "Cengkareng",
          "ciganjur": "Ciganjur",
          "cilandak": "Cilandak",
          "cipayung": "Cipayung",
          "cipete": "Cipete",
          "cipinang": "Cipinang",
          "ciracas": "Ciracas",
          "gambir": "Gambir",
          "grogol": "Grogol",
          "gunung": "Gunung",
          "jagakarsa": "Jagakarsa",
          "jakarta": "Jakarta",
          "jelambar": "Jelambar",
          "joglo": "Joglo",
          "karet": "Karet",
          "kebayoran_baru": "Kebayoran Baru",
          "kebayoran_lama_selatan": "Kebayoran Lama Selatan",
          "kebon_baru": "Kebon Baru",
          "kedoya_selatan": "Kedoya Selatan",
          "kemanggisan": "Kemanggisan",
          "kramat": "Kramat",
          "kuningan_barat": "Kuningan Barat",
          "kwitang": "Kwitang",
          "malaka": "Malaka",
          "pademangan_barat": "Pademangan Barat",
          "pasar_baru": "Pasar Baru",
          "pegadungan": "Pegadungan",
          "pegangsaan_dua": "Pegangsaan Dua",
          "penggilingan": "Penggilingan",
          "penjaringan": "Penjaringan",
          "petukangan_selatan": "Petukangan Selatan",
          "petukangan_utara": "Petukangan Utara",
          "pisangan_lama": "Pisangan Lama",
          "rorotan": "Rorotan",
          "serdang": "Serdang",
          "setiabudi": "Setiabudi",
          "sukabumi_selatan": "Sukabumi Selatan",
          "tambun_selatan": "Tambun Selatan"
        },
        "jambi": { "bangko": "Bangko", "jambi_city": "Jambi City" },
        "lampung": {
          "natar": "Natar",
          "ogan": "Ogan",
          "pringsewu": "Pringsewu",
          "teluk_betung": "Teluk Betung"
        },
        "maluku": {
          "ambon_city": "Ambon City",
          "ternate": "Ternate",
          "timoer": "Timoer"
        },
        "north_kalimantan": { "lingkas": "Lingkas", "tarakan": "Tarakan" },
        "north_maluku": { "ternate": "Ternate" },
        "north_sulawesi": {
          "bitung": "Bitung",
          "lolak": "Lolak",
          "manado": "Manado",
          "tomohon": "Tomohon",
          "tondano": "Tondano"
        },
        "north_sumatra": {
          "adiantorop": "Adiantorop",
          "amplas": "Amplas",
          "asahan": "Asahan",
          "bali": "Bali",
          "balige": "Balige",
          "bandar": "Bandar",
          "binjai": "Binjai",
          "bukit_tinggi": "Bukit Tinggi",
          "gunungsitoli": "Gunungsitoli",
          "helvetia": "Helvetia",
          "kabanjahe": "Kabanjahe",
          "kampung_dalam": "Kampung Dalam",
          "kisaran": "Kisaran",
          "lubuk_pakam": "Lubuk Pakam",
          "mabar": "Mabar",
          "medan": "Medan",
          "nangka": "Nangka",
          "padang_bulan": "Padang Bulan",
          "pancuran": "Pancuran",
          "pasar_baru": "Pasar Baru",
          "pematangsiantar": "Pematangsiantar",
          "sepinggan": "Sepinggan",
          "serdang": "Serdang",
          "sibolga": "Sibolga",
          "simalungun": "Simalungun",
          "stabat": "Stabat",
          "sunggal": "Sunggal",
          "tanah_enam_ratus": "Tanah Enam Ratus",
          "tanjung_gusta": "Tanjung Gusta",
          "tebingtinggi": "Tebingtinggi",
          "titi_papan": "Titi Papan"
        },
        "papua": {
          "jayapura": "Jayapura",
          "merauke": "Merauke",
          "serui": "Serui",
          "tembagapura": "Tembagapura",
          "timika": "Timika",
          "wamena": "Wamena"
        },
        "riau": {
          "bengkalis": "Bengkalis",
          "dumai": "Dumai",
          "karanganunggi": "Karanganunggi",
          "pekanbaru": "Pekanbaru",
          "siak_sri_indrapura": "Siak Sri Indrapura",
          "tangkerang": "Tangkerang"
        },
        "riau_islands": {
          "batam": "Batam",
          "sekupang": "Sekupang",
          "tanjung_balai": "Tanjung Balai",
          "tanjungpinang": "Tanjungpinang",
          "tengah": "Tengah"
        },
        "south_kalimantan": {
          "alabio": "Alabio",
          "amuntai": "Amuntai",
          "banjarbaru": "Banjarbaru",
          "banjarmasin": "Banjarmasin",
          "belandean": "Belandean",
          "kotabaru_hilir": "Kotabaru Hilir",
          "martapura": "Martapura",
          "sungkai": "Sungkai"
        },
        "south_sulawesi": {
          "ballaparang": "Ballaparang",
          "baranti": "Baranti",
          "batang": "Batang",
          "bombong": "Bombong",
          "daya": "Daya",
          "duri": "Duri",
          "jaya": "Jaya",
          "jempang": "Jempang",
          "karampuang": "Karampuang",
          "makale": "Makale",
          "makassar": "Makassar",
          "malili": "Malili",
          "maros": "Maros",
          "masamba": "Masamba",
          "melayu": "Melayu",
          "palangka": "Palangka",
          "palopo": "Palopo",
          "parepare": "Parepare",
          "salupontu": "Salupontu",
          "sidenreng": "Sidenreng",
          "sinjai": "Sinjai",
          "solo": "Solo"
        },
        "south_sumatra": {
          "baturaja": "Baturaja",
          "lubuklinggau": "Lubuklinggau",
          "palembang": "Palembang"
        },
        "southeast_sulawesi": {
          "kendari": "Kendari",
          "kolaka": "Kolaka",
          "muara": "Muara",
          "poanaha": "Poanaha"
        },
        "west_java": {
          "andir": "Andir",
          "antapani": "Antapani",
          "babakan": "Babakan",
          "babakan_ciparay": "Babakan Ciparay",
          "babakan_sari": "Babakan Sari",
          "balaraja": "Balaraja",
          "bandung": "Bandung",
          "banjar": "Banjar",
          "barengkok": "Barengkok",
          "bekasi": "Bekasi",
          "bogor": "Bogor",
          "bojong": "Bojong",
          "bungursari": "Bungursari",
          "cempaka": "Cempaka",
          "ciamis": "Ciamis",
          "cianjur": "Cianjur",
          "ciapus": "Ciapus",
          "ciateul": "Ciateul",
          "cibabat": "Cibabat",
          "cibadung": "Cibadung",
          "cibinong": "Cibinong",
          "cibiru": "Cibiru",
          "cigadung": "Cigadung",
          "cikampek": "Cikampek",
          "cikarang": "Cikarang",
          "cikiwul": "Cikiwul",
          "cilegon": "Cilegon",
          "cileungsir": "Cileungsir",
          "cimahi": "Cimahi",
          "cindogo": "Cindogo",
          "cinere": "Cinere",
          "cipageran": "Cipageran",
          "cipondoh": "Cipondoh",
          "ciporeat": "Ciporeat",
          "ciputat": "Ciputat",
          "cirangrang": "Cirangrang",
          "cirebon": "Cirebon",
          "cisaranten_kulon": "Cisaranten Kulon",
          "cisarua": "Cisarua",
          "ciseureuh": "Ciseureuh",
          "citeureup": "Citeureup",
          "depok": "Depok",
          "garut": "Garut",
          "hegarmanah": "Hegarmanah",
          "indramayu": "Indramayu",
          "jatiasih": "Jatiasih",
          "jatibening": "Jatibening",
          "karangtawang": "Karangtawang",
          "karawang": "Karawang",
          "kertasari": "Kertasari",
          "kunciran": "Kunciran",
          "kuningan": "Kuningan",
          "majalengka": "Majalengka",
          "melong": "Melong",
          "ngawi": "Ngawi",
          "padalarang": "Padalarang",
          "padasuka": "Padasuka",
          "pajajaran": "Pajajaran",
          "pakulonan_barat": "Pakulonan Barat",
          "pamanukan": "Pamanukan",
          "pamulang": "Pamulang",
          "pamulang_barat": "Pamulang Barat",
          "purwakarta": "Purwakarta",
          "rahayu": "Rahayu",
          "sawangan": "Sawangan",
          "sentul": "Sentul",
          "serang": "Serang",
          "serpong": "Serpong",
          "sindangrasa": "Sindangrasa",
          "subang": "Subang",
          "sukabumi": "Sukabumi",
          "sukamaju": "Sukamaju",
          "sumedang": "Sumedang",
          "tangsel": "Tangsel",
          "tasikmalaya": "Tasikmalaya",
          "utama": "Utama"
        },
        "west_kalimantan": {
          "bengkayang": "Bengkayang",
          "pontianak": "Pontianak",
          "singkawang": "Singkawang",
          "sintang": "Sintang"
        },
        "west_nusa_tenggara": {
          "gunungsari": "Gunungsari",
          "labuan_lombok": "Labuan Lombok",
          "leneng": "Leneng",
          "luk": "Luk",
          "mataram": "Mataram",
          "sandubaya": "Sandubaya",
          "selong": "Selong",
          "sumbawa_besar": "Sumbawa Besar",
          "tanjung": "Tanjung"
        },
        "west_papua": { "sorong": "Sorong" },
        "west_sulawesi": {
          "mamuju": "Mamuju",
          "panasuan": "Panasuan",
          "polewali": "Polewali"
        },
        "west_sumatra": {
          "batusangkar": "Batusangkar",
          "bukittinggi": "Bukittinggi",
          "gadang": "Gadang",
          "karang": "Karang",
          "padang": "Padang",
          "payakumbuh": "Payakumbuh",
          "solok": "Solok"
        },
        "yogyakarta": {
          "baciro": "Baciro",
          "bantul": "Bantul",
          "canden": "Canden",
          "condong": "Condong",
          "pandeyan": "Pandeyan",
          "panggung": "Panggung",
          "panjangrejo": "Panjangrejo",
          "patehan": "Patehan",
          "sleman": "Sleman",
          "yogyakarta": "Yogyakarta"
        }
      }
    }
  },
  "limitation": {
    "inc": "Include",
    "exc": "Exclude",
    "Preferred": "Preferred",
    "NonPreferred": "Non Preferred",
    "other": "Other",
    "labels": {
      "trafficAttribute": "Traffic Attribute",
      "total": "Total: {{total}}",
      "warningAddDomain": "Entered Space ID may not be valid RMax space id",
      "customGeofence": "Latitude and longitude",
      "customKeyword": "Custom Keyword",
      "contentcat": "Content Category",
      "keywordDescription": "Please input keyword",
      "languageDescription": "Please choose language",
      "tranditionalChinese": "Tranditional Chinese",
      "vietnamese": "Vietnamese",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "radius": "Radius",
      "minDecimalPlacesError": "It must be accurate to at least {{count}} decimal places",
      "maxDecimalPlacesError": "Only supports up to {{count}} decimal places",
      "simulcastMismatch": "Synchronized Playback Mismatch",
      "searchResult": "Depend on the keyword you set up, it might be included in {{articleCount}} articles in last 7 days.",
      "updateEveryHour": "※ Update every hour ※",
      "singleSelectTip": "Single selection only",
      "peopleNumberTip": "{{value}} people",
      "country": "Country",
      "geography": "Country",
      "adx": "Ad Exchange",
      "keyword": "Keyword",
      "unicornkeywords": "Keywords",
      "keyword1": "Keyword 1",
      "keyword2": "Keyword 2",
      "searchKeyword": "Seach Keyword",
      "unicornkeyword1": "Keyword 1",
      "unicornkeyword2": "Keyword 2",
      "unicornlanguage": "Keyword Language",
      "and": "And",
      "space": "Space",
      "adspace": "Space",
      "ages": "Age",
      "age": "Age",
      "os": "OS",
      "articleCategory": "Content Category",
      "tenmaxCategory": "Space Category",
      "adcat": "Space Category",
      "carrier": "Carrier",
      "contentlang": "Content Language",
      "dealId": "Deal ID",
      "testMode": "Test Mode",
      "segment": "Audience Segment",
      "gender": "Gender",
      "device": "Device",
      "tenmaxAudience": "TenMax Segment",
      "domain": "Domain",
      "finishEditing": "Finish editing",
      "spaceType": "Space Type",
      "outDoorDevice": "Outdoor Device",
      "publisher": "Publisher",
      "edit": "Edit",
      "incHaveValue": "Selected Traffic",
      "incNoValue": "Selected Traffic (None)",
      "excHaveValue": "Excluded Traffic",
      "excNoValue": "Excluded Traffic (None)",
      "preferHaveValue": "Preferred Traffic",
      "preferNoValue": "Preferred Traffic (None)",
      "nonpreferHaveValue": "Nonpreferred Traffic",
      "nonpreferNoValue": "Nonpreferred Traffic (None)",
      "instl": "Allow Interstitail",
      "adFormat": "Ad Format",
      "agencySegment": "{{name}}'s Segments",
      "consumer_profile": "Consumer Profile",
      "bill_payment_audience": "Bill Payment Audience",
      "consumer_profile-age": "Consumer Profile - Age",
      "consumer_profile-gender": "Consumer Profile - Gender",
      "location_audience": "Location Audience",
      "offline_store_consumption": "Offline Store Consumption",
      "offline_store_active_users": "Offline Store Active Users",
      "purchase_power_audience": "Puchase Power Audience",
      "preorder_products": "Pre-order Products",
      "gaming_audience": "Gaming Audience",
      "others": "Others",
      "custom_segment": "Custom Audience",
      "gender_male": "Male",
      "gender_female": "Female",
      "age_1": "0 ~ 17",
      "age_2": "18 ~ 24",
      "age_3": "25 ~ 34",
      "age_4": "35 ~ 44",
      "age_5": "45 ~ 54",
      "age_6": "55 ~ 64",
      "age_7": "65+",
      "work_area": "Work Area",
      "home_area": "Home Area",
      "hospital_area": "Hospital Area",
      "school_area": "School Area",
      "business_area": "Business Area",
      "tech_area": "Tech Area",
      "travel_area": "Travel Area",
      "low_spend": "Low Spend",
      "mid_spend": "Mid Spend",
      "high_spend": "High Spend",
      "high_activity": "High Activity",
      "low_activity": "Low Activity",
      "discount": "Discount",
      "health_food": "Health Food",
      "forzen_food": "Forzen Food",
      "snack": "Snack",
      "makeup": "Makeup",
      "goods": "Goods",
      "coffee": "Coffee",
      "alcohol": "Alcohol",
      "beer": "Beer",
      "drinks": "Drink",
      "fried_food": "Fried Food",
      "instant_noodles": "Instant Noodles",
      "fresh_food": "Fresh Food",
      "oral_care": "Oral Care",
      "facial_care": "Facial Care",
      "threeC": "3C",
      "gaming": "Gaming",
      "parking": "Parking",
      "bill": "Bill",
      "donation": "Donation",
      "i_threeC": "Home Application (3C)",
      "i_fancy_food": "Fancy Food",
      "i_makeup": "Makeup",
      "i_health_food": "Health Food",
      "customOutdoorDevice": "Customed Outdoor Device",
      "systemRecommendOutdoorDevice": "System Recommendations",
      "geofence": "Important MRT Stations",
      "simulcastGroup": "Synchronized Playback Space",
      "storeNum": "Stores Information",
      "expandAllStores": "Expand All",
      "collapseAllStores": "Collapse All",
      "unknownMunicipality": "Unknown City",
      "weatherCode": "Weather Phenomenon",
      "temperature": "Temperature",
      "probabilityOfPrecipitation": "Precipitation Probability",
      "uvIndex": "UV Index",
      "relativeHumidity": "Relative Humidity",
      "options": {
        "uvIndex": {
          "low": "Low",
          "moderate": "Moderate",
          "high": "High",
          "veryHigh": "Very High",
          "extreme": "Extreme"
        },
        "weatherCode": {
          "sunny": "Sunny",
          "cloudy": "Cloudy",
          "rainy": "Rainy",
          "snowy": "Snowy"
        }
      },
      "settingSearchResult": "{{name}} search result articles count : <2>{{result}}</2>",
      "adxCanNotNull": "At least one adx must be selected",
      "geograthyCanNotNull": "At least one country must be selected",
      "general": "General",
      "searchKeywordsTitle": "Search Keywords",
      "searchKeywords": "Keywords",
      "searchKeywordsDes": "Please enter the keyword you want to translate",
      "placement": "Placement",
      "relatedKeywordsTitle": "Related Keywords",
      "audienceDefinition": "Audience Definition",
      "cityGroup": "Location",
      "administrativeArea": "District",
      "outdoorPlaceCategories": "Local Feature",
      "deviceCharacteristic": "Device Information",
      "interests": "Interests"
    },
    "titles": { "outdoorDeviceProperty": "Outdoor Attributes" },
    "addSpace": "Add Space",
    "addSpaceTip": "Separated by a \",\" and break line to add space, please.",
    "placeholders": {
      "addSpace": "ex: Space ID,Space Name\nff73b7afb2804c15,Space Name1\nfeda87ba37f94366\nfe7c4bea7b39473c,Space Name2",
      "addDomain": "tenmax.io\ngoogle.com",
      "addOutdoorDevice": "ex: Outdoor Space Name\n台北市_XXXXX1_XX門市_門口第1台\n台北市_XXXXX1_XX門市_門口第2台\n台北市_XXXXX1_XX門市_門口第3台",
      "addOutdoorStore": "ex: Outdoor Store Name\n台北市_XXXXX1_XX門市\n台北市_XXXXX2_XX門市\n台北市_XXXXX3_XX門市",
      "addPublisher": "ex: Publisher ID,Publisher Name\nff73b7afb2804c15,Publisher Name1\nfeda87ba37f94366\nfe7c4bea7b39473c,Publisher Name2",
      "categoryTip": "Choose a property to check categories",
      "searchSpace": "Search Space Name",
      "searchAdx": "Search Ad Exchange Name",
      "searchCountryCity": "Search Country / City Name",
      "searchCountryProvince": "Search Country / Province Name",
      "searchCarrier": "Search Carrier",
      "searchContentLang": "Search Content Language",
      "searchContentCat": "Search Content Category",
      "searchOs": "Search OS",
      "searchAges": "Search Age",
      "searchGenders": "Search Gender",
      "searchDevice": "Search Device",
      "searchTenmaxSegments": "Search TenMax Segment",
      "searchDomains": "Search Domain",
      "searchAdCat": "Search Space Category",
      "searchAgencySegment": "Search Agency Segment",
      "searchSegment": "Search Audience Segment",
      "searchSpaceType": "Search Space Type",
      "searchAdFormat": "Search Ad Format",
      "searchOutdoorDevice": "Search Outdoor Device",
      "searchRecommendOutdoorDevice": "Search Recommend Outdoor Device",
      "searchGeofence": "Search Important MRT Stations",
      "searchKeywords": "Please use \",\" to separate keyword. Such as: 3c, smart phone",
      "searchPlacement": "Search Placement"
    },
    "addDomain": "Add Custom Domain",
    "addDomainTip": "Please break line to add more domain.",
    "addOutdoorDevice": "Add Outdoor Device",
    "addOutdoorDeviceTip": "Please break line to add more domain outdoor device.",
    "addOutdoorStore": "Add Outdoor Store",
    "addOutdoorStoreTip": "Please break line to add more domain outdoor store.",
    "addPublisher": "Add Publisher",
    "addPublisherTip": "Separated by a \",\" and break line to add publisher please.",
    "addDealId": "Use Enter to finish typing a set of numbers",
    "buttons": {
      "addDomain": "Add",
      "cancelAddDomain": "Cancel",
      "search": "Search",
      "clear": "Clear",
      "addDevice": "Add Device",
      "removeDevice": "Remove Device",
      "addStore": "Add Store",
      "removeStore": "Remove Store"
    },
    "classificationTotal": "{{total}} categories",
    "hints": {
      "inc": "Ads will default to all eligible inventory if no delivery constraints are applied.",
      "ageGroups": "Covering Age Groups: {{groups}}",
      "storeCount": "Store Count: {{count}}",
      "deviceCount": "Device Count: {{count}}",
      "overBindingLimit": "Delivery limit reached"
    },
    "title": {
      "you": {
        "need": "Include people who match",
        "dont": { "need": "Exclude people who match" }
      },
      "other": { "need": "Other" },
      "fixOutdoorLimitationSection": "Fixed Outdoor Device Options",
      "weatherSection": "Weather Targeting",
      "mapSection": "Map Mode"
    },
    "hint": {
      "weatherSection": "Weather targeting intersects with store settings to determine which stores are eligible to serve ads"
    },
    "allow": { "inst": "Allow Interstitail" },
    "move": { "to": "Move to" },
    "include": "Selected Traffic",
    "exclude": "Excluded Traffic",
    "preferred": "Preferred Traffic",
    "nonPreferred": "Nonpreferred Traffic",
    "general": "General Targeting",
    "warning": {
      "sameTypeWarning": "Already has property in {{type}}, are you confirm to override setting."
    },
    "genders": { "male": "Male", "female": "Female", "unlimited": "All" },
    "carries": { "chunghwa": "ChungHwa", "taiwanMobile": "Taiwan Mobile" },
    "locations": {
      "xiangshanStation": "Xiangshan Station",
      "daanStation": "Daan Station",
      "nanjingFuxingStation": "Nanjing Fuxing Station",
      "songshanStation": "Songshan Station",
      "yonganMarketStation": "Yongan Market Station",
      "shilinStation": "Shilin Station",
      "tamsuiStation": "Tamsui Station",
      "taipeiNangangExhibitionCenterStation": "Taipei Nangang Exhibition Center Station",
      "taipeiMainStation": "Taipei Main Station",
      "wanfangHospitalStation": "Wanfang Hospital Station",
      "ximenStation": "Ximen Station",
      "minquanWestRoadStation": "Minquan West Road Station",
      "luzhouStation": "Luzhou Station",
      "fuJenUniversityStation": "Fu Jen University Station",
      "shanbStation": "Shanb Station"
    },
    "contentCategory": {
      "iab1": "Arts & Entertainment",
      "iab1_1": "Books & Literature",
      "iab1_2": "Celebrity Fan/Gossip",
      "iab1_3": "Fine Art",
      "iab1_4": "Humor",
      "iab1_5": "Movies",
      "iab1_6": "Music",
      "iab1_7": "Television",
      "iab2": "Automotive",
      "iab2_1": "Auto Parts",
      "iab2_2": "Auto Repair",
      "iab2_3": "Buying/Selling Cars",
      "iab2_4": "Car Culture",
      "iab2_5": "Certified Pre-Owned",
      "iab2_6": "Convertible",
      "iab2_7": "Coupe",
      "iab2_8": "Crossover",
      "iab2_9": "Diesel",
      "iab2_10": "Electric Vehicle",
      "iab2_11": "Hatchback",
      "iab2_12": "Hybrid",
      "iab2_13": "Luxury",
      "iab2_14": "Minivan",
      "iab2_15": "Motorcycles",
      "iab2_16": "Off-Road Vehicles",
      "iab2_17": "Performance Vehicles",
      "iab2_18": "Pickup",
      "iab2_19": "Road-Side Assistance",
      "iab2_20": "Sedan",
      "iab2_21": "Trucks & Accessories",
      "iab2_22": "Vintage Cars",
      "iab2_23": "Wagon",
      "iab3": "Business",
      "iab3_1": "Advertising",
      "iab3_2": "Agriculture",
      "iab3_3": "Biotech/Biomedical",
      "iab3_4": "Business Software",
      "iab3_5": "Construction",
      "iab3_6": "Forestry",
      "iab3_7": "Government",
      "iab3_8": "Green Solutions",
      "iab3_9": "Human Resources",
      "iab3_10": "Logistics",
      "iab3_11": "Marketing",
      "iab3_12": "Metals",
      "iab4": "Careers",
      "iab4_1": "Career Planning",
      "iab4_2": "College",
      "iab4_3": "Financial Aid",
      "iab4_4": "Job Fairs",
      "iab4_5": "Job Search",
      "iab4_6": "Resume Writing/Advice",
      "iab4_7": "Nursing",
      "iab4_8": "Scholarships",
      "iab4_9": "Telecommuting",
      "iab4_10": "U.S Military",
      "iab4_11": "Career Advice",
      "iab5": "Education",
      "iab5_1": "44024 Education",
      "iab5_2": "Adult Education",
      "iab5_3": "Art History",
      "iab5_4": "College Administration",
      "iab5_5": "College Life",
      "iab5_6": "Distance Learning",
      "iab5_7": "English as a 2nd Language",
      "iab5_8": "Language Learning",
      "iab5_9": "Graduate School",
      "iab5_10": "Homeschooling",
      "iab5_11": "Homework/Study Tips",
      "iab5_12": "K-6 Educators",
      "iab5_13": "Private School",
      "iab5_14": "Special Education",
      "iab5_15": "Studying Business",
      "iab6": "Family & Parenting",
      "iab6_1": "Adoption",
      "iab6_2": "Babies & Toddlers",
      "iab6_3": "Daycare/Pre School",
      "iab6_4": "Family Internet",
      "iab6_5": "Parenting - K-6 Kids",
      "iab6_6": "Parenting teens",
      "iab6_7": "Pregnancy",
      "iab6_8": "Special Needs Kids",
      "iab6_9": "Eldercare",
      "iab7": "Health & Fitness",
      "iab7_1": "Exercise",
      "iab7_2": "ADD",
      "iab7_3": "AIDS/HIV",
      "iab7_4": "Allergies",
      "iab7_5": "Alternative Medicine",
      "iab7_6": "Arthritis",
      "iab7_7": "Asthma",
      "iab7_8": "Autism/PDD",
      "iab7_9": "Bipolar Disorder",
      "iab7_10": "Brain Tumor",
      "iab7_11": "Cancer",
      "iab7_12": "Cholesterol",
      "iab7_13": "Chronic Fatigue Syndrome",
      "iab7_14": "Chronic Pain",
      "iab7_15": "Cold & Flu",
      "iab7_16": "Deafness",
      "iab7_17": "Dental Care",
      "iab7_18": "Depression",
      "iab7_19": "Dermatology",
      "iab7_20": "Diabetes",
      "iab7_21": "Epilepsy",
      "iab7_22": "GERD/Acid Reflux",
      "iab7_23": "Headaches/Migraines",
      "iab7_24": "Heart Disease",
      "iab7_25": "Herbs for Health",
      "iab7_26": "Holistic Healing",
      "iab7_27": "IBS/Crohn’s Disease",
      "iab7_28": "Incest/Abuse Support",
      "iab7_29": "Incontinence",
      "iab7_30": "Infertility",
      "iab7_31": "Men’s Health",
      "iab7_32": "Nutrition",
      "iab7_33": "Orthopedics",
      "iab7_34": "Panic/Anxiety Disorders",
      "iab7_35": "Pediatrics",
      "iab7_36": "Physical Therapy",
      "iab7_37": "Psychology/Psychiatry",
      "iab7_38": "Senior Health",
      "iab7_39": "Sexuality",
      "iab7_40": "Sleep Disorders",
      "iab7_41": "Smoking Cessation",
      "iab7_42": "Substance Abuse",
      "iab7_43": "Thyroid Disease",
      "iab7_44": "Weight Loss",
      "iab7_45": "Women's Health",
      "iab8": "Food & Drink",
      "iab8_1": "American Cuisine",
      "iab8_2": "Barbecues & Grilling",
      "iab8_3": "Cajun/Creole",
      "iab8_4": "Chinese Cuisine",
      "iab8_5": "Cocktails/Beer",
      "iab8_6": "Coffee/Tea",
      "iab8_7": "Cuisine-Specific",
      "iab8_8": "Desserts & Baking",
      "iab8_9": "Dining Out",
      "iab8_10": "Food Allergies",
      "iab8_11": "French Cuisine",
      "iab8_12": "Health/Low-Fat Cooking",
      "iab8_13": "Italian Cuisine",
      "iab8_14": "Japanese Cuisine",
      "iab8_15": "Mexican Cuisine",
      "iab8_16": "Vegan",
      "iab8_17": "Vegetarian",
      "iab8_18": "Wine",
      "iab9": "Hobbies & Interests",
      "iab9_1": "Art/Technology",
      "iab9_2": "Arts & Crafts",
      "iab9_3": "Beadwork",
      "iab9_4": "Bird-Watching",
      "iab9_5": "Board Games/Puzzles",
      "iab9_6": "Candle & Soap Making",
      "iab9_7": "Card Games",
      "iab9_8": "Chess",
      "iab9_9": "Cigars",
      "iab9_10": "Collecting",
      "iab9_11": "Comic Books",
      "iab9_12": "Drawing/Sketching",
      "iab9_13": "Freelance Writing",
      "iab9_14": "Genealogy",
      "iab9_15": "Getting Published",
      "iab9_16": "Guitar",
      "iab9_17": "Home Recording",
      "iab9_18": "Investors & Patents",
      "iab9_19": "Jewelry Making",
      "iab9_20": "Magic & Illusion",
      "iab9_21": "Needlework",
      "iab9_22": "Painting",
      "iab9_23": "Photography",
      "iab9_24": "Radio",
      "iab9_25": "Roleplaying Games",
      "iab9_26": "Sci-Fi & Fantasy",
      "iab9_27": "Scrapbooking",
      "iab9_28": "Screenwriting",
      "iab9_29": "Stamps & Coins",
      "iab9_30": "Video & Computer Games",
      "iab9_31": "Woodworking",
      "iab10": "Home & Garden",
      "iab10_1": "Appliances",
      "iab10_2": "Entertaining",
      "iab10_3": "Environmental Safety",
      "iab10_4": "Gardening",
      "iab10_5": "Home Repair",
      "iab10_6": "Home Theater",
      "iab10_7": "Interior Decorating",
      "iab10_8": "Landscaping",
      "iab10_9": "Remodeling & Construction",
      "iab11": "Law, Government, & Politics",
      "iab11_1": "Immigration",
      "iab11_2": "Legal Issues",
      "iab11_3": "U.S. Government Resources",
      "iab11_4": "Politics",
      "iab11_5": "Commentary",
      "iab12": "News",
      "iab12_1": "International News",
      "iab12_2": "National News",
      "iab12_3": "Local News",
      "iab13": "Personal Finance",
      "iab13_1": "Beginning Investing",
      "iab13_2": "Credit/Debt & Loans",
      "iab13_3": "Financial News",
      "iab13_4": "Financial Planning",
      "iab13_5": "Hedge Fund",
      "iab13_6": "Insurance",
      "iab13_7": "Investing",
      "iab13_8": "Mutual Funds",
      "iab13_9": "Options",
      "iab13_10": "Retirement Planning",
      "iab13_11": "Stocks",
      "iab13_12": "Tax Planning",
      "iab14": "Society",
      "iab14_1": "Dating",
      "iab14_2": "Divorce Support",
      "iab14_3": "Gay Life",
      "iab14_4": "Marriage",
      "iab14_5": "Senior Living",
      "iab14_6": "Teens",
      "iab14_7": "Weddings",
      "iab14_8": "Ethnic Specific",
      "iab15": "Science",
      "iab15_1": "Astrology",
      "iab15_2": "Biology",
      "iab15_3": "Chemistry",
      "iab15_4": "Geology",
      "iab15_5": "Paranormal Phenomena",
      "iab15_6": "Physics",
      "iab15_7": "Space/Astronomy",
      "iab15_8": "Geography",
      "iab15_9": "Botany",
      "iab15_10": "Weather",
      "iab16": "Pets",
      "iab16_1": "Aquariums",
      "iab16_2": "Birds",
      "iab16_3": "Cats",
      "iab16_4": "Dogs",
      "iab16_5": "Large Animals",
      "iab16_6": "Reptiles",
      "iab16_7": "Veterinary Medicine",
      "iab17": "Sports",
      "iab17_1": "Auto Racing",
      "iab17_2": "Baseball",
      "iab17_3": "Bicycling",
      "iab17_4": "Bodybuilding",
      "iab17_5": "Boxing",
      "iab17_6": "Canoeing/Kayaking",
      "iab17_7": "Cheerleading",
      "iab17_8": "Climbing",
      "iab17_9": "Cricket",
      "iab17_10": "Figure Skating",
      "iab17_11": "Fly Fishing",
      "iab17_12": "Football",
      "iab17_13": "Freshwater Fishing",
      "iab17_14": "Game & Fish",
      "iab17_15": "Golf",
      "iab17_16": "Horse Racing",
      "iab17_17": "Horses",
      "iab17_18": "Hunting/Shooting",
      "iab17_19": "Inline Skating",
      "iab17_20": "Martial Arts",
      "iab17_21": "Mountain Biking",
      "iab17_22": "NASCAR Racing",
      "iab17_23": "Olympics",
      "iab17_24": "Paintball",
      "iab17_25": "Power & Motorcycles",
      "iab17_26": "Pro Basketball",
      "iab17_27": "Pro Ice Hockey",
      "iab17_28": "Rodeo",
      "iab17_29": "Rugby",
      "iab17_30": "Running/Jogging",
      "iab17_31": "Sailing",
      "iab17_32": "Saltwater Fishing",
      "iab17_33": "Scuba Diving",
      "iab17_34": "Skateboarding",
      "iab17_35": "Skiing",
      "iab17_36": "Snowboarding",
      "iab17_37": "Surfing/Body-Boarding",
      "iab17_38": "Swimming",
      "iab17_39": "Table Tennis/Ping-Pong",
      "iab17_40": "Tennis",
      "iab17_41": "Volleyball",
      "iab17_42": "Walking",
      "iab17_43": "Waterski/Wakeboard",
      "iab17_44": "World Soccer",
      "iab18": "Style & Fashion",
      "iab18_1": "Beauty",
      "iab18_2": "Body Art",
      "iab18_3": "Fashion",
      "iab18_4": "Jewelry",
      "iab18_5": "Clothing",
      "iab18_6": "Accessories",
      "iab19": "Technology & Computing",
      "iab19_1": "3-D Graphics",
      "iab19_2": "Animation",
      "iab19_3": "Antivirus Software",
      "iab19_4": "C/C++",
      "iab19_5": "Cameras & Camcorders",
      "iab19_6": "Cell Phones",
      "iab19_7": "Computer Certification",
      "iab19_8": "Computer Networking",
      "iab19_9": "Computer Peripherals",
      "iab19_10": "Computer Reviews",
      "iab19_11": "Data Centers",
      "iab19_12": "Databases",
      "iab19_13": "Desktop Publishing",
      "iab19_14": "Desktop Video",
      "iab19_15": "Email",
      "iab19_16": "Graphics Software",
      "iab19_17": "Home Video/DVD",
      "iab19_18": "Internet Technology",
      "iab19_19": "Java",
      "iab19_20": "JavaScript",
      "iab19_21": "Mac Support",
      "iab19_22": "MP3/MIDI",
      "iab19_23": "Net Conferencing",
      "iab19_24": "Net for Beginners",
      "iab19_25": "Network Security",
      "iab19_26": "Palmtops/PDAs",
      "iab19_27": "PC Support",
      "iab19_28": "Portable",
      "iab19_29": "Entertainment",
      "iab19_30": "Shareware/Freeware",
      "iab19_31": "Unix",
      "iab19_32": "Visual Basic",
      "iab19_33": "Web Clip Art",
      "iab19_34": "Web Design/HTML",
      "iab19_35": "Web Search",
      "iab19_36": "Windows",
      "iab20": "Travel",
      "iab20_1": "Adventure Travel",
      "iab20_2": "Africa",
      "iab20_3": "Air Travel",
      "iab20_4": "Australia & New Zealand",
      "iab20_5": "Bed & Breakfasts",
      "iab20_6": "Budget Travel",
      "iab20_7": "Business Travel",
      "iab20_8": "By US Locale",
      "iab20_9": "Camping",
      "iab20_10": "Canada",
      "iab20_11": "Caribbean",
      "iab20_12": "Cruises",
      "iab20_13": "Eastern Europe",
      "iab20_14": "Europe",
      "iab20_15": "France",
      "iab20_16": "Greece",
      "iab20_17": "Honeymoons/Getaways",
      "iab20_18": "Hotels",
      "iab20_19": "Italy",
      "iab20_20": "Japan",
      "iab20_21": "Mexico & Central America",
      "iab20_22": "National Parks",
      "iab20_23": "South America",
      "iab20_24": "Spas",
      "iab20_25": "Theme Parks",
      "iab20_26": "Traveling with Kids",
      "iab20_27": "United Kingdom",
      "iab21": "Real Estate",
      "iab21_1": "Apartments",
      "iab21_2": "Architects",
      "iab21_3": "Buying/Selling Homes",
      "iab22": "Shopping",
      "iab22_1": "Contests & Freebies",
      "iab22_2": "Couponing",
      "iab22_3": "Comparison",
      "iab22_4": "Engines",
      "iab23": "Religion & Spirituality",
      "iab23_1": "Alternative Religions",
      "iab23_2": "Atheism/Agnosticism",
      "iab23_3": "Buddhism",
      "iab23_4": "Catholicism",
      "iab23_5": "Christianity",
      "iab23_6": "Hinduism",
      "iab23_7": "Islam",
      "iab23_8": "Judaism",
      "iab23_9": "Latter-Day Saints",
      "iab23_10": "Pagan/Wiccan",
      "iab24": "Uncategorized",
      "iab25": "Non-Standard Content",
      "iab25_1": "Unmoderated UGC",
      "iab25_2": "Extreme Graphic/Explicit Violence",
      "iab25_3": "Pornography",
      "iab25_4": "Profane Content",
      "iab25_5": "Hate Content",
      "iab25_6": "Under Construction",
      "iab25_7": "Incentivized",
      "iab26": "Illegal Content",
      "iab26_1": "Illegal Content",
      "iab26_2": "Warez",
      "iab26_3": "Spyware/Malware",
      "iab26_4": "Copyright Infringement",
      "countHint": "The article categories you set has a chance to appear in {{count}} articles in the last seven days"
    },
    "errors": {
      "invalidSpaceName": "<1>Space name verification failed.</1>\nPlease ensure the name matches the original data and only contains the symbols <2>[</2>, <2>]</2> and <2>_</2>. If it contains other abnormal characters or spaces, it will fail to be added successfully.",
      "invalidStoreName": "<1>Store name verification failed.</1>\nPlease ensure the name matches the original data and only contains the symbols <2>[</2>, <2>]</2> and <2>_</2>. If it contains other abnormal characters or spaces, it will fail to be added successfully."
    }
  },
  "adFormat": { "instl": "Interstitial" },
  "rtbCampaignSetupStep": {
    "labels": {
      "fixOutdoorDeviceSection": "Fixed Device Option",
      "fixOutdoorStoreSection": "Fixed Store Option"
    },
    "hints": {
      "fixOutdoorDeviceSection": "The system will fix the current list of devices and make it available for download.",
      "fixOutdoorStoreSection": "The system will fix the current list of stores and make it available for download."
    }
  },
  "campaign": {
    "buttons": {
      "downloadFixOutdoorStoreData": "Download Store Info",
      "downloadFixOutdoorDeviceData": "Download Device Info",
      "importOutdoorStore": "Import Store info",
      "importOutdoorDevice": "Import Device info",
      "cancelCreate": "Cancel",
      "saveDraft": "Save Draft",
      "cancelEdit": "Cancel",
      "adTypeDisplayTitle": "Display Ads",
      "adTypeVideoTitle": "Video Ads",
      "adTypeComboTitle": "Video + Image Ads",
      "adTypeSandboxOutdoorTitle": "Sandbox Outdoor Ads",
      "adTypeSandboxMovableOutdoorTitle": "Sandbox Movable Outdoor Ad",
      "adTypePicShortTitle": "PIC Outdoor 15s Ads",
      "adTypePicLongTitle": "PIC Outdoor 30s Ads",
      "adTypePicExtendedTitle": "PIC Outdoor 60s Ads",
      "adTypePicBroadTitle": "PIC Outdoor 60+s Ads",
      "adTypeHwacomShortTitle": "HwaCom 15s Ads",
      "adTypeHwacomLongTitle": "HwaCom 30s Ads",
      "adTypeHwacomExtendedTitle": "HwaCom 60s Ads",
      "adTypeHwacomBroadTitle": "HwaCom 60+s Ads",
      "adTypeFridgeBroadTitle": "WI Fridge 60+s Ads",
      "adTypeFridgeLongTitle": "WI Fridge 30s Ads",
      "adTypeFridgeExtendedTitle": "WI Fridge 60s Ads",
      "adTypePmpPicTitle": "PMP PIC Outdoor Ads",
      "adTypePmpFridgeTitle": "PMP WI Fridge Ads",
      "adTypeThirdPartyTitle": "AdNeon Ads",
      "adTypeThirdPartyBottomTitle": "Mobile Footer Ads",
      "adTypeThirdPartyRectangleTitle": "Medium Rectangle Ads",
      "adTypeOutdoorLineMessageTitle": "Outdoor Line Message Ads",
      "adTypeLineMessageTitle": "Line Message Ads",
      "adTypeDisplayDesc": "Image│HTML5│Native│Dynamic",
      "adTypeVideoDesc": "In-Stream│Out-Stream",
      "adTypeComboDesc": "Video + Image",
      "adTypeSandboxOutdoorDesc": "Sandbox Outdoor",
      "adTypeSandboxMovableOutdoorDesc": "Sandbox Movable Outdoor",
      "adTypePicShortDesc": "PIC Outdoor 15s",
      "adTypePicLongDesc": "PIC Outdoor 30s",
      "adTypePicExtendedDesc": "PIC Outdoor 60s",
      "adTypePicBroadDesc": "PIC Outdoor 60+s",
      "adTypeHwacomShortDesc": "HwaCom 15s Ads",
      "adTypeHwacomLongDesc": "HwaCom 30s Ads",
      "adTypeHwacomExtendedDesc": "HwaCom 60s Ads",
      "adTypeHwacomBroadDesc": "HwaCom 60+s Ads",
      "adTypeFridgeBroadDesc": "WI Fridge 60+s",
      "adTypeFridgeLongDesc": "WI Fridge 30s",
      "adTypeFridgeExtendedDesc": "WI Fridge 60s",
      "adTypeOutdoorLineMessageDesc": "Outdoor Line Message",
      "adTypeLineMessageDesc": "Line Message",
      "adTypePmpPicDesc": "PMP PIC Outdoor",
      "adTypePmpFridgeDesc": "PMP WI Fridge",
      "adTypeThirdPartyDesc": "AdNeon",
      "adTypeThirdPartyBottomDesc": "Mobile Footer",
      "adTypeThirdPartyRectangleDesc": "Medium Rectangle",
      "adTypeCTVTitle": "CTV Ads",
      "adTypeCTVDesc": "Connected TV│Connected Device│Set Top Box",
      "completeAndCheck": "Complete and Check",
      "send": "Send",
      "back": "Back",
      "saveAndBindCreative": "Save And Add Creative"
    },
    "labels": {
      "adType": "Campaign type",
      "noSupportedAdType": "There are no campaign types available, please contact your system administrator to enable the corresponding feature",
      "pmpSelect": "Select PMP Order",
      "campaignSetting": "Campaign Setting",
      "summary": "Summary",
      "standard": "Standard",
      "accelerated": "Accelerated",
      "deliverType": "Deliver Type",
      "orderPrice": "- Order Price",
      "orderPriceChange": "Manager adjusts contract price\nfrom {{from}} to {{to}}",
      "adTypePageTitle": "Select Campaign Type",
      "createCampaignTitle": "Create Campaign",
      "editCampaignTitle": "Edit Campaign",
      "splitCampaignTitle": "Split Campaign",
      "copyCampaignTitle": "Copy Campaign",
      "editCampaignDraftTitle": "Edit Draft",
      "summaryCampaignTitle": "Campaign Summary",
      "videoObjective": "Video Ad Objective",
      "videoObjectiveDefault": "Default",
      "videoObjectiveProgress": "Progress",
      "videoObjectiveMetric": "Event",
      "rs": "Revenue Sharing",
      "dcpm": "Dynamic CPM",
      "fcpc": "Fixed CPC",
      "fcpm": "Fixed CPM",
      "fbcpm": "Cost Per Message",
      "fcpv": "Fixed CPV",
      "fvcpm": "Fixed vCPM",
      "facpm": "Fixed aCPM",
      "fwcpm": "Fixed wCPM",
      "rb": "RoadBlock",
      "cpc": "CPC",
      "cpm": "CPM",
      "cpv": "CPV",
      "vcpm": "vCPM",
      "fixed_viewable_impression": "Fixed Viewable Impression",
      "firstquartile": "First Quartile",
      "midpoint": "Midpoint",
      "complete": "Complete",
      "thirdquartile": "Third Quartile",
      "sec": "Sec",
      "targetClicks": "Target {{value}} Clicks",
      "targetKImpressions": "Target {{value}} k Impres",
      "targetKPublisherImpressions": "Target {{value}} k Publisher Impres",
      "targetViews": "Target {{value}} Views",
      "targetMessages": "Target {{value}} Messages",
      "tags": "Tags",
      "agencyProfit": "Agency Margin",
      "budgetPercentage": "Budget Percentage",
      "creativeDeliverType": { "optimize": "Optimize", "average": "Average" },
      "outdoorDeliverType": { "optimize": "Optimize", "average": "Average" },
      "convTrackEventclick": "Convert After Click",
      "convTrackEventview": "Convert After View",
      "convTrackEvent": "Convertion Mode",
      "hour": "hour",
      "day": "day",
      "week": "week",
      "group": { "rs": "CPC Floating Bid", "fcpc": "Fixed CPC" }
    },
    "descriptions": {
      "notWithinOrderDayRange": "The day range must be withing order's schedule time",
      "overDailyBudget": "Over Daily Budget",
      "underDailyBudget": "Under Daily Budget",
      "meetDailyBudget": "Meet Daily Budget",
      "lengthError": "Must be less than 255",
      "smallerThanBudgetZero": "Can not less than 0",
      "smallerThanDailyMnBudgetSum": "Minimum daily budget is {{dmin}}, the number of days x the daily minimum budget cannot be less than {{min}}",
      "smallerThanCampaignBudgetMinimum": "Can not less than campaign minimum budget {{min}}",
      "smallerThanBudgetMinimum": "Can not less than minimum budget {{min}}",
      "smallerThanBudgetMinimumDetail": "Can not less than minimum budget {{min}}, current allocated budget is {{budget}}",
      "smallerThanRTBBudgetMinimum": "This setting will cause the budget allocated to RTB to be lower than the minimum budget of RTB, recommended to be greater than {{min}}",
      "smallerThanSpents": "Can not less than already spent {{min}}",
      "smallerThanExpectSpents": "Can not less than expected spent {{min}}",
      "smallerThanExpectSpentsDetail": "Can not less than expected spent {{min}}, current allocated budget is {{budget}}",
      "smallerThanRTBExpectSpents": "This setting will cause the budget allocated to RTB to be lower than the expected budget of RTB, recommended to be greater than {{min}}",
      "percentSmallerThanLowerbound": "Can not less than {{min}}% of budget",
      "percentBiggerThanUpperbound": "Can not larger than {{max}}% of budget",
      "overed": "Already exceeded",
      "overBudget": "{{wording}} <1>Total budget</1><2> : {{currency}} {{overBudget}}</2>",
      "remainBudget": "Remain budget <1>{{currency}}{{remainBudget}}</1>",
      "percentBudgetHint": "Allocated budget <1>{{currency}}{{budget}}</1>",
      "orderPriceTips": "The price have to over <1>{{price}}</1>",
      "comboObjectiveDefault": "The default viewing progress is 2s",
      "videoObjectiveDefault": "The default viewing ratio is 100%",
      "videoObjectiveProgress": "Only accepts Video + Image Ad",
      "videoObjective25Event": "Only accepts InStreaming, Video + Image Ad or Outstreaming for 25%",
      "videoObjective50100Event": "Only accepts InStreaming And Video + Image Ad for 50%, 100%",
      "videoObjectiveAllEvent": "Accepts InStreaming, Video + Image Ad or Outstreaming",
      "adTypeChangeAlert": "Edit content will be reset after AdType changed, are you sure to change?",
      "campaignSchedulingDay": "Total <1>{{days}} days</1>",
      "campaignSchedulingHour": "Total <1>{{hours}} hours</1>",
      "priceMinimum": "The price have to over {{min}}",
      "bidPriceRange": "The bid price should be higher than <1>{{min}}</1> and cannot exceed the contract price <3>{{orderPrice}}</3>",
      "moreThanDays": "Day range must be less than {{days}} days",
      "moreThanHours": "Day range must be less than {{hours}} hours",
      "createBeforeNow": "The start time must be greater than now",
      "startDayBeforeOrder": "The start time must be greater than order start date",
      "endDayBeforeNow": "Cannot select past time as end time",
      "invalidValue": "This option is no longer available.",
      "budgetPercentageHoverHint": "※ If campaign is over the halfway, it can not be modified",
      "cannotEditBudgetPercentHint": "※ Campaign has already been more than half, unable to modify the budget ratio",
      "budgetPercentageRangeHint": "Only 50% of the initial value({{init}}) can be adjusted downwards, The range that can be modified is {{min}}% ~ {{max}}%.",
      "initBudgetPercentageRangeHint": "The range that can be modified is {{min}}% ~ {{max}}%.",
      "minL1ObjectBudget": "Your campaign group budget must be at least {{budget}} to account for all campaigns in this campaign group."
    },
    "prefixs": {
      "videoObjectiveProgress": "Sec",
      "videoObjectiveMetric": "Event"
    },
    "strategyAndTracking": {
      "conversionTracking": "Conversion Tracking",
      "newThirdPartyTracking": "Add Third-Party Tracking",
      "thirdPartyTracking": "Third-Party Tracking",
      "thirdPartyTrackingType": "Tracking code type",
      "thirdPartyTrackingTypePixel": "Pixel code / URL",
      "thirdPartyTrackingTypeJs": "JavaScript URL",
      "thirdPartyTrackingCode": "Tracking code",
      "thirdPartyTrackingPreview": "Parser Result",
      "videoProgressTracking": "Retargeting Tracker",
      "videoProgressTrackingCode": "Retargeting Code",
      "videoProgressTrackingCodeOffset": "Trigger Time (Second)",
      "noURL": "Parser Failed",
      "asiaMaxOnlyHint": "*Note: After adding JS type of third party tracker, only asiamax traffic can be delivered",
      "viewableImpressionTrigger": "Viewable Impression",
      "impressionTrigger": "Impressions",
      "trigger": "Trigger"
    },
    "name": "Campaign Name",
    "placeholders": {
      "tags": "Enter the content and complete the tag creation with Enter"
    },
    "errors": {
      "movableOutdoorAreaDerivationFailed": "Failed to derive administrative area for coordinates: {{coordinates}}. Please verify the coordinates are valid and try again."
    }
  },
  "campaignInfo": {
    "labels": {
      "title": "Campaign Basic Information and Price Model",
      "order": "Order",
      "campaignName": "Campaign Name",
      "dayRange": "Schedule",
      "priceModel": "Price Model",
      "totalBudget": "Total Budget",
      "dailyBudgetPlan": "Budget Distribution",
      "schedule": "Schedule",
      "daily": "Daily",
      "cannotModifyHint": "※ Cannot modify after created",
      "cannotModifyPriceModelHint": "※ Cannot modify after created",
      "dateCannotModifyHint": "※ Cannot modify start date after started",
      "optimizeTitle": "Optimize",
      "optimizeCap": "{{optimize}} Price Cap",
      "creativeDeliverType": "Creative Deliver Type",
      "outdoorDeliverType": "Outdoor Deliver Type",
      "optimize": "Optimize",
      "minimizeHint": "The price have to over {{optimizeMinimum}}",
      "frequencySessionTitle": "Frequency Session Setting",
      "sessionCapping": "Session Capping",
      "daypart": "Daypart",
      "rbPriceModelHint": "Need assign ad space",
      "isOutOfOutdoorBk": "is out of outdoor BK",
      "orderPriceEnable": "Set Order Price Manually",
      "allowOverrun": "Allow Overrun",
      "lifeHint": "The number of times an audience can watch this ad during the full advertising period",
      "bLifeHint": "The number of times an audience can watch each creative of this ad during the full advertising period",
      "sessionHint": "The number of times an audience can watch this ad in the set time period",
      "bSessionHint": "The number of times an audience can watch each creative of this ad in the set time period",
      "enableMonitor": "Enable Campaign Monitor",
      "autoBudgetOptimize": "Auto Budget Optimize",
      "autoBudgetOptimizeHint": "After turning on this feature, the system will automatically adjust the budget allocation ratio based on the performance of the ad",
      "group": { "priceModel": "RTB Price Model" },
      "CBOBudgetHint": "CBO campaign group controls the budget of campaigns, and users do not need to set a budget.",
      "backToEditRtbCampaignGroup": "Click here back to modify campaign group budget."
    },
    "hints": {
      "acceleratedDeliverType": "Note: Once enabled, the system will continuously deliver ads whenever traffic conditions are met. This may cause your budget to be exhausted much earlier than expected in a short period of time. Please evaluate this setting carefully and closely monitor your spending progress."
    }
  },
  "stepSideBar": {
    "labels": {
      "basic": "Basic",
      "targeting": "Audience Targeting",
      "strategyAndTracking": "Audience Tracking",
      "adLogo": "AdLogo",
      "creativeChooseAdvertiser": "Choose Advertiser",
      "creativeSetUp": "Set Up Creative",
      "creativeSummary": "Summary",
      "creativeBasic": "Basic Setting",
      "creativeLimitation": "Target Setting",
      "campaignSettingSummary": "Campaign Setting",
      "creativeSettingSummary": "Creative Setting"
    }
  },
  "campaignSummary": {
    "labels": {
      "adTypeDisplay": "Display Ads",
      "adTypePicShort": "PIC Outdoor 15s Ads",
      "adTypePicLong": "PIC Outdoor 30s Ads",
      "adTypePicExtended": "PIC Outdoor 60s Ads",
      "adTypePicBroad": "PIC Outdoor 60+s Ads",
      "adTypeFridgeBroad": "WI Fridge 60+s Ads",
      "adTypeFridgeLong": "WI Fridge 30s Ads",
      "adTypeFridgeExtended": "WI Fridge 60s Ads",
      "adTypeVideo": "Video Ads",
      "adTypeThirdParty": "AdNeon Ads",
      "adTypeThirdPartyBottom": "Mobile Footer Ads",
      "adTypeThirdPartyRectangle": "Medium Rectangle Ads",
      "adTypeSandboxOutdoor": "Sandbox Outdoor Ads",
      "adTypeSandboxMovableOutdoor": "Sandbox Movable Outdoor Ad",
      "adTypeOutdoorLineMessage": "Outdoor Line Message Ads",
      "adTypeLineMessage": "Line Message Ads",
      "orderName": "Order",
      "campaignName": "Campaign Name",
      "schedule": "Schedule",
      "deliverDate": "Deliver Date",
      "message": "Message",
      "pricingModel": "Pricing Model",
      "orderPrice": "{{model}} Order Price",
      "campaignBudget": "Campaign Budget",
      "budgetDistribution": "Budget Distribution",
      "budgetScheduleDistribution": "Schedule",
      "budgetDailyDistribution": "{{currency}}{{budget}} / day",
      "optimizeModel": "Optimize",
      "optimizePriceCap": "{{model}} Price Cap",
      "creativeDeliveryType": "Creative Delivery Type",
      "creativeOptimizeDelivery": "Optimize Delivery",
      "creativeUniformDelivery": "Uniform Delivery",
      "budgetPercentage": "Budget Percentage",
      "autoBudgetOptimize": "Auto Budget Optimize",
      "videoAdViewObjective": "Video Ad Objective",
      "videoAdViewObjectiveMetric": "Event : {{mertic}}",
      "videoAdViewObjectiveProgress": "Progress: {{offset}} second",
      "videoAdViewObjectiveDefault": "Default",
      "fixOutdoorSpace": "Fixed Store Option",
      "conversionTracking": "Tracking Data",
      "trackingCodes": "URL",
      "videoProgressTrackingCode": "Tracking Code",
      "videoProgressTrackingOffset": "Tracking Offset",
      "dayPart": "Daypart Setting",
      "deliverType": "Deliver Type",
      "standard": "Standard",
      "accelerated": "Accelerated",
      "tags": "Tags",
      "uniqueUserTitle": "Estimated number of weekly touches",
      "impressionTitle": "Estimated impression",
      "uniqueUserInformation": "Estimate advertising audience size per week based on the current targeting settings, the actual number of people reached will also vary depending on your budget settings.",
      "estimateDesc": "The estimated weekly touch and estimated impression may be different from the actual advertising audience size. The estimation is based on your settings in including traffic or excluding traffic:",
      "limitationNotEstimateDesc": "There is no provision of the estimated number of touch and estimated impressions for excluding or including which include segments, TenMax segments, keywords, etc.",
      "impressionInformation": "Estimate the number of impression of your ads in the future week. The actual number of impression will also vary due to budget settings.",
      "rbNotEstimateDesc": "Cannot provide the number of touch and impression when the price model is the roadblock",
      "estimateLowHint": "The optimization target setting is too strict!",
      "convTrackEventClick": "Convert After Click",
      "convTrackEventView": "Convert After View",
      "convTrackEvent": "Convertion Mode",
      "autoBid": "Auto Bid",
      "enableMonitor": "Enable Campaign Monitor",
      "group": { "pricingModel": "RTB Price Model" },
      "adTypeOneForAllDisplay": "One For All Display Ad",
      "startDate": "State Date",
      "endDate": "End Date",
      "storeDeliverable": "Deliverable stores",
      "deviceDeliverable": "Deliverable devices",
      "storeWeatherNonDeliverable": "Weather-Filtered Stores",
      "deviceWeatherNonDeliverable": "Weather-Filtered Devices",
      "storeChangeNonDeliverable": "Store Changes",
      "deviceChangeNonDeliverable": "Device Changes",
      "deviceOverBindingLimitNonDeliverable": "Devices Over Binding Limit",
      "storeOverBindingLimitNonDeliverable": "Stores Over Binding Limit"
    },
    "titles": {
      "generalInformation": "General Information",
      "optimizeSetting": "Optimize Setting",
      "advanceSetting": "Frequency And Session Setting",
      "inc": "Selected Traffic",
      "exc": "Excluded Traffic",
      "preferred": "Preferred Traffic",
      "nonPreferred": "Nonpreferred Traffic",
      "other": "Other Traffic",
      "adType": "AdType",
      "basicSetting": "Basic",
      "targetSetting": "Audience Targeting",
      "trackingSetting": "All Kinds of Tracking",
      "conversionTracking": "Use Tracking Data",
      "trackingCodes": "Tracking Code URL",
      "videoProgressTrackingCode": "Retarget Tracking",
      "checkYourSettings": "Check Your Setting",
      "adLogo": "Ad Logo",
      "storeDeliverability": "Deliverable stores / Total configured stores",
      "deviceDeliverability": "Deliverable devices / Total configured devices"
    }
  },
  "summary": {
    "titles": { "noData": "none", "generalInfo": "General Information" }
  },
  "daypart": {
    "labels": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday",
      "optionsPlaceholder": "Select a Preset",
      "am": "AM",
      "pm": "PM",
      "hourUnit": "hour",
      "allDay": "All Day",
      "afternoon": "Afternoon",
      "evening": "Evening",
      "morning": "Morning",
      "weekday": "Weekday",
      "weekend": "Weekend",
      "conversionOptimize": "Conversion Optimize 1",
      "midnightDisabled": "Midnight Disabled",
      "mobileOptimize": "Mobile Optmize",
      "pcOptimize": "PC Optimize"
    },
    "segments": {
      "h00": "00:00 - 05:59",
      "h06": "06:00 - 11:59",
      "h12": "12:00 - 17:59",
      "h18": "18:00 - 23:59"
    }
  },
  "errorPage": {
    "labels": {
      "403": "Sorry ! You don‘t have permission to access this page,<1/>\nmaybe you <3>can switch to the role has authority</3>, OR...",
      "404": "Oops ! We can’t find this page,<1/> maybe you can <3>browse other resource</3>, OR...",
      "back": "Go Back",
      "contact": "Contact Us"
    }
  },
  "orderDetail": {
    "labels": {
      "orderNumber": "Order ID",
      "orderType": "Order Type",
      "externalId": "External ID",
      "externalType": "External Type",
      "dateRange": "Schedule",
      "remainDays": "Remaining Days",
      "today": "Today",
      "totalBudget": "Budget",
      "alreadySpent": "Spent",
      "remainBudget": "Remaining Budget",
      "progress": "In Progress",
      "agencyProfit": "Agency Margin",
      "impres": "Impress",
      "viewable": "Viewable Impress",
      "clicks": "Clicks",
      "ctr": "CTR",
      "adView": "View",
      "viewRate": "View Rate",
      "originBudget": "{{budget}} (origin budget)",
      "changeBudget": "{{budget}} (reviewing)",
      "originProfit": "{{profit}} % (origin margin)",
      "changeProfit": "{{profit}} % (reviewing)",
      "days": "{{days}} days",
      "settleWait": "Please waiting to settle",
      "settledNoNeedSettle": "The order has been seattled",
      "settleSuccess": "Settle Success",
      "unsettleSuccess": "Unsettle Success",
      "creator": "Creator",
      "creatorEmail": "Creator Email",
      "monitor": "Order Monitor",
      "channelMargin": "{{channel}} Agency Margin",
      "title": "Order And Campaign List",
      "name": "Order name: {{name}}",
      "hasRunningCampaignCannotSettle": "Campaign not start or running / stopping can not settle",
      "finished": "Already Finished",
      "notstart": "Not started",
      "isEndCannotCreate": "Cannot create campaign if order has been ended",
      "orderStateCannotCreate": "Cannot create campaign when order state is not approve, seattle or seattled",
      "lessThanBudgetMinimum": "Remaining budget less than {{budget}}",
      "report": "Ad Performance",
      "generalReport": "General Report",
      "videoReport": "Video Report",
      "downloadRtbReport": "Download RTB Report",
      "downloadOutdoorReport": "Download Outdoor Report",
      "editOrder": "Edit Order",
      "waitingForReview": "Waiting For Review",
      "reject": "Reject",
      "settle": "Settle",
      "settled": "Settled",
      "approve": "Approve",
      "status": "Status",
      "approveSuccess": "Approve Success",
      "rejectSuccess": "Reject Success",
      "modifyReason": "Modify Reason",
      "orderPrice": "CPM Order Price",
      "creativeDuration": "Creative Duration Prediction",
      "dayPart": "Daypart Setting"
    },
    "errors": {
      "budgetExceedStoredValueError": "Insufficient stored value, budget cannot be greater than {{amount}}"
    },
    "buttons": { "settle": "Settle", "unsettle": "Unsettle" },
    "tabs": {
      "campaign": "Campaign",
      "campaignControl": "Budget Allocation Group",
      "record": "Record"
    }
  },
  "orderForm": {
    "errors": {
      "budgetExceedStoredValueError": "Insufficient stored value, budget cannot be greater than {{max}}",
      "endDateError": "Cannot select past date as end date",
      "finalReport": {
        "receivers": "Contains invalid emails: {{invalidEmails}}"
      },
      "projectNamePatternError": "Onelink campaign name must be a CamelCase alphanumeric string without symbols or blanks"
    },
    "labels": {
      "advertiser": "Advertiser",
      "name": "Order Name",
      "externalId": "External ID",
      "dateRange": "Date Range",
      "dateCannotModifyHint": "※ Cannot modify start date after started",
      "totaldates": "total {{num}} days",
      "budget": "Budget",
      "orderMargin": "Agency Margin",
      "remark": "Remark",
      "createTitle": "Add Order",
      "modifyReason": "Modify Reason",
      "modifyMargin": "Modify Margin",
      "modifyCancel": "Cancel Change",
      "modifyBudget": "Modify Budget",
      "editTitle": "Edit Order",
      "externalType": "External Type",
      "campaignMinDateError": "Order start time cannot be later than the start time of any campaign",
      "campaignMaxDateError": "Order end time cannot be earlier than the end time of any campaign",
      "monitor": "Order Monitor",
      "creditHint": "The current credit limit has reached the upper limit {{credit}}, waiting for management",
      "orderPrice": "CPM Order Price",
      "creativeDuration": "Creative Duration",
      "daypart": "Daypart Setting",
      "basic": "Basic Setting",
      "outdoor": "Outdoor Setting",
      "finalReport": {
        "projectName": "One Link Campaign Name",
        "projectType": "Advertiser Type",
        "receivers": "Recipients",
        "sendOutDate": "Send Out Date",
        "advertiserName": "Advertiser Name",
        "targetType": "Target Type",
        "targetValue": "Target Value",
        "targetImpressions": "Target Impressions"
      }
    },
    "placeholders": {
      "finalReport": { "receivers": "email address of the recipient" }
    },
    "titles": { "finalReport": "Final Report" },
    "hints": {
      "finalReport": {
        "projectName": "※ This project name has been used before"
      }
    }
  },
  "orderList": {
    "headers": {
      "orderNumber": "Name and ID",
      "advertiser": "Advertiser",
      "targetBudget": "Budget",
      "spent": "Spent",
      "remainingDay": "Remaining Days",
      "progress": "Progress",
      "state": "Approval",
      "endDate": "End Date",
      "externalId": "ExternalID",
      "noDataAvailable": "No Order"
    },
    "labels": {
      "copyYahooOrderNameSuccess": "Already copy order ID and Name",
      "editHint": "Edit Order",
      "copyYahooOrderNameHint": "Copy Verizon Order Name",
      "reportHint": "View Report",
      "creatorInformation": "Creator Information",
      "creator": "Creator",
      "creatorEmail": "E-mail",
      "createDateTime": "Created Time",
      "stateFilterMenuTitle": "Select State",
      "progressNormal": "Normal {{count}}",
      "progressNotStart": "Not Start {{count}}",
      "progressBehind": "Behind {{count}}",
      "progressSeverelyBehind": "Severely Behind {{count}}",
      "progressOver": "Over {{count}}",
      "progressAhead": "Ahead {{count}}",
      "filterList": "Filter Menu",
      "stateFilter": "Delivery",
      "tagFilter": "Tags",
      "tagFilterMenuTitle": "Select Tag",
      "stateTag": "Delivery",
      "tagTag": "Tag",
      "remainBudget": "Remain Budget"
    },
    "placeholders": { "searchbar": "Order name, Order ID or External ID" }
  },
  "campaignList": {
    "headers": {
      "nameColumn": "Name",
      "stateColumn": "Status",
      "typeColumn": "AdType",
      "scheduleColumn": "Schedule",
      "progressColumn": "Progress",
      "budgetColumn": "Budget and Distribute",
      "budgetDistributionColumn": "Budget Distribute",
      "priceModel": "Price Model",
      "limitationColumn": "Limitation Setting",
      "trackingColumn": "Audience Tracking",
      "campaignControlColumn": "Budget Allocation Group",
      "tagsColumn": "Custom Tags",
      "impresColumn": "Impressions",
      "viewableColumn": "Viewable Impres",
      "clicksColumn": "Clicks",
      "cpcColumn": "CPC",
      "ctrColumn": "CTR",
      "vctrColumn": "VCTR",
      "convertColumn": "Conversions",
      "cpaColumn": "CPA",
      "cvrColumn": "CVR",
      "viewColumn": "Video View",
      "viewRateColumn": "Video View Rate",
      "viewableViewRateColumn": "Video Viewable View Rate",
      "creativeColumn": "Creative",
      "uuCountColumn": "Unique Users",
      "priceGroupColumn": "Price Model",
      "deliveryColumn": "Delivery",
      "optimize": "Optimization & Delivery",
      "resultsColumn": "Results",
      "spents": "Spent"
    },
    "labels": {
      "createCampaignBtn": "+ Campaign",
      "stateFilterMenuTitle": "Select State",
      "tagFilterMenuTitle": "Select Tag",
      "adTypeThirdParty": "AdNeon",
      "adTypeThirdPartyRectangle": "Medium Rectangle",
      "adTypeThirdPartyBottom": "Mobile Footer",
      "adTypeVideo": "Video",
      "adTypeDisplay": "Display",
      "adTypePicShort": "PIC Outdoor 15s Ads",
      "adTypePicLong": "PIC Outdoor 30s Ads",
      "adTypePicExtended": "PIC Outdoor 60s Ads",
      "adTypePicBroad": "PIC Outdoor 60+s Ads",
      "adTypeHwacomShort": "HwaCom 15s Ads",
      "adTypeHwacomLong": "HwaCom 30s Ads",
      "adTypeHwacomExtended": "HwaCom 60s Ads",
      "adTypeHwacomBroad": "HwaCom 60+s Ads",
      "adTypeFridgeBroad": "WI Fridge 60+s Ads",
      "adTypeFridgeLong": "WI Fridge 30s Ads",
      "adTypeFridgeExtended": "WI Fridge 60s Ads",
      "adTypePmpPic": "PMP PIC Outdoor Ads",
      "adTypePmpFridge": "PMP WI Fridge Ads",
      "adTypeCombo": "Video + Image",
      "adTypeCTV": "CTV",
      "adTypeKeyword": "Keyword",
      "adTypeEmpty": "Uncategorized",
      "adTypeSandboxOutdoor": "Sandbox Outdoor",
      "adTypeSandboxMovableOutdoor": "Sandbox Movable Outdoor Ad",
      "adTypeOutdoorLineMessage": "Outdoor Line Message",
      "adTypeLineMessage": "Line Message",
      "activateState": "Active",
      "deactivateState": "Inactive",
      "deleteState": "Deleted",
      "pendingReviewState": "Pending Review",
      "withIssues": "With Issues",
      "stoppingState": "Stopping",
      "pmpInactiveState": "PMP Inactive",
      "pmpEndState": "PMP End",
      "pmpExpiredState": "PMP Expired",
      "pmpExpiredHint": "RTB Campaign is expired since creatives failed approval before PMP order begins",
      "draftStateHint": "The draft has not yet been published",
      "schedule": "{{start}}<1/>to<3/>{{end}}",
      "budget": "Budget",
      "distribute": "Distribute",
      "budgetSchedule": "Schedule",
      "budgetDailyDistribution": "{{currency}} {{budget}} / day",
      "bidPriceDes": "Price Cap {{currency}} {{price}}",
      "conversionTracking": "Tracking Data",
      "viewTrackingCodes": "Third-Party Tracking",
      "videoProgressTrackingCode": "Retarget Tracking",
      "campaignCount": "Campaign {{count}}",
      "campaignBudget": "Total budget {{number}}",
      "emptyContent": "No Data",
      "creativeAmount": "Creative {{count}}",
      "pmpChangedState": "PMP Changed",
      "pmpChangedHint": "View PMP Changed",
      "limitation": "Limitation",
      "addLimitation": "Add Limitation",
      "removeLimitation": "Remove Limitation",
      "summaryCampaign": "Campaign Summary Page",
      "deliverStandard": "Standard",
      "deliverAsap": "Accelerated",
      "deliverType": "Deliver Type",
      "noData": "No data, let ’s add a new campaign",
      "noCreativesState": "No Creatives",
      "budgetRemainState": "Budget Remain",
      "partialStoreChange": "Partial Store Numbers Changed",
      "allStoreChange": "All Store Numbers Changed",
      "allWeatherFiltered": "All Weather Conditions Do Not Match",
      "partialWeatherFiltered": "Some Weather Conditions Do Not Match",
      "endState": "End",
      "notStartState": "Not Start",
      "editHint": "Edit Campaign",
      "cloneHint": "Clone Campaign",
      "splitHint": "Split Campaign",
      "reportHint": "View Report",
      "creativeEditHint": "Manage creatives",
      "creativeViewHint": "View creatives",
      "priceModel": "Price model",
      "campaignControlName": "Name",
      "optimize": "Optimize Mode",
      "priceCap": "Price Cap",
      "autoBid": "Auto Bid",
      "filterList": "Filter Menu",
      "tagFilter": "Tags",
      "tagTag": "Tag",
      "bidPriceChange": "Bid cap changed\nfrom {{from}} to {{to}}",
      "deliveringStoreRatio": "Delivering / Configured Stores",
      "deliveringDeviceRatio": "Delivering / Configured Devices",
      "notDelivering": "Not Delivering",
      "weatherMismatch": "Weather Mismatch",
      "storeChange": "Store Changes",
      "deviceChange": "Device Changes",
      "limitationDetail": "Show Limitation Detail",
      "edit": "Edit",
      "creative": "Creative",
      "batchEdit": "Batch Edit",
      "bindCreative": "Bind Creative",
      "deactivateCreative": "Deactivate",
      "activeCreative": "Activate",
      "activeCampaign": "Activate",
      "activeSuccess": "Activate Success",
      "activeFailed": "Activate Failed",
      "deactiveSuccess": "Deactivate Success",
      "deactiveFailed": "Deactivate Failed",
      "deleteSuccess": "Delete Success",
      "deactivateCampaign": "Deactivate",
      "selected": "Selected",
      "canSplitMinimum": "Campaign Budget less than the minimum splittable amount: {{budget}}",
      "adTypeNotSupportCopy": "This ad type does not yet support copy functionality",
      "adTypeNotSupportSplit": "This ad type does not yet support split functionality",
      "batchEditMultiTypeError": "Cannot batch edit different types of campaigns",
      "unknowTypeBatchEditError": "Unknow campaign type cannot batch edit",
      "batchEditDraftError": "Draft cannot batch edit",
      "cannotDelete": "Cannot delete a campaign which already bind creatives",
      "deleteCampaign": "Delete",
      "deleteDraft": "Delete Drafts",
      "deleteCampaignModalTitle": "Delete Campaigns",
      "deleteCampaignModalContent": "Are you sure you want to delete selected campaigns?\nThis action cannot be undone.",
      "deleteDraftModalTitle": "Delete Drafts",
      "deleteDraftModalContent": "Are you sure you want to delete selected drafts?\nThis action cannot be undone.",
      "mixDeleteModalTitle": "Delete Campaigns And Drafts",
      "mixDeleteModalContent": "Are you sure you want to delete selected campaigns and drafts?\nThis action cannot be undone.",
      "rtbPriceCap": "RTB Price Cap",
      "manageBidWeightModalTitle": "Manage Bid Weight",
      "updateBidWeightSuccess": "Update bid weight success",
      "updateAdminBidPriceSuccess": "Update bid price success",
      "adTypeOneForAllDisplay": "One For All Display Ad",
      "canCopyNeedMore": "{{parent}} budget still need {{budget}} more to copy this campaign.",
      "minBudgetRequiredHint": "To activate the inactive campaigns, the campaign group requires more budget : {{margin}}",
      "hasRejectedAd": "One or more ad creatives have been rejected. See ad list for details.",
      "duplicate": "Duplicate",
      "allStoreOverBindingLimit": "All Over Binding Limit",
      "epaperNotActivatableHint": "Some selected campaigns lock devices that are already bound by 10 campaigns. Edit the campaign to remove the over-limit spaces before activating.",
      "partialStoreOverBindingLimit": "Partially Over Binding Limit"
    },
    "hints": { "manageAdminBidPrice": "Modify Bid Price Setting" },
    "tabs": {
      "basic": "Basic",
      "performance": "Performance",
      "auditLog": "Audit Log",
      "videoPerformance": "Video Performance",
      "rtb_video_performance": "Video Performance"
    },
    "placeholders": { "searchbar": "Search Campaign Name and ID..." }
  },
  "l2ObjectList": {
    "labels": {
      "objectTypeFilterMenuTitle": "Select Object Type",
      "objectTypeFilter": "Object Types",
      "objectTypeTag": "Type",
      "ordinaryCampaign_rtb": "Campaign",
      "draft": "Draft",
      "editDraft": "Edit Draft",
      "statusFilter": "Status",
      "statusFilterMenuTitle": "Select Status",
      "statusTag": "Status",
      "deliveryFilter": "Delivery Status",
      "deliveryFilterMenuTitle": "Select Delivery Status",
      "deliveryTag": "Delivery Status"
    }
  },
  "order": {
    "status": {
      "notapprove": "Pending Approval",
      "reject": "Reject",
      "approvenotstart": "Approved",
      "approvestart": "Approved",
      "approve": "Approved",
      "stop": "Closed",
      "delete": "Delete",
      "invalid": "Invalid",
      "changepending": "Order changed, waiting for approval",
      "settle": "Order settling",
      "settled": "Order has been settled",
      "active": "Active",
      "deactive": "Deactive"
    },
    "finalReport": {
      "targetType": {
        "impression": "Impression",
        "click": "Click",
        "conversion": "Conversion",
        "view": "Video Views"
      }
    }
  },
  "creativeOverviewStateContent": {
    "buttons": {
      "bind": "Bind Creative",
      "new": "New Creative",
      "actionTips": "Creatives with an effecitve status of \"in processing\" are not allowed to change",
      "pmpDeactiveTips": "PMP campaigns do not allow all creatives to be deactivated",
      "active": "Active",
      "deactive": "Deactive",
      "singleActiveBindTips": "A creative is already active. Deactivate it before binding another one.",
      "singleActiveActivateTips": "Only one creative can be active at a time. Deactivate the current one first.",
      "singleActiveCreateTips": "A creative is already active. Deactivate it before creating another one.",
      "epaperSpaceQuotaFullTips": "This campaign locks devices that are already bound by 10 campaigns. Edit the campaign to remove the over-limit spaces first.",
      "epaperSpaceQuotaFullTipsWithCampaigns": "Campaigns {{names}} lock devices that are already bound by 10 campaigns. Remove the over-limit spaces from those campaigns, or change your selection."
    },
    "tags": { "selectedTip": "{{count}} Selected" },
    "tooltip": { "notAllowUnkown": "AdType not allowed" }
  },
  "campaignCreativeList": {
    "headers": {
      "creativeName": "Creative Name",
      "creativePreview": "Creative Preview",
      "creativeStatus": "Status",
      "ctr": "CTR",
      "vctr": "VCTR",
      "vtr": "VTR",
      "imps": "Impress",
      "clicks": "Clicks",
      "vimps": "vImpress",
      "view": "View",
      "typeAndSize": "Type & Size",
      "approvalStatus": "Approval Status",
      "effectiveStatus": "Delivery",
      "creativeLayout": "Layout",
      "noDataAvailable": "No Creative",
      "results": "Results",
      "uu": "Unique Users"
    },
    "labels": {
      "copyImaxShortcutSuccess": "Already copy shortcut URL",
      "emptyShortcutUrl": "Do not have valid shortcut URL",
      "editHint": "Edit Creative",
      "copyShortcutHint": "Copy Shortcut",
      "reportHint": "View Report",
      "cannotEditCustomCreativeHint": "The ads would be non-editable if users have edited the their creatives on self-serve platform.",
      "noData": "No data, let ’s bind a new creative",
      "noDataWithoutAddPermission": "No data to browse"
    }
  },
  "creativeList": {
    "labels": {
      "demoPageHint": "Go to Demo Page",
      "beforeStartTime": "Before Start Time",
      "afterEndTime": "After End Time",
      "none": "none",
      "notBindYet": "Not Bind Yet",
      "reviewSuccess": "Review Success",
      "reviewFailed": "Review Failed",
      "noData": "No data, let ’s add a new creative",
      "newCreative": "+ Creative",
      "bindEnable": "Enable {{count}}",
      "bindDisable": "Disable {{count}}",
      "selected": "Selected",
      "unlimited": "Unlimited",
      "bindingCampaign": "Bind Status",
      "enableBindState": "Enable",
      "disableBindState": "Disable",
      "copyCreative": "Copy",
      "nameIdSummary": "Creatives {{count}}",
      "updateYahooIdsSuccess": "Update Verizon AD ID Success",
      "yahooIdEditTitle": "Edit Verizon AD ID",
      "enableStartTime": "Start Date",
      "enableEndTime": "End Date",
      "yahooIdBind": "Aready bind Verizon AD ID",
      "updateBindStateSuccess": "Update Bind Status Success",
      "cloneCreativeSuccess": "Clone Creative Success",
      "deleteCreativeSuccess": "Delete Creative Success",
      "cannotDeleteHint": "Cannot delete a creative which has bound",
      "cannotCloneHint": "Cannot clone a creative which is processing",
      "editHint": "Edit Creative",
      "cloneHint": "Clone Creative",
      "editYahooIdHint": "Edit Verizon AD ID",
      "deleteHint": "Delete Creative",
      "previewHint": "Preview creative for publication",
      "cannotUnBindSomeCreative": "The following creatives cannot be deactivated because they are bound to a PMP campaign and the campaign has no other deliverable creatives: {{ creatives }}",
      "deleteModalTitle": "Delete Creative",
      "deleteModalContent": "Are you sure you want to delete selected creative?",
      "skippable": "Skippable",
      "nonSkippable": "Non Skippable",
      "skipOffset": "{{offset}} seconds",
      "inStream": "In-Stream (Pre-Roll)",
      "outStream": "Out-Stream",
      "approvalDefault1": "Image",
      "approvalDefault2": "HTML5",
      "approvalDefault3": "Native",
      "approvalDefault4": "Video",
      "approvalDefault8": "AdNeon",
      "approvalDefault10": "Video + Image",
      "approvalDefault11": "EdiMax Outdoor",
      "approvalDefault26": "PIC Outdoor 15s",
      "approvalDefault27": "PIC Outdoor 30s",
      "approvalDefault12": "RTB Native",
      "approvalDefault13": "One For All Display",
      "approvalDefault14": "One For All Display",
      "approvalDefault15": "One For All Display",
      "approvalDefault23": "CTV",
      "approvalDefault28": "Native",
      "approvalCtv": "CTV",
      "approvalDesktop": "Desktop",
      "approvalMobile": "Mobile",
      "creativeCount": "Creative {{count}}",
      "approvalDefault16": "One For All - Video",
      "archivedActionHint": "This creative is archived and this action is unavailable.",
      "archivedNotice": "This creative has passed its retention period and is no longer in use. It can no longer be edited or bound.",
      "noMatchData": "No matching creatives"
    },
    "placeholders": { "searchbar": "Creative name or ID" },
    "headers": {
      "bannerId": "Creative Name & ID",
      "bindingCampaign": "Usage State",
      "approvalStatus": "Creative Format And Approval State",
      "preview": "Creative Preview",
      "adTitle": "Creative Title",
      "adDesc": "Creative Description",
      "bannerUrl": "Landing URL",
      "sponsor": "Sponsor",
      "limitations": "Target Setting",
      "streamingSetting": "Video Placement",
      "oneForAllClickUrl": "Click URL",
      "rtbClickUrl": "RTB Click URL",
      "ppsLayoutId": "Layout ID",
      "message": "Message",
      "shortMessage": "Short Message",
      "skipSetting": "Skip Setting",
      "outdoorType": "Outdoor Ad Type",
      "duration": "Creative Duration",
      "status": "Status",
      "delivery": "Delivery",
      "adneonLayout": "Layout"
    },
    "filter": {
      "statusFilter": "Status",
      "statusFilterMenuTitle": "Select creative status",
      "statusTag": "Status"
    },
    "status": { "active": "Active", "all": "All", "archived": "Archived" }
  },
  "bindCreativeStateContent": {
    "placeholders": { "searchbar": "Search creative name or id" },
    "buttons": {
      "newToOld": "New To Old",
      "oldToNew": "Old To New",
      "native": "Native Ad",
      "selected": "Selected",
      "allSelected": "All Selected"
    },
    "labels": {
      "title": "Bind Creative",
      "image": "RTB Image",
      "html5": "Html",
      "native": "Native",
      "video": "Video",
      "dynamic": "Dynamic",
      "flash": "Flash",
      "third_party": "AdNeon",
      "combo": "Video + Image",
      "edimax": "EdiMax Outdoor Ads",
      "pic_short": "PIC Outdoor 15s Ads",
      "pic_long": "PIC Outdoor 30s Ads",
      "pic_extended": "PIC Outdoor 60s Ads",
      "pic_broad": "PIC Outdoor 60+s Ads",
      "hwacom_short": "HwaCom 15s Ads",
      "hwacom_long": "HwaCom 30s Ads",
      "hwacom_extended": "HwaCom 60s Ads",
      "hwacom_broad": "HwaCom 60+s Ads",
      "fridge_braod": "WI Fridge 60+s Ads",
      "fridge_long": "WI Fridge 30s Ads",
      "fridge_extended": "WI Fridge 60s Ads",
      "one_for_all": "One For All - Display",
      "one_for_all_display": "One For All - Display",
      "one_for_all_display_ios": "One For All - Display",
      "one_for_all_display_android": "One For All - Display",
      "ctv": "CTV",
      "custom_bottom": "Custom Bottom",
      "custom_rectangle": "Custom Rectangle",
      "sandbox_outdoor": "Sandbox Outdoor Ads",
      "outdoor_line_message": "Outdoor Line Message Ads",
      "line_message": "Line Message Ads",
      "one_for_all_video": "One For All - Video",
      "one_for_all_video_ios": "One For All - Video",
      "one_for_all_video_android": "One For All - Video",
      "singleCreativeTips": "Only one creative can be bound at a time for e-paper channel. Please deselect the others."
    }
  },
  "creativeCard": { "labels": { "createTime": "Created at {{time}}" } },
  "batchEditCampaignTitle": {
    "title": "Editing {{num}} campaigns",
    "labels": { "subTitle": "Campaign Name" }
  },
  "batchEditCampaignSummary": {
    "labels": { "checkYourSettings": "Check Your Settings" },
    "titles": { "trackingSummary": "All Kinds of Tracking" }
  },
  "creativeSummmaryStateContent": { "title": "Bind Creative" },
  "creative": {
    "approval": { "no": { "record": "No Record" } },
    "list": { "filter": { "all": "All" } },
    "change": { "confirmation": "Creatives Change Confirmation" },
    "binding": { "status": "Creatives Binding Status" },
    "compositeSetting": {
      "invalidHint": "The creative display size setting is invalid. Please ask a system administrator to check the sales channel settings."
    },
    "status": {
      "enable": "Active",
      "disable": "Inactive",
      "waitingActivate": "Activating",
      "waitingDeactivate": "Deactivating",
      "default": "Activating",
      "processing": "Processing",
      "processingFailed": "Processing Failed",
      "archived": "Archived"
    }
  },
  "creativeOverviewState": {
    "labels": {
      "activeSuccess": "Activate Success",
      "activeFailed": "Activate Failed",
      "deactiveSuccess": "Deactivate Success",
      "deactiveFailed": "Deactivate Failed"
    }
  },
  "creativeSummaryState": { "labels": { "modifySuccess": "Modify Success" } },
  "orderHome": {
    "labels": {
      "title": "Orders with Campaigns",
      "advertiserListTitle": "Advertiser"
    }
  },
  "recentGroupDropdown": {
    "labels": {
      "useRecently": "Use Recently",
      "otherAdvertiserId": "Other Advertisers",
      "otherMerchantId": "Other Merchants",
      "otherAgencyId": "Other Agencys",
      "otherRestaurantId": "Other Restaurants",
      "otherBeaconConnectionId": "Other Official Accounts"
    }
  },
  "groupOptionsSelection": {
    "labels": {
      "selectAllAdvertiserId": "All Advertisers",
      "selectAllMerchantId": "All Merchants",
      "selectAllAgencyId": "All Agencies",
      "selectAllRestaurantId": "All Restaurants",
      "selectAllBeaconConnectionId": "All Official Accounts",
      "pleaseChooseAdvertiserId": "Please choose advertiser...",
      "pleaseChooseMerchantd": "Please choose Merchant...",
      "pleaseChooseAgencyId": "Please choose agency...",
      "pleaseChooseRestaurantId": "Please choose restaurant...",
      "pleaseChooseBeaconConnectionId": "Please choose official account ...",
      "searchAdvertiserId": "Search Advertiser Name",
      "searchMerchantId": "Search Merchant Name",
      "searchAgencyId": "Search Agency Name",
      "searchRestaurantId": "Search Restaurant Name",
      "searchBeaconConnectionId": "Search Official Account Name  ..."
    }
  },
  "orders": { "labels": { "newOrder": "+ Order" } },
  "modifyCreativeActivationStateContent": {
    "labels": {
      "chooseActivate": "Choose creatives to activate",
      "chooseDeactivate": "Choose creatives to deactivate"
    }
  },
  "downloadReportPanel": {
    "labels": {
      "cpmClosingReport": "CPM Closing Report",
      "cpcClosingReport": "CPC Closing Report",
      "normal": "Custom Schedule Report",
      "closing": "All Schedule Report",
      "downloadReport": "Download Report",
      "downloadOutdoorReport": "Download Outdoor Report",
      "dateRange": "Date Range",
      "reportType": "Report Type",
      "advance": "Custom Report",
      "dataContent": "Data Content",
      "quickSelect": "Quick pick",
      "videoAdViewObjective": "Video Ad Objective",
      "cpmOption": "CPM Pricing",
      "cpcOption": "CPC Pricing",
      "cpaOption": "CPA Pricing",
      "videoOption": "Video Ad",
      "outdoorOption": "Outdoor Ad",
      "outdoorDeviceOption": "Outdoor Device Advertising Information",
      "outdoorDeviceBeaconOption": "Outdoor Device Advertising Information (Line Simple Beacon)",
      "lineMessageOption": "Line Message Report",
      "rawDataOption": "Raw Data",
      "reset": "Reset",
      "firstQuartile": "First Quartile",
      "midPoint": "Midpoint",
      "thirdQuartile": "Third Quartile",
      "complete": "Complete",
      "audienceData": "Audience Data",
      "gender": "Gender",
      "age": "Age",
      "interest": "Interests",
      "impress": "Impression",
      "viewable": "Viewable",
      "uu": "Unique User",
      "click": "Clicks",
      "ctr": "CTR",
      "viewableCtr": "VCTR",
      "adView": "VIew",
      "viewRate": "View Rate",
      "viewableViewRate": "Viewable View Rate",
      "convs": "Conversions",
      "spent": "Spent",
      "cpm": "CPM",
      "cpc": "CPC",
      "cpv": "CPV",
      "cpa": "CPA",
      "groupBy": "Group By",
      "groupByCreative": "Creative",
      "groupByCampaign": "Campaign",
      "groupByL1Object": "Campaign Group",
      "audienceDataHint": "The audience data is the accumulated data during the entire order duration and is not affected by the date interval.",
      "beaconEvents": "Beacon Data",
      "ePublisherImpres": "Publisher Impressions",
      "acpm": "aCPM",
      "acpmOption": "aCPM Pricing",
      "country": "Country",
      "domain": "Domain",
      "deliveryBrief": "Delivery Data Brief",
      "reportDateRange": "Report Period",
      "format": "Format",
      "uniqueUserCount": "Unique Users",
      "averageViewRate": "Average View Rate",
      "averageCtr": "Average CTR"
    },
    "buttons": { "download": "Download" },
    "placeholders": { "reportType": "Select Report Type" },
    "errors": {
      "fieldRequired": "{{field}}: {{checkedDependentFields}} requires information of this field",
      "dateRangeOutOfOrderPeriod": "The period must be within the order schedule ({{start}} ~ {{end}})"
    }
  },
  "limitationOptions": {
    "labels": {
      "gender": { "1": "Male", "2": "Female" },
      "spaceType": { "1": "Site", "2": "App" },
      "carrier": {
        "chunghwa": "Chunghwa",
        "taiwan_mobile": "Taiwan Mobile",
        "far_eastone": "Far EasTone",
        "taiwan_star": "Taiwan Star",
        "asia_pacific": "Asia Pacific",
        "viettel": "Viettel",
        "mobifone": "MobiFone",
        "vinaphone": "Vinaphone",
        "vietnamobile": "Vietnamobile"
      },
      "contentlang": {
        "zh": "Chinese",
        "en": "English",
        "vi": "Vietnamese",
        "th": "Thai",
        "es": "Spanish",
        "ja": "Japanese",
        "mg": "Malay",
        "ko": "Korean",
        "id": "Indonesian"
      },
      "device": {
        "2": "PC",
        "3": "Connected TV",
        "4": "Phone",
        "5": "Tablet",
        "6": "Connected Device",
        "7": "Set Top Box",
        "smartphone": "Smartphone",
        "tablet": "Tablet"
      }
    }
  },
  "tenmaxCategory": {
    "labels": {
      "others": "Others",
      "3c": "3C",
      "telecom": "Telecom",
      "home_appliance": "Home Appliance",
      "mobile_app": "Mobile App",
      "computer_software": "Computer Software",
      "pharmacy": "Pharmacy",
      "diet": "Diet",
      "medical_care": "Medical Care",
      "career": "Career",
      "e_commerce": "EC",
      "shopping": "Shopping",
      "aviation": "Aviation",
      "travel": "Travel",
      "baby": "Baby",
      "automobile": "Automobile",
      "automobile1": "Car",
      "insurance": "Insurance",
      "real_estate": "Real Estate",
      "loan": "Loan",
      "investment": "Investment",
      "investment_activities": "Investment Activities",
      "credit_card": "Credit Card",
      "media": "Media",
      "social_media": "Social Media",
      "dessert": "Dessert",
      "restaurant": "Restaurant",
      "wine": "Wine",
      "home_decoration": "Home Decoration",
      "cook": "Cook",
      "cleaning": "Cleaning",
      "beverage": "Beverage",
      "snack": "Snack",
      "fast_food": "Fast Food",
      "science": "Science",
      "science_activity": "Science Activity",
      "books": "Books",
      "graphic_art": "Graphic Art",
      "cosmetics": "Cosmetics",
      "women_clothing": "Women Clothing",
      "men_clothing": "Men Clothing",
      "luxary": "Luxary",
      "beauty": "Beauty",
      "accessory": "Accessory",
      "surgery": "Surgery",
      "news": "News",
      "government": "Government",
      "government_communications": "Government Communications",
      "politics": "Politics",
      "regime": "Regime",
      "pet": "Pet",
      "toy": "Toy",
      "music": "Music",
      "movie": "Movie",
      "outdoor_activities": "Outdoor Activities",
      "drama": "Drama",
      "game": "Game",
      "sport": "Sport",
      "society": "Society",
      "sexuality": "Sexuality",
      "exhibition": "Exhibition",
      "immigration": "Immigration",
      "motobike": "Motobike",
      "saas": "SaaS",
      "social_issue": "Social Issue",
      "social_welfare": "Social Welfare",
      "technology_art": "Technology Art",
      "iab1": "Arts & Entertainment",
      "iab19": "Computers & Electronics",
      "iab13": "Finance",
      "iab9_30": "Games",
      "iab10": "Home & Garden",
      "iab3": "Business & Industrial",
      "iab19_18": "Internet & Telecom",
      "iab14_1": "People & Society",
      "iab12": "News",
      "iab22": "Shopping",
      "iab11": "Law & Government",
      "iab17": "Sports",
      "iab1_1": "Books & Literature",
      "iab21": "Real Estate",
      "iab14": "Online Communities",
      "iab18": "Beauty & Fitness",
      "iab7": "Health",
      "iab2": "Autos & Vehicles",
      "iab4": "Jobs & Education",
      "iab9": "Hobbies & Leisure",
      "iab16": "Pets & Animals",
      "iab20": "Travel",
      "iab8": "Food & Drink",
      "iab19-12": "Reference",
      "iab15": "Science",
      "logistics": "Logistics",
      "education": "Education",
      "wedding": "Wedding",
      "daily_necessities": "Daily Necessities",
      "shoes": "Shoes",
      "women_talk": "Women Talk",
      "energy": "Energy"
    }
  },
  "creativeSetupFlow": {
    "labels": {
      "advertiser": "Advertiser",
      "nextStep": "Next Step",
      "name": "Creative Name",
      "title": "Ad Title",
      "desc": "Ad Description",
      "message": "Ad Message",
      "shortMessage": "Ad Short Message",
      "landingPageUrl": "Landing Page URL",
      "sponsor": "Sponsored Name",
      "sponsorLink": "Sponsored Link",
      "videoPlacement": "Video Placement",
      "creativeType": "Creative Type",
      "tenmaxCategory": "Creative Category",
      "remainingCharacters": "Remaining characters : {{num}}",
      "openLinkHint": "Open Link",
      "creativeBasicInfo": "Creative Basic Information",
      "agencyId": "Agency Id",
      "enableNativeBanner": "Enable Native Banner",
      "image": "Image File",
      "enableStartTime": "Set Start Time",
      "enableEndTime": "Set End Time",
      "outdoorHtml": "Html Zip File",
      "customLayout": "Custom Layout",
      "bannerUrl": "Click URL",
      "rtbBannerUrl": "RTB Click URL",
      "analyzingHint": "Analyzing...",
      "sponsoredBy": "Sponsored by",
      "imageCreativeTypeHint": "Picture only supports jpg, png or gif format",
      "typeHint": "Picture only supports format: jpg or png",
      "comboImagetypeHint": "Picture only supports jpg or png format",
      "videoTypeHint": "Video only supports mp4 format",
      "videoDurationHint": "Can use up to 120 seconds of video",
      "sizeHint": "The size of this graph must be greater than (equal to) {{size}}, the scale is {{proportion}}",
      "storageHint": "File size must be less than {{storage}}",
      "successHint": "Uploaded successfully",
      "audioSuccessHint": "Audio uploaded successfully",
      "fileUploadSuccessHint": "File uploaded successfully",
      "videoSuccessHint": "Video uploaded successfully",
      "sizeErrorHint": "The size of this picture is {{size1}}, and must be greater than (equal to) {{size2}}",
      "proportionErrorHint": "The proportion of this figure is {{proportion1}}, which must be {{proportion2}}",
      "typeErrorHint": "Image format is ({type}} format, must be jpg or png",
      "imageCreativeTypeErrorHint": "Image format is ({type}} format, must be jpg or png or gif",
      "storageErrorHint": "This file is {{storage1}} and must be less than {{storage2}}",
      "zipContentError": "Zip file must include index.html",
      "rectImg": "Wide Image File",
      "squareImg": "Square Image File",
      "dragdropHint": "Drop File or Choose File",
      "videoDurationError": "The length of the video cannot exceed 120 seconds",
      "creatives": "Creatives",
      "creativeBinding": "Creative Preview",
      "createSuccess": "Create Success",
      "updateSuccess": "Update Success",
      "createCreative": "Create Creative",
      "editCreative": "Edit Creative",
      "creativeId": "Creative ID",
      "cancelUpdate": "Cancel Update",
      "updateManually": "Update manually",
      "bannerSize": "Creative Size",
      "maxCardsCount": "Max Cards Count",
      "autoAnimationSeconds": "Auto Animation (sec)",
      "autoAnimationSeconds_postText": "later auto animation starts",
      "showAdvanceSetting": "Expand",
      "closeAdvanceSetting": "Collapse",
      "displaySize": "Ad Display Size",
      "layoutId": "Layout ID",
      "subLayout": "Sub Layout",
      "adServingUrl": "Ad Serving Url",
      "videoDuration": "Video Duration",
      "skippableSetting": "Skip Setting",
      "imageSizeErrorHint": "Image size {{size}} is not supported, please click on the size instruction button to view the supported size",
      "imagePreview": "Image Preview",
      "htmlSnippet": "AdNeon Code",
      "outdoorType": "Outdoor Ad Type",
      "imageSizeHint": "The size of this graph must be {{size}}",
      "outdoorDuration": "Creative Duration",
      "creativeSize": "Creative Size",
      "lineBeaconServiceType": "Line Beacon Service Type",
      "lineBeaconHardwareId": "Hardware ID",
      "lineBotChannelSecret": "Channel Secret",
      "lineBotChannelAccessToken": "Channel Access Token",
      "orderName": "Order Name",
      "orderBudget": "Order Budget",
      "orderSchedule": "Order Schedule",
      "sizeErrorHint2": "The size of this picture is {{size1}}, and must be equal to {{size2}}",
      "audioTypeHint": "Audio only supports mp3 format",
      "audio": "Audio File",
      "outdoorAudioSwitch": "Use Audio File",
      "videoSizeHint": "The size of this video must be {{size}}",
      "videoSizeErrorHint2": "The size of this video is {{size1}}, and must be equal to {{size2}}",
      "callToAction": "Call To Action",
      "deepLink": "Deep Link (optional)",
      "layout": "Layout Type",
      "imageMultipleSizeErrorHint": "The size of some image files is not supported, please click on the size instruction button to view the supported size",
      "storageMultipleErrorHint": "This size of some file is large than {{storage}}",
      "imageMultipleTypeErrorHint": "The format of some image files is not jpg or png or gif",
      "images": "Image File(s)",
      "oneForAllRectImg": "Wide Image File (optional)",
      "outdoorVideoSizeErrorHint": "Video size {{size}} is not supported, please click on the creative infromation reminder button to view the supported size",
      "outdoorImageSizeErrorHint": "Image size {{size}} is not supported, please click on the creative infromation reminder button to view the supported size",
      "videoCodecHint": "Supported video codecs for this channel: {{codecs}}"
    },
    "placeholders": {
      "chooseAdvertiser": "Choose Advertiser",
      "landingPageUrlHint": "Auto fill after enter the click URL"
    },
    "titles": { "advancedSetting": "Advance Setting" }
  },
  "formValidate": {
    "labels": {
      "remainingCharacters": "Remaining characters : {{num}}",
      "needUrl": "Please enter a URL",
      "maximumError": "Value must be smaller than or equal to {{max}}",
      "minimumError": "Value must be greater than or equal to {{min}}",
      "emptyError": "Cannot Be Empty",
      "integerError": "Expected Integer",
      "maximumLengthError": "Length must be smaller than or equal to {{max}}",
      "invalidValueError": "This option is no longer available.",
      "validWordsError": "Value must be pure text or punctuation marks",
      "invalidEmail": "Invalid Email",
      "emailRequired": "Email is required"
    }
  },
  "creativeType": {
    "image": "RTB Image Ads",
    "html": "HTML Ads",
    "html5": "HTML Ads",
    "native": "Native Ads",
    "video": "Video Ads",
    "dynamic": "Dynamic Ads",
    "flash": "Flash Ads",
    "thirdParty": "Third Party Ads",
    "combo": "Video + Image Ads",
    "edimax": "EdiMax Outdoor Ads",
    "picShort": "PIC Outdoor 15s Ads",
    "picLong": "PIC Outdoor 30s Ads",
    "picExtended": "PIC Outdoor 60s Ads",
    "picBroad": "PIC Outdoor 60+s Ads",
    "hwacomShort": "HwaCom 15s Ads",
    "hwacomLong": "HwaCom 30s Ads",
    "hwacomExtended": "HwaCom 60s Ads",
    "hwacomBroad": "HwaCom 60+s Ads",
    "fridgeBroad": "WI Fridge 60+s Ads",
    "fridgeLong": "WI Fridge 30s Ads",
    "fridgeExtended": "WI Fridge 60s Ads",
    "imageAds": "RTB Image Ads",
    "htmlAds": "HTML Ads",
    "nativeAds": "Native Ads",
    "videoAds": "Video Ads",
    "dynamicAds": "Dynamic Ads",
    "flashAds": "Flash Ads",
    "thirdPartyAds": "AdNeon Ads",
    "comboAds": "Video + Image Ads",
    "picShortAds": "PIC Outdoor 15s Ads",
    "picLongAds": "PIC Outdoor 30s Ads",
    "picExtendedAds": "PIC Outdoor 60s Ads",
    "picBroadAds": "PIC Outdoor 60+s Ads",
    "fridgeBroadAds": "WI Fridge 60+s Ads",
    "fridgeLongAds": "WI Fridge 30s Ads",
    "fridgeExtendedAds": "WI Fridge 60s Ads",
    "oneForAllDisplay": "One For All - Display",
    "oneForAllDisplayIos": "One For All - Display (iOS)",
    "oneForAllDisplayAndroid": "One For All - Display (Android)",
    "custom": "Custom Ads",
    "ctv": "CTV Ads",
    "customBottom": "Custom Bottom Ads",
    "customRectangle": "Custom Rectangle Ads",
    "sandboxOutdoor": "Sandbox Outdoor Ads",
    "outdoorLineMessage": "Outdoor Line Message Ads",
    "lineMessage": "Line Message Ads",
    "oneForAllVideo": "One For All - Video",
    "oneForAllVideoIos": "One For All - Video (iOS)",
    "oneForAllVideoAndroid": "One For All - Video (Android)"
  },
  "yahooIDInput": {
    "labels": { "title": "Please enter Verizon AD ID" },
    "placeholders": { "tags": "Enter the id and complete the input with Enter" }
  },
  "creativeBindStatusPage": {
    "headers": {
      "id": "Campaign ID",
      "name": "Campaign Name",
      "effectiveStatus": "Campaign Effective Status",
      "bindState": "Creatives Binding Status"
    },
    "labels": {
      "noData": "Not bind to any campaign yet",
      "active": "Active",
      "inactive": "Inactive"
    }
  },
  "creativeBindingStatusPage": { "title": "Campaign Binding Creative Status" },
  "creativesHome": {
    "labels": {
      "title": "Creatives",
      "agencyListTitle": "Agencies",
      "advertiserListTitle": "Advertisers"
    },
    "titles": { "createCreativeErrorModal": "Failed to create some creatives" }
  },
  "creativeReview": {
    "labels": {
      "pending": "Pending",
      "approved": "Approved",
      "denied": "Denied",
      "fixed": "Fixed",
      "new": "New",
      "reviewHint": "Review Creative",
      "incompleted": "Incompleted",
      "deleted": "Deleted",
      "stateTitle": "State:",
      "stateUpdateTime": "Last update time:",
      "tenmaxCategoryChange": "TenmaxCategory is changed by SSP",
      "tenmaxCategoryFrom": "Will from:",
      "tenmaxCategoryTo": "Change to:",
      "categoryChangeHint": "This creative will be delivered with the changed category.",
      "banAttribute800": "Inappropriate for female fashion publishers",
      "banAttribute810": "Inappropriate ad image for female fashion publishers",
      "banAttribute811": "Text in image",
      "banAttribute812": "Has sponsor logo",
      "banAttribute813": "Explicit product image",
      "banAttribute820": "Inappropriate ad title for female fashion publishers",
      "banAttribute821": "Explicit brand info or sales speech. (e.g. ad title has brand name, product name, pricing info, sales speech)",
      "banAttribute822": "Negative speech (e.g. ad title has brand name, product name, pricing info, sales terms)",
      "banAttribute700": "Adult content",
      "partialBanTitle": "Reasons for partial denied:",
      "partialBanHint": "This creative will still be delivered to the space that meets the specifications.",
      "missingReviewDataHint": "This creative lacks the necessary information for review, please re-edit this creative and fill in the missing information."
    },
    "lables": {
      "titkokWaitingForCreate": "It may take up to 24 hours to calculate your audiences. Check the status again later."
    }
  },
  "report": {
    "labels": {
      "reportType": "Report Type",
      "reportGran": "Schedule",
      "performanceType": "Performance",
      "videoType": "Video Performance",
      "outdoorType": "Outdoor Performance",
      "lineMessageType": "Line Message",
      "month": "Month",
      "day": "Day",
      "hour": "Hour",
      "+0800": "UTC+8",
      "+0700": "UTC+7",
      "+0900": "UTC+9",
      "reconciliationTitle": "Reconciliation Report",
      "performanceTitle": "Performance Report",
      "beaconMessageTitle": "Beacon Report",
      "filterCondition": "Filter Condition",
      "agencyId": "Agency",
      "advertiserId": "Advertiser",
      "adsOrderId": "Order",
      "campaignId": "Campaign",
      "creativeId": "Creative",
      "creativeType": "Creative Type",
      "creativeSize": "Creative Size",
      "isSelfBuy": "Self Buy",
      "deviceType": "Device Type",
      "salesChannel": "Sales Channel",
      "dimentSelectArea": "Dimension Select Area",
      "reportChartArea": "Report Chart",
      "download": "Download",
      "adType": "Ad Type",
      "useAppsflyerConversion": "Use Appsflyer Conversion",
      "withoutPerformance": "Current option does not has preformance records.",
      "mrt": "Important MRT Station",
      "l3ChannelId": "Binding",
      "l2ChannelId": "Campaign",
      "l2ObjectId": "Campaign",
      "l1ObjectId": "Campaign Group"
    },
    "buttons": { "search": "Query" },
    "titles": {
      "salesChannelReconciliation": "Sales Channel Reconciliation Report"
    },
    "hints": {
      "salesChannelReconciliation": "Daily data will change with the original delivery information. The final data of the previous month can be checked after the 2nd day of each month."
    }
  },
  "reportTable": {
    "labels": {
      "dayDimension": "Date",
      "agencyIdDimension": "Agency",
      "advertiserIdDimension": "Advertiser",
      "adsOrderIdDimension": "Order",
      "campaignIdDimension": "Campaign",
      "adTypeDimension": "Ad Type",
      "creativeIdDimension": "Creative",
      "creativeTypeDimension": "Creative Type",
      "creativeSizeDimension": "Creative Size",
      "isSelfBuyDimension": "Self Buy",
      "deviceTypeDimension": "Device Type",
      "salesChannelDimension": "Sales Channel",
      "mrtDimension": "Important MRT Station",
      "adsOrderIdLinkHint": "View Order Detail",
      "campaignIdLinkHint": "View Campaign Detail",
      "l2ObjectIdLinkHint": "View Campaign Detail",
      "creativeIdLinkHint": "View Creative Detail",
      "alertModalContent": "The sum of the report data may differ in creative type dimension since the creatives created/edited on self serving are not able to be matched to original creative type on the platform.",
      "alertModalTitle": "Switch Report Dimension",
      "l3ChannelIdDimension": "Binding",
      "l2ChannelIdDimension": "Campaign",
      "l2ObjectIdDimension": "Campaign",
      "l1ObjectIdDimension": "Campaign Group",
      "l1ObjectIdLinkHint": "View Campaign Group Detail",
      "l2ChannelIdLinkHint": "View Campaign Detail",
      "l3ChannelIdLinkHint": "View Binding Detail"
    },
    "placeholders": {
      "searchDate": "Search Date...",
      "searchName": "Search Name..."
    },
    "headers": {
      "name": "Name",
      "date": "Date",
      "impres": "Impression",
      "clicks": "Clicks",
      "ctr": "CTR",
      "viewable": "Viewable Impres",
      "vctr": "VCTR",
      "cpm": "CPM",
      "acpm": "aCPM",
      "cpc": "CPC",
      "cpa": "CPA",
      "convs": "Conversions",
      "conv_1": "Conversions(1d)",
      "conv_7": "Conversions(7d)",
      "cvr": "CVR",
      "mediaCost": "Media Cost ({{currency}})",
      "mediaSpent": "Media Spent ({{currency}})",
      "agcProfit": "Agency Margin ({{currency}})",
      "sysProfit": "System Margin ({{currency}})",
      "dataCost": "Data Cost ({{currency}})",
      "spent": "Spent ({{currency}})",
      "adView": "View",
      "viewRate": "View Rate",
      "viewableViewRate": "Viewable View Rate",
      "cpv": "CPV",
      "skipCount": "Skip Count",
      "firstQuartile": "View Rate(25%)",
      "midpoint": "View Rate(50%)",
      "thirdQuartile": "View Rate(75%)",
      "complete": "View Rate(100%)",
      "tags": "Custom Tags",
      "ePublisherImpres": "Publisher Impres",
      "beaconEvents": "Beacon Data",
      "beacon": "Beacon Transmissions",
      "messageCount": "Beacon Message Sends",
      "uu": "Unique User"
    },
    "footers": { "total": "Total" }
  },
  "deviceType": {
    "computer": "Computer",
    "tablet": "Tablet",
    "phone": "Phone",
    "unknown": "Unknown"
  },
  "advertiserHome": {
    "labels": { "title": "Advertiser", "agencyOptionsTitle": "Agencies" }
  },
  "advertiserList": {
    "headers": {
      "id": "Advertiser Name and ID",
      "category": "Creative Categories",
      "website": "Official Website"
    },
    "labels": {
      "nodata": "No data, let ’s add a new advertiser",
      "newAdvertiser": "+ Advertiser",
      "editHint": "Edit Advertiser"
    },
    "placeholders": { "searchbar": "Advertiser name or ID" }
  },
  "advertiserForm": {
    "labels": {
      "createTitle": "Create Advertiser",
      "editTitle": "Edit Advertiser",
      "name": "Company Name",
      "website": "Official Website",
      "category": "Creative Categories",
      "note": "Note",
      "id": "Advertiser ID",
      "publisher": "Publisher"
    }
  },
  "advertiserDetail": {
    "labels": {
      "title": "Advertiser and Member List",
      "name": "Company name: {{name}}",
      "id": "Advertiser ID",
      "website": "Official Website",
      "publisher": "Publisher",
      "category": "Creative Categories",
      "note": "Note",
      "advertiserSegmentSource": "Other Advertiser Segments",
      "editAdvertiser": "Edit Advertiser",
      "segmentSource": "Other Advertiser Segment Source"
    },
    "tabs": {
      "member": "Member",
      "advertiserMemberList": "Member",
      "beaconConnectionList": "Beacon Connection"
    }
  },
  "advertiserMemberList": {
    "labels": {
      "nodata": "No data, let ’s add a new member",
      "newAdvertiserMember": "+ Member",
      "deleteModalTitle": "Delete Account Role",
      "deleteModalContent": "Are you sure you want to delete selected account role?",
      "deleteAccountMemberSuccess": "Delete Account Role Success",
      "createAccountMemberSuccess": "Create Account Role Success",
      "editAccountMemberSuccess": "Update Account Role Success",
      "editHint": "Edit Member",
      "deleteHint": "Remove Permission",
      "newAccount": "+ Account"
    },
    "placeholders": { "searchbar": "Member name or Email" },
    "permissions": {
      "ROLE_ADV_ADMIN": "Advertiser Account Manager",
      "ROLE_ADV_REPORT": "Advertiser AD Client",
      "ROLE_ADV_SALES": "Advertiser Account Executive"
    },
    "headers": {
      "emailColumn": "Email",
      "nameIdColumn": "Name",
      "statusColumn": "Status",
      "permissionColumn": "Permission"
    }
  },
  "advertiserMemberForm": {
    "labels": {
      "email": "Email",
      "role": "Permission",
      "role_adv_admin": "Advertiser Account Manager - all of advertiser permission",
      "role_adv_report": "Advertiser AD Client - only report permission",
      "role_adv_sales": "Advertiser Account Executive - only order and report permission",
      "createMember": "Create Advertiser Member",
      "editMember": "Edit Advertiser Member"
    }
  },
  "adLogoForm": {
    "labels": {
      "title": "Advertisement Logo",
      "logoType": "Logo Type",
      "logoLink": "Logo Link",
      "logoUpload": "Logo Upload",
      "typeErrorHint": "Image format is ({type}} format, must be jpg or png",
      "sizeErrorHint": "The size of this picture is {{size1}}, and must equal to {{size2}}",
      "default": "Default",
      "custom": "Custom",
      "null": "None",
      "sizeHint": "The size of this graph must equal to 50 x 50",
      "logoPreview": "Ad Logo Preview",
      "logoHint": "Ad Logo only shows in image ads and native ads"
    }
  },
  "adDeclarationForm": {
    "labels": { "title": "Upload Advertising Declaration" }
  },
  "segmentHome": {
    "labels": {
      "title": "Ad Segment",
      "agencyListTitle": "Agencies",
      "advertiserListTitle": "Advertiser"
    }
  },
  "segmentList": {
    "placeholders": { "searchbar": "Segment name or ID" },
    "labels": {
      "newSegment": "+ Segment",
      "nodata": "No data, let ’s add a new segment",
      "chooseAgency": "Please choose a agency first",
      "duration": "{{days}} days",
      "deleteModalTitle": "Delete Segment",
      "deleteModalContent": "Are you sure you want to delete selected segment and all sub segment of it?",
      "editHint": "Edit Segment",
      "deleteHint": "Delete Segment",
      "deleteSuccess": "Delete segment success"
    },
    "headers": {
      "nameIdColumn": "Segment Name",
      "durationColumn": "Duration",
      "segmentCountColumn": "Audience Count",
      "subSegmentAmountColumn": "Sub Segment Amount"
    }
  },
  "segmentForm": {
    "labels": {
      "createTitle": "Create Segment",
      "editTitle": "Edit Segment",
      "advertiser": "Advertiser",
      "name": "Segment Name",
      "duration": "Duration",
      "durationUnit": "Day",
      "durationLimit": "The duration setting is limited to 30 days to 365 days"
    }
  },
  "segmentDetail": {
    "labels": {
      "dmpId": "Segment ID",
      "duration": "Duration",
      "segmentCount": "Audience Count",
      "name": "Segment Name: {{name}}",
      "title": "Segment and Subsegment List",
      "editSegment": "Edit Segment",
      "code": "Code",
      "import": "Import Audience",
      "reset": "Reset Audience",
      "export": "Export Audience",
      "importSuccess": "Import Audience Success",
      "resetSuccess": "Reset Audience Success",
      "exportSuccess": "Export Audience Success",
      "fileSizeErrorModalTitle": "File Size Too Big",
      "fileSizeErrorModalContent": "Import Audience. File size must smaller than {{bytes}} bytes",
      "importCookies": "Cookie",
      "importDeviceIds": "Device ID"
    }
  },
  "segmentCode": {
    "labels": {
      "id": "Segment ID",
      "code": "Segment Code",
      "codeHint": "Please copy the code, and paste on the footer of site!",
      "codeType": "Code Type",
      "jsCode": "JS Code",
      "imageCode": "Image Code"
    }
  },
  "codePage": {
    "labels": {
      "privacy": "Privacy Statement",
      "privacyStatement": "The tracking code is used to track user behavior, assist in forwarding events to third-party advertising or analytics platforms (e.g. facebook, adword, google analytics), or to track conversion performance. Please read TenMax’s <1>Privacy Policy</1> first. Once using the tracking code, you accept our use of cookies, revised Privacy Policy and Terms of Use.",
      "copyCodeSuccess": "Copy Code Success"
    }
  },
  "subSegmentList": {
    "labels": {
      "newSegment": "+ Sub Segment",
      "nodata": "No data, let ’s add a new sub segment",
      "deleteModalTitle": "Delete Subsegment",
      "deleteModalContent": "Are you sure you want to delete selected subsegment?",
      "editHint": "Edit Subsegment",
      "exportHint": "Export Subsegment",
      "deleteHint": "Delete Subsegment",
      "deleteSuccess": "Delete subsegment success"
    },
    "headers": {
      "nameIdColumn": "Name",
      "dmpSegmentIdColumn": "Segment ID",
      "segmentCountColumn": "Audience Count",
      "ruleContentColumn": "Website Rule"
    },
    "placeholders": { "searchbar": "Subsegment name or ID" }
  },
  "segmentRuleComparator": {
    "labels": {
      "contains": "Contains",
      "equals": "Equals",
      "starts_with": "Starts with",
      "ends_with": "Ends with",
      "does_not_equal": "Does not equal",
      "does_not_contain": "Does not contain",
      "does_not_start_with": "Does not start with",
      "does_not_end_with": "Does not end with",
      "regex": "Regex"
    }
  },
  "subSegmentForm": {
    "labels": {
      "createTitle": "Create Subsegment",
      "editTitle": "Edit SubsSegment",
      "name": "Subsegment Name",
      "ruleContent": "Advanced Rule - URL Pattern",
      "filterRules": "Filter Condition",
      "ruleContentEmptyError": "Please have at least one valid URL pattern"
    }
  },
  "conversionHome": {
    "labels": {
      "title": "Conversion Tracking",
      "agencyListTitle": "Agencies",
      "advertiserListTitle": "Advertiser"
    }
  },
  "conversionForm": {
    "labels": {
      "createTitle": "Create Conversion Tracking",
      "editTitle": "Edit Conversion Tracking",
      "advertiser": "Advertiser",
      "name": "Name",
      "type": "Type"
    }
  },
  "conversionList": {
    "labels": {
      "newConversion": "+ Conversion Tracking",
      "nodata": "No data, let ’s add a new conversion tracking",
      "chooseAgency": "Please choose a agency first",
      "editHint": "Edit Conversion Tracking",
      "codeHint": "Conversion Tracking Code"
    },
    "placeholders": { "searchbar": "Conversion Tracking name or ID" },
    "headers": { "nameIdColumn": "Name", "typeColumn": "Type" }
  },
  "conversionType": {
    "labels": {
      "purchase": "Purchase",
      "cart": "Cart",
      "signUp": "Sign up",
      "lead": "Lead",
      "viewOfAKeyPage": "View of a key page",
      "others": "Others"
    }
  },
  "conversionCode": {
    "labels": {
      "id": "Conversion Tracking ID",
      "code": "Conversion Tracking Code",
      "codeHint": "Please copy the tracking code and paste the tracking code behind the <body> tag in the website to ensure that the event collection information can be accurately sent to the server."
    }
  },
  "accountActorList": {
    "labels": {
      "deletePermissionContent": "Are you sure you want to delete the permission of this account?",
      "actionHint": {
        "edit": "Edit Account Permission",
        "delete": "Delete Account Permission"
      }
    }
  },
  "accountDetail": {
    "labels": {
      "name": "Account name: {{name}}",
      "resendActivationEmail": "Resend Activation Email"
    }
  },
  "loginPage": {
    "labels": {
      "loginError": "Incorrect account or password",
      "emailTitle": "E-mail",
      "passwordTitle": "Password",
      "forgotPassword": "Forgot password?",
      "privacyPolicy": "Privacy Policy",
      "confirmPasswordTitle": "Confirm Password"
    }
  },
  "prompt": {
    "labels": {
      "title": "About to leave this page",
      "message": "If you leave this page, the changes you made will be lost. Click [Leave] to proceed without saving, or [Cancel] to stay and continue editing."
    }
  },
  "daypick": {
    "labels": {
      "add1Day": "After 1 Day",
      "add7Days": "After 7 Days",
      "add1Month": "After 1 Month",
      "thisWeek": "This Week",
      "thisMonth": "This Month",
      "endOfNextMonth": "End of Next Month",
      "endOfNext3Months": "End of Next 3 Months",
      "today": "Today",
      "yesterday": "Yesterday",
      "last7Days": "Last 7 Days",
      "last30Days": "Last 30 Days",
      "lastWeek": "Last Week",
      "lastMonth": "Last Month"
    }
  },
  "advertiserDetailModal": {
    "titles": {
      "addOtherAdvertiserSegments": "Add Other Advertiser Segments Source"
    }
  },
  "videoForm": {
    "labels": {
      "inStream": "In-Stream (Pre-Roll)",
      "outStream": "Out-Stream",
      "unlimitStream": "Unlimit",
      "nonSkippable": "Non Skippable",
      "skippable": "Skippable",
      "videoSource": "Select video source",
      "tenMaxVideo": "TenMax",
      "3rdVideo": "3rd Party",
      "tenMaxVideoInput": "Video File",
      "3rdVideoInput": "Ad Serving URL",
      "3rdVideoDuration": "Video Duration"
    }
  },
  "advertiserSegmentSource": {
    "labels": {
      "addSourceBtn": "Add Source",
      "advertiserSegmentSource": "Segment Source",
      "title": "Other Advertiser Segment Source"
    },
    "placeholders": {
      "agencies": "Please select an agency",
      "advertisers": "Please select an advertiser"
    }
  },
  "thirdPartyVideoPreview": { "labels": { "thirdParty": "Third Party" } },
  "videoCreativePreivew": {
    "labels": { "generating": "Preview Image is generating" }
  },
  "videoCreativeDetail": { "labels": { "generating": "Video is generating" } },
  "creativeChooseAdvertiser": {
    "title": { "warning": "Warning" },
    "labels": {
      "advertiserChangeAlert": "Edit content will be reset after advertiser changed, are you sure to change?"
    }
  },
  "nativeForm": {
    "labels": {
      "nativeBannerTitle": "Ad style",
      "enableNativeBanner": "Delivery to image ad traffic",
      "cannotModifyHint": "※ Cannot modify after created"
    }
  },
  "nativeBanner": {
    "labels": {
      "sponsoredBy": "Sponsored by {{sponsor}}",
      "learnMore": "Learn more",
      "recommendation": "HOT"
    }
  },
  "nativeCreativeDetail": {
    "labels": { "toggleBanner": "BANNER", "toggleNative": "NATIVE" }
  },
  "ppsCreativeDetail": {
    "labels": { "toggleMobile": "Mobile", "toggleDesktop": "Desktop" }
  },
  "nativeMediaSummary": {
    "titles": {
      "native": "Native Creative",
      "nativeBanner": "Native Banner Creative"
    }
  },
  "imageCreativeSizeHint": {
    "labels": {
      "sizeInstruction": "Size Instruction",
      "recommendTitle": "Recommended image sizes",
      "otherSizeTitle": "Other supported image sizes"
    }
  },
  "ppsForm": {
    "labels": {
      "macroInstruction": "The code must include the necessary tracking macros",
      "htmlSnippet": "Ad Code",
      "normalBannerUrlHint": "It will follow the export link set in the Ad Tag, if you need to adjust, please contact the Ad Tag service provider",
      "layoutId": "Layout ID",
      "subLayout": "Sub Layout",
      "noCorrespondingLayoutId": "Not supported Layout ID: {{layoutId}}",
      "layoutIdNotFound": "Layout ID not found",
      "autoGenImage": "Auto Gengerate",
      "cannotFindPreveiwImage": "Cannot find the preview image",
      "needPPSCreativeID": "Please enter a valid AdNeon code first"
    }
  },
  "macro": {
    "titles": {
      "clickMacroDesc": "Your code will be checked if it includes any necessary tracking MACRO. Your AD code must contain at least one marco in the below table",
      "viewableMacroDesc": "For AdNeon creatives, your AD code must contains marcos in the below table"
    },
    "headers": {
      "clickMacro": "Click Tracking Macro",
      "desc": "Description",
      "viewableMacro": "Viewable Impression Tracking Macro"
    },
    "unescapedClickURL": "Unescaped click tracking URL",
    "escapedClickURL": "Escaped click URL",
    "doubledEscapedClickURL": "Double-escaped click URL",
    "vastUrl": "VAST url for VideoAds to exchange video view events",
    "dspViewableURL": "DSP viewable impression tracking macro",
    "sspViewableURL": "SSP viewable impression tracking macro",
    "adxViewableURL": "ADX viewable impression tracking macro",
    "bannerUrl": {
      "clickId": "Tracking ID macro for this ad click",
      "idfa": "Tracking ID macro for this ad click of the IOS device",
      "androidId": "Tracking ID macro for this ad click of the AOS device",
      "campaignId": "Campaign ID macro for this ad click",
      "bannerId": "Creative ID macro for this ad click"
    },
    "hint": {
      "appsflyer": "*Note: This rule is only applicable to Appsflyer's website, if you have other requirements, please contact the window"
    }
  },
  "ppsFormValidate": {
    "labels": {
      "macroError": "AdNeon code lacks necessary macros",
      "codeSizeToLarge": "AdNeon code is too large, please reduce the content"
    }
  },
  "html5Form": {
    "labels": {
      "recommended": "recommended",
      "bannerSize": "Creative Size",
      "htmlZip": "Html Zip File",
      "typeHint": "only supports zip format",
      "fileHint": "※ Please compress the relevant files of the creative webpage into a zip file before uploading. <1>Click here</1> to download the example file",
      "typeErrorHint": "file format is ({type}} format, must be zip"
    }
  },
  "outdoorForm": {
    "labels": {
      "outdoorType1": "VIDEO",
      "outdoorType2": "IMAGE + AUDIO",
      "outdoorType3": "VIDEO + IMAGE",
      "outdoorType4": "HTML",
      "outdoorType2Epaper": "IMAGE",
      "duration15": "15 seconds",
      "duration30": "30 seconds",
      "duration0": "Not limited",
      "videoProportionHint": "The proportion of this video is {{proportion}}",
      "videoProportionErrorHint": "The proportion of this video must be {{proportion}}",
      "videoSizeHint": "The size of this video must be {{size}}",
      "videoSizeBoxingHint": "Please see the creative information reminder for video size restrictions.",
      "imageSizeBoxingHint": "Please see the creative information reminder for image size restrictions.",
      "orderName": "Order Name",
      "orderBudget": "Order Budget",
      "orderSchedule": "Order Schedule",
      "selfCheckDocument": "Self Check Document",
      "outdoorType6": "IMAGE"
    },
    "hints": {
      "orderName": "{{channelName}} reviewers will decide whether to pass the review based on the information. Please fill in the details carefully.",
      "orderBudget": "{{channelName}} reviewers will decide whether to pass the review based on the information. Please fill in the details carefully.",
      "orderSchedule": "The schedule setting will be displayed during the review stage for reviewers’ reference and will not affect the ad delivery schedule setting.",
      "selfCheckFileType": "Only supports doc / docx / pdf format",
      "selfCheckFileExample": "<1>Click here</1> to download the example file",
      "nonExpressPassCategory": "This category is not eligible for express pass — self-check document upload is required."
    },
    "errors": {
      "selfCheckDocumentRequired": "Please upload the self-check document for creative review."
    }
  },
  "streamingStatus": {
    "title": "直撥素材調整",
    "labels": {
      "create": "直撥素材調整",
      "edit": "編輯直撥素材調整",
      "noData": "直撥素材調整"
    }
  },
  "streamingStatusList": {
    "headers": { "crid": "Creative id", "isLive": "是否直播中" },
    "hints": { "edit": "編輯直撥素材狀態" }
  },
  "streamingStatusForm": {
    "labels": {
      "createTitle": "新增直撥素材狀態",
      "editTitle": "編輯直撥素材狀態",
      "crid": "Creative id",
      "isLive": "是否直播中"
    }
  },
  "beaconFields": {
    "labels": {
      "beaconConnection": "Official Account",
      "webhookType": "Webhook Type",
      "hardwareId": "Hardware ID",
      "channelSecret": "Channel Secret",
      "channelAccessToken": "Channel Access Token",
      "beaconConfigSwitch": "Beacon Push",
      "generateWebhook": "Generate Webhook URL",
      "generateBeaconAPIUrl": "Generate Beacon API URL",
      "tenmaxSupport": "TenMax Support",
      "tenmax": "TenMax Support",
      "advertiserSelfServe": "Advertiser Owned Webhook",
      "beaconType": "Beacon Type",
      "frequencyCap": {
        "every": "Every",
        "send": "send",
        "cappingCount": "time",
        "cappingCounts": "times"
      },
      "frequencyCapSwitch": "Frequency Capping",
      "language": "User Language",
      "lineUserLanguage": {
        "all": "Any Language",
        "zh_hant": "Traditional Chinese",
        "zh_hans": "Simplified Chinese",
        "en": "English",
        "ja": "Japanese",
        "th": "Thai"
      }
    },
    "buttons": {
      "generateWebhook": "Copy Webhook URL after Clicking",
      "generateBeaconAPIUrl": "Copy Beacon API URL after Clicking"
    },
    "hints": {
      "generateWebhookSuccess": "Webhook url is copied to clipboard",
      "generateBeaconUrlSuccess": "Beacon API url is copied to clipboard"
    }
  },
  "comboForm": {
    "labels": {
      "videoHint": "The length of the video cannot exceed {{sec}} seconds and the height cannot exceed {{height}}",
      "videoDurationErrorHint": "The length of this video is {{sec1}} seconds and cannot exceed {{sec2}} seconds",
      "videoHeightErrorHint": "The height of this video is {{height1}} and cannot exceed {{height2}}"
    }
  },
  "doctor": {
    "labels": { "campaignId": "Campaign ID", "creativeId": "Creative ID" }
  },
  "doctors": {
    "labels": {
      "campaignIdPlaceholder": "Please enter campaign ID",
      "creativeIdPlaceholder": "Please enter creative ID",
      "noCreative": "This campaign does not have any creative bind",
      "title": "Check Campaign Bid Restrictions"
    }
  },
  "doctorChart": {
    "labels": { "remain": "Remaining spaces", "filtered": "Filtered spaces" }
  },
  "doctorTable": {
    "labels": {
      "filterConditionTitle": "Filter Condition",
      "tenmaxCategory": "Creative Category",
      "interstitial": "Interstitial",
      "creativeTitle": "Creative"
    },
    "headers": { "domain": "Domain", "spaceCount": "Space Count" },
    "placeholders": {
      "filterCondition": "Please select a filter condition",
      "searchbar": "Search domain or space"
    },
    "tabs": {
      "filtered": "Filtered channel information",
      "remained": "Remaining channel information"
    }
  },
  "doctorTableRowExtender": {
    "labels": {
      "banCategoryReasonTitle": "Space Ban Categories :",
      "intersitialCampaign": "The space is an interstitial space, this campaign is not allowed to be delivered to an interstitial space",
      "intersitialCreative": "The space is an interstitial space, this creative is not allowed to be delivered to an interstitial space",
      "reasonTitle": "Unable to bid reason"
    },
    "placeholders": {
      "spaceList": "Search for space to see details",
      "banReason": "Choose a space to see reason"
    }
  },
  "campaignControlList": {
    "headers": { "name": "Group Name", "campaignInfos": "Campaign Count" },
    "placeholders": { "searchbar": "Search Budget Allocation Group" },
    "labels": {
      "newCampaignControl": "+ Budget Allocation Group",
      "noData": "No data, let ’s add a new budget allocation group",
      "editHint": "Edit Budget Allocation Group",
      "deleteHint": "Delete Budget Allocation Group",
      "deleteModalTitle": "Delete Budget Allocation Group",
      "deleteModalContent": "Are you sure you want to delete selected group?",
      "managementModalTitle": "Manage Campaigns",
      "campaignEditHint": "Manage Campaigns"
    }
  },
  "campaignControlForm": {
    "labels": {
      "createTitle": "Create Budget Allocation Group",
      "editTitle": "Edit Budget Allocation Group",
      "name": "Name",
      "campaigns": "Campaigns"
    },
    "placeholders": { "campaigns": "Please select campaigns to manage" }
  },
  "changePasswords": {
    "title": { "change": "Change password" },
    "message": { "reload": "Change password success. Need login again." }
  },
  "campaignControlCampaignList": {
    "headers": { "name": "Campaign Name" },
    "labels": { "deleteHint": "Remove campaign from this group" },
    "placeholders": { "searchbar": "_x0008_Search Campaign" }
  },
  "sudo": {
    "placeholders": { "searchbar": "Search Email or Name" },
    "label": {
      "platformAccounts": "Platform Accounts",
      "oemAccounts": "Oem Accounts"
    },
    "message": { "success": "sudo success" }
  },
  "errorBoundary": { "labels": { "title": "Something went wrong" } },
  "bidPriceSetting": {
    "labels": {
      "display": "Display advertising bid price settings",
      "video": "Video advertising bid price settings",
      "combo": "Video + Image advertising bid price settings",
      "thirdParty": "3rd Party(Uncategorized) advertising bid price settings",
      "thirdPartyBottom": "3rd Party(Bottom) advertising bid price settings",
      "thirdPartyRectangle": "3rd Party(Rectangle) advertising bid price settings",
      "oneForAllDisplay": "One For All Display advertising bid price settings",
      "ctv": "CTV advertising bid price settings",
      "keyword": "Keyword advertising bid price settings",
      "message": "Message advertising bid price settings",
      "picShort": "PIC Outdoor 15s advertising bid price settings",
      "picLong": "PIC Outdoor 30s advertising bid price settings",
      "picExtended": "PIC Outdoor 60s advertising bid price settings",
      "picBroad": "PIC Outdoor 60+s advertising bid price settings",
      "hwacomShort": "HwaCom 15s advertising bid price settings",
      "hwacomLong": "HwaCom 30s advertising bid price settings",
      "hwacomExtended": "HwaCom 60s advertising bid price settings",
      "hwacomBroad": "HwaCom 60+s advertising bid price settings",
      "fridgeBroad": "WI Fridge 60+s advertising bid price settings",
      "fridgeLong": "WI Fridge 30s advertising bid price settings",
      "fridgeExtended": "WI Fridge 60s advertising bid price settings",
      "sandboxOutdoor": "Sandbox Outdoor advertising bid price settings",
      "sandboxMovableOutdoor": "Sandbox Movable Outdoor advertising bid price settings",
      "outdoorLineMessage": "Outdoor Line Message advertising bid price settings",
      "lineMessage": "Line Message advertising bid price settings",
      "autoBidCapSetting": "Auto Bid Cap Setting",
      "bidFloorSetting": "Bid Floor Setting"
    },
    "optimize": {
      "cpc": "Clicks",
      "cpm": "Impressions",
      "cpv": "Video Views",
      "vcpm": "Viewable Impressions",
      "acpm": "Publisher Impressions",
      "wcpm": "Screen Weight Impressions",
      "bcpm": "Cost Per Message",
      "dcpm": "Dynamic CPM"
    }
  },
  "agencyForm": {
    "placeholders": {
      "tags": "Enter the ID and complete the publisher creation with Enter"
    },
    "labels": {
      "sysMarginMaximumError": "The sum of Internal Margin and External Margin ratio must be less than {{value}}",
      "smallerThanAgcMarginError": "Remain margin cannot be less than agency default margin {{value}}",
      "smallerThanOrderProfitError": "Remain margin cannot be less than max agency margin {{value}}",
      "orderDefaultProfitBiggerThanMaxProfit": "Agency default margin cannot be greater than max agency margin",
      "clickToAddEffectDate": "Click to add future rebate effect date",
      "rebateRateMaximumError": "The rebate rate cannot be greater than the system margin: {{margin}}",
      "duplicateAlertEmails": "Duplicate emails are not allowed"
    }
  },
  "agencyList": { "labels": { "editHint": "Edit Agency" } },
  "productGroupList": {
    "labels": {
      "title": "Product Group Management",
      "space": "Space",
      "domain": "Domain",
      "deleteHint": "Delete Product Group",
      "noData": "No data, let ’s add a new product group",
      "campaignModalTitle": "Campaign Information",
      "showCampaignHint": "Show campaign information which uses this product group",
      "create": "Create Product Group",
      "editHint": "Edit product group",
      "deleteModalTitle": "Delete Product Group",
      "deleteModalContent": "Are you sure you want to delete the product group?"
    },
    "headers": {
      "id": "Name",
      "description": "Description",
      "agencys": "Agencies"
    },
    "placeholders": { "searchbar": "_x0008_Search Product Group" }
  },
  "campaignUseProductGroup": {
    "headers": { "id": "campaign id", "name": "campaign name" }
  },
  "productGroupForm": {
    "labels": {
      "groupName": "Group Name",
      "groupType": "Group Type",
      "adspace": "Space",
      "domain": "Domain",
      "agencyIds": "Agencies can use this group",
      "description": "Description",
      "customDomain": "Custom Domain",
      "customSpace": "Custom Space",
      "customSpaceName": "Name",
      "customSpaceId": "ID",
      "createTitle": "Create Product Group",
      "editTitle": "Edit product group",
      "single": "Single",
      "multiple": "Multiple",
      "adFormat": "Ad Format",
      "channel": "Channel",
      "attributes": "Attributes",
      "selectAllSpace": "Select All",
      "conditionSpace": "Auto Update By Attributes",
      "selectAllDevice": "Select All",
      "conditionDevice": "Auto Update By Attributes",
      "selectAllStore": "Select All",
      "conditionStore": "Auto Update By Attributes"
    },
    "buttons": {
      "customSpace": "+ Custom Space",
      "customDomain": "+ Custom Domain",
      "filterSpace": "Filter Space",
      "filterDevice": "Filter Device",
      "filterStore": "Filter Store",
      "editFilters": "Edit Filters",
      "editAdspace": "Edit Spaces",
      "editDomain": "Edit Domains",
      "finishEdit": "Complete Editing"
    },
    "placeholders": {
      "customDomain": "Enter the domain and complete the domain creation with Enter",
      "addDomain": "ex: www.example.com"
    },
    "addDomain": "Add Custom Domain",
    "title": {
      "generalSection": "General",
      "filterSection": "Condition",
      "selectAdspaceSection": "Space",
      "selectDomainSection": "Domain",
      "selectStoreSection": "Store",
      "selectDeviceSection": "Device"
    },
    "titles": { "other": "Other" },
    "hints": {
      "conditionSpace": "After selecting [Automatically update placements based on conditions], the system will automatically update the space group based on the conditions. When the space's attributes change, the system will automatically update the group to ensure the consistency with the actual placement attributes.",
      "conditionDevice": "After selecting [Automatically update placements based on conditions], the system will automatically update the space group based on the conditions. When the space's attributes change, the system will automatically update the group to ensure the consistency with the actual placement attributes.",
      "conditionStore": "After selecting [Automatically update placements based on conditions], the system will automatically update the store group based on the conditions. When the store's attributes change, the system will automatically update the group to ensure the consistency with the actual placement attributes.",
      "autoUpdate": "Auto update by attributes"
    }
  },
  "productGroup": {
    "placeholders": { "search": "Search" },
    "labels": { "autoUpdate": "(Space updated according to attributes)" },
    "space": {
      "attributes": {
        "store": { "postfix": "{{value}} Branch Store" },
        "titles": {
          "storeNum": "Stores Information",
          "cityGroup": "Location",
          "administrativeArea": "District",
          "outdoorPlaceCategories": "Local Feature",
          "weather": "Weather Information",
          "deviceCharacteristic": "Device Information"
        }
      }
    }
  },
  "outdoorMonitor": {
    "labels": {
      "dayRange": "Duration",
      "agency": "Agency",
      "total": "Estimated Total Traffic Seconds",
      "remain": "Estimated Remain Traffic Seconds",
      "proposal": "_x0008_Proposal Order Used Traffic Seconds",
      "formal": "Formal Order Used Traffic Seconds",
      "day": "Day",
      "hour": "Hour",
      "title": "Outdoor Traffic Monitor"
    },
    "placeholders": {
      "agencies": "Please select agency",
      "searchbar": "Search Order"
    }
  },
  "creditList": {
    "labels": {
      "title": "Credit Info",
      "noData": "No data",
      "pay": "Pay",
      "payConfirm": "Going to pay {{date}} for {{name}}. Are you sure?"
    },
    "headers": {
      "agency_id": "Agency",
      "used_credit": "Used Credit",
      "creditLimit": "Total Credit"
    },
    "placeholders": { "searchbar": "Search Credit Info" }
  },
  "creditDetail": {
    "labels": {
      "totalCredit": "Total Credit",
      "remainCredit": "Remaining Credit",
      "billUnpaid": "Unpaid Bill",
      "billSpent": "Spent",
      "paymentAt": "Last paid: {{amount}} at {{at}}",
      "noLastPaid": "No payment record",
      "title": "Credit",
      "pay": "Pay"
    }
  },
  "creditLog": {
    "labels": {
      "approveAddOrderBudget": "Order budget increase {{orderNumber}}",
      "approveReduceOrderBudget": "Order budget decrease {{orderNumber}}",
      "addCreditLimit": "Increase credit limit",
      "reduceCreditLimit": "Decrease credit limit",
      "orderSettleAddOrderBudget": "Order settled {{orderNumber}}",
      "orderSettleReduceOrderBudget": "Order settled {{orderNumber}}",
      "approveNewOrder": "New order {{orderNumber}}",
      "paidBill": "Payment made {{dateId}}",
      "noData": "No credit log"
    },
    "headers": {
      "ctime": "Date",
      "note": "Note",
      "paid": "Inflow",
      "unpaid": "Outflow",
      "updatedCredit": "Credit"
    }
  },
  "creditPayModal": {
    "labels": {
      "agency": "Agency",
      "currency": "Currency",
      "period": "Bill Period",
      "payment": "Amounts",
      "credit": "Credit Replenished",
      "noData": "No unpaid bills"
    }
  },
  "currencyRateList": {
    "labels": {
      "title": "Exchange Rate Setting",
      "NTD": "NTD",
      "MYR": "MYR",
      "JPY": "JPY",
      "VND": "VND",
      "EUR": "EUR",
      "IDR": "IDR",
      "noData": "No data, let ’s add a new exchange rate",
      "create": "Add Exchange Rate",
      "oneDollarEqual": "1 U.S. dollar exchange"
    },
    "headers": {
      "ctime": "Date",
      "rate": "Exchange Rate",
      "createdBy": "Created By"
    }
  },
  "l1Object": {
    "labels": {
      "noData": "No data, let ’s add a new campaign group",
      "create": "+ Campaign Group",
      "createTitle": "Create Campaign Group",
      "editTitle": "Edit Campaign Group",
      "deleteTitle": "Delete Campaign Group",
      "name": "Group Name",
      "l1ObjectId": "Group Name",
      "channel": "Group Channel",
      "budget": "Budget",
      "autoOptimise": "Campaign Budget Optimization",
      "channel_all": "ALL",
      "channel_rtb": "RTB",
      "channel_pic": "PIC Outdoor",
      "channel_fridge": "WI Fridge",
      "channel_matsukiyo": "Retail Beacon Network",
      "channel_hwacom": "HwaCom",
      "detailTitle": "Campaign Group & Campaigns",
      "deleteModalContent": "Are you sure you want to delete selected group?",
      "state": "Status",
      "budgetBalance": "Available Budget",
      "outdoorDeviceReport": "Outdoor Deliver Performance",
      "objectiveLabel": "Objective",
      "objective": {
        "awareness": "Awareness",
        "traffic": "Traffic",
        "sales": "Sales",
        "unspecified": "Unspecified"
      },
      "cannotDeleteTitle": "Campaign Group cannot delete if it has campaign",
      "bidStrategyLabel": "Bid Strategy",
      "bidStrategy": {
        "lowest_cost_without_cap": "Auto Bid",
        "lowest_cost_with_bid_cap": "Bid Cap",
        "cost_cap": "Cost Cap"
      },
      "viewableImpressReport": "Use Viewable Impression In Report",
      "downloadReport": "Download RTB Report",
      "delivery": "Delivery",
      "impres": "Impressions",
      "viewable": "Viewable Impres",
      "clicks": "Clicks",
      "cpc": "CPC",
      "ctr": "CTR",
      "vctr": "VCTR",
      "convs": "Conversions",
      "cpa": "CPA",
      "cvr": "CVR",
      "cboTimeLimit": "Need to wait {{time}} minutes to switch again",
      "campaignBudgetDisableHint": "Only available when Campaign Budget Optimize is ON.",
      "results": "Results",
      "uu": "Unique Users",
      "spent": "Spent",
      "view": "Video Views",
      "viewRate": "Video View Rate",
      "viewableViewRate": "Video Viewable View Rate",
      "videoPlayActions": "Video Views",
      "videoWatched2s": "2-Second Video views",
      "videoWatched6s": "6-Second Video views",
      "videoViewsP25": "Video views at 25%",
      "videoViewsP50": "Video views at 50%",
      "videoViewsP75": "Video views at 75%",
      "videoViewsP100": "Video views at 100%",
      "profileVisits": "Paid Profile Visits",
      "likes": "Paid Likes",
      "comments": "Paid Comments",
      "shares": "Paid Shares",
      "follows": "Paid Followers",
      "clicksOnMusicDisc": "Paid Music Clicks",
      "rtbCboLimitation": "All campaigns of the campaign group must have the same optimization goal and bid strategy to enable this feature.",
      "rtbCboDailyBudgetHint": "Campaign group contains campaigns that utilize Daily Budget therefore this feature is unavailable.",
      "cboRtbCampaignLengthLimit": "Campaign group must have at least one campaign to close CBO",
      "cboRtbCampaignBudgetLimit": "Campaign group contains campaigns that budget is less than daily minimum budget x the number of days: {{campaignIds}}"
    },
    "placeholders": { "searchbar": "Search Campaign Group Name and ID..." },
    "hints": { "editRtbCampaignBudgets": "Edit RTB campaign budgets" }
  },
  "adSetSetupFlow": {
    "mainStep": {
      "fieldset": { "optimizationTitle": "Optimization & Delivery" },
      "field": {
        "optimizationGoal": "Optimization for Ad Delivery",
        "bidStrategy": "Bid Strategy",
        "bidControl": "Bid Control",
        "billingEvent": "When You Get Charged",
        "frequencyControl": "Frequency Cap",
        "useFrequencyControl": "Use Frequency Control"
      },
      "labels": {
        "impression": "impression",
        "frequencyControl": "{{max_frequency}} {{event}}{{eventPlural}} every {{interval_days}} {{unit}}{{unitPlural}}",
        "frequencyCap": {
          "event": "{{event}}{{plural}} every",
          "unit": "{{unit}}{{plural}}"
        }
      },
      "errors": {
        "emptyMaxFrequency": "Frequency value can not be empty",
        "emptyIntervalDays": "Interval days can not be empty",
        "maxFrequencyOutofRange": "The frequency value must be within {{min}} ~ {{max}}",
        "intervalDaysOutofRange": "The interval days must be within {{min}} ~ {{max}}"
      }
    }
  },
  "optimizationGoal": {
    "impressions": "Impressions",
    "clicks": "Clicks",
    "video_views": "Video Views",
    "reach": "Reach",
    "sales": "Sales",
    "landing_page_views": "Landing Page Views",
    "fixed_viewable_impression": "Fixed Viewable Impression",
    "video_views_reach": "Video Views Reach",
    "acpm": "Publisher Impressions",
    "wcpm": "Screen Weight Impressions",
    "unspecified": "Unspecified"
  },
  "l1ObjectList": {
    "labels": {
      "l1ObjectCount": "CampaignGroup {{count}}",
      "drafts": "{{count}} drafts",
      "cbo": "CBO",
      "non-cbo": "Non-CBO",
      "activeState": "Active",
      "deactivateState": "Inactive",
      "deleteState": "Deleted",
      "notStartState": "Not Start",
      "endState": "End",
      "statusFilter": "Status",
      "statusFilterMenuTitle": "Select Status",
      "statusTag": "Status",
      "deliveryFilter": "Delivery Status",
      "deliveryFilterMenuTitle": "Select Delivery Status",
      "deliveryTag": "Delivery Status",
      "delivery": {
        "notStart": "Not Start",
        "noCreatives": "No Creatives",
        "normal": "Normal",
        "behind": "Behind",
        "severelyBehind": "Severely Behind",
        "ahead": "Ahead",
        "inactive": "Inactive",
        "end": "End",
        "pmpChanged": "PMP Changed"
      },
      "remainBudget": "Remain Budget",
      "undistributedBudget": "Undistributed Budget",
      "orderStateCannotCreate": "Cannot create campaign group when order state is not approve, seattle or seattled",
      "isEndCannotCreate": "Cannot create campaign group if order has been ended",
      "noChannelAllowed": "Cannot create campaign group when there are no given channels, please contact the administrator."
    }
  },
  "goSegmentForm": {
    "errors": {
      "uploadTypeErrorHint": "File format is {{type}} format, must be csv"
    },
    "titles": { "create": "Create Segment" },
    "hints": { "fileType": "only supports csv format" }
  },
  "l2ObjectOptimize": {
    "labels": {
      "lowest_cost_without_cap": "RTB will aim to spend your entire budget and get the most {{optimization}} using the lowest cost bid strategy. If you want to set a cost control, enter an amount.",
      "lowest_cost_with_bid_cap": "RTB will aim to get the most {{optimization}} without bidding more than {{bidControl}} in any auction using the bid cap bid strategy."
    }
  },
  "editLimitation": {
    "errors": {
      "repeat": "Some options has been selected in other sections",
      "someSelectedOptionInvalid": "Some {{name}} is invalid. Please delete and choose again",
      "tooManyKeywords": "Cannot exceed 30 keywords",
      "requireIncludeLimitation": "At least one limitation that limits traffic needs to be selected",
      "spaceOverBindingLimit": "{{count}} store(s)/device(s) are already bound by 10 campaigns during the schedule (including campaigns in paused campaign groups). Please remove them before submitting"
    },
    "buttons": { "importTargeting": "Import Targeting" }
  },
  "l1ObjectBudgetManagement": {
    "title": "Budget for {{num}} GoCampaigns",
    "headers": {
      "id": "Name",
      "status": "Status",
      "spent": "Amount Spent",
      "budget": "Budget"
    },
    "hints": { "campaignBudget": "Available Budget: {{total}}" }
  },
  "creativeBasicForm": {
    "labels": { "urlMacroInstruction": "Supported macros for creative url" },
    "titles": {
      "clickMacroDesc": "The system supports the following macros, which will be automatically replaced with related data. Please use \"&\" to concatenate different macros"
    }
  },
  "authenticationManager": {
    "errors": {
      "noActor": "Your account is not given any role, please contact the administrator."
    }
  },
  "orderDetails": {
    "buttons": {
      "downloadFinalReport": "Generate Final Report",
      "downloadOutdoorFinalReport": "Generate Outdoor Final Report"
    }
  },
  "accountManager": {
    "errors": {
      "localeMeFailed": "Failed to obtain account information, if this persists, please contact the system administrator"
    }
  },
  "registerPage": {
    "titles": {
      "notice": "Notice",
      "invalidLink": "Invalid Activation Link",
      "complete": "Setup Completed"
    },
    "messages": {
      "activated": "This activation link has been used and the user has been activated. Please login with your credential.",
      "resendEmail": "Please contact your account manager to resend the activation email."
    },
    "labels": {
      "setPassword": "Hi {{name}},<3/>please set your password",
      "completeTitle": "Setup Completed !",
      "completeMessage": "Password has been successfully set, please login to start using PMax3."
    }
  },
  "finalReportPage": {
    "titles": {
      "confirmation": "Permission Setting",
      "fail": "Fail",
      "common": {
        "adsPerformance": "Ads Performance",
        "overallAdsPerformance": "Overall Ads Performance",
        "overallReport": {
          "platform": "Reporting By Platfrom",
          "l1Object": "Reporting By Ad Product"
        },
        "chart": {
          "platform": {
            "CTR": "Daily Trend of Impressions by Platform vs Overall CTR (%)"
          },
          "l1Object": {
            "CTR": "Daily Trend of Impressions by Ad Product vs Overall CTR (%)",
            "VTR": "Daily Trend of Impressions by Ad Product vs Overall VTR (%)"
          }
        },
        "deepDiveBy": {
          "platform": "Audience Deep Dive by Platform -",
          "l1Object": "Audience Deep Dive by Ad Product -",
          "order": "Audience Deep Dive by Order - {{name}}"
        },
        "table": {
          "platform": "By Platform",
          "age_group": "By Age Group",
          "gender": "By Gender",
          "audience_segment": "By Audience Segment",
          "domain": "By Domain",
          "region": "By Region",
          "creative": "Top 5 Creative",
          "service_area": "Top 5 Location",
          "tenmax_segment": "Top 6 TenMax Segment",
          "traffic_category": "Top 5 Traffic Category"
        }
      },
      "outdoor": {
        "summaryInfo": "Ad Order Summary",
        "dailyInfo": "Daily Ad Impressions",
        "deliveryInfo": "Delivery Summary",
        "dailyInfoChart": "Daily Impressions & Foot Traffic"
      }
    },
    "messages": {
      "login": "Please login and start using PMax3.",
      "permission": "You don't have permission to view report data.",
      "exceeded": "Time exceeded during data fetching. Click 'OK' and retry.",
      "invalid": "Invalid path name or file not existed."
    },
    "labels": {
      "outdoor": {
        "advertiser": "Advertiser",
        "industry": "Industry",
        "period": "Period",
        "budget": "Budget",
        "creativeDuration": "Creative Duration",
        "cpm": "CPM Price",
        "targetImpression": "Target Impressions",
        "actualImpression": "Actual Impressions",
        "achievementRate": "Achievement Rate",
        "totalPlayHours": "Total Play Hours",
        "impres": "Impressions",
        "ePublisherImpres": "Foot Traffic",
        "storeCount": "Store Count",
        "totalImpres": "Total Impressions",
        "totalEPublisherImpres": "Total Foot Traffic",
        "thousandsUnit": "K",
        "district": "District",
        "impressionShareByCity": "Impression Share by City",
        "cityCounty": "City/County",
        "impressionShareByDistrict": "Impression Share by District",
        "store": "Store",
        "spent": "Spent",
        "totalPlayHoursValue": "Approx. {{hours}} hours",
        "noData": "No delivery data"
      },
      "common": {
        "header": { "confidential": "Confidential" },
        "settings": {
          "campaign_name": "Campaign Name",
          "period": "Period",
          "budget": "Budget",
          "order_name": "Order Name"
        },
        "overall": {
          "actual": {
            "impression": "Actual Impressions",
            "click": "Actual Clicks",
            "conversion": "Actual Conversions",
            "view": "Actual Views"
          },
          "target": {
            "impression": "Target Impressions",
            "click": "Target Clicks",
            "conversion": "Target Conversions",
            "view": "Target Views"
          }
        },
        "adsImpact": {
          "sales": "Sales (IDR)",
          "transactions": "Transactions (Orders)",
          "items_sold": "Items Sold",
          "basket_size": "Basket Size",
          "lapse_users": "Lapse Users",
          "new_users": "New Users",
          "existing_users": "Existing Users",
          "totalSummary": "Total Summary",
          "averageDaily": "Average Daily"
        },
        "table": { "impressions": "Imps.", "convs": "Convs." },
        "impressions": "Impressions",
        "clicks": "Clicks",
        "reach": "Reach",
        "convs": "Conversions",
        "views": "Views",
        "CTR": "CTR",
        "VTR": "VTR",
        "CPM": "CPM",
        "CPC": "CPC",
        "CPA": "CPA",
        "CPV": "CPV",
        "spend": "Spend",
        "sales": "Sales",
        "transactions": "Transactions",
        "items_sold": "Items Sold",
        "users": "Users",
        "new_users": "New Users",
        "lapse_users": "Lapse Users",
        "existing_users": "Existing Users",
        "basket_size": "Basket Size",
        "unknown": "Unknown",
        "open_rtb": "Open RTB",
        "edimax": "EdiMax Outdoor",
        "pic": "PIC Outdoor",
        "platform": "Platform",
        "age_group": "Age Group",
        "gender": "Gender",
        "audience_segment": "Audience Segment",
        "domain": "Domain",
        "region": "Region",
        "creative": "Creative",
        "service_area": "Service Area",
        "l1Object": "Ad Product",
        "tenmax_segment": "TenMax Segment",
        "traffic_category": "Traffic Category",
        "benchmark": {
          "awareness": "Facebook Awareness",
          "traffic": "Facebook Traffic",
          "mixed": "Open RTB by Gojek"
        },
        "createdTime": "Created Time: {{createTime}}",
        "notes": {
          "title": "Notes:",
          "key": {
            "actual_impressions": "Actual Impressions",
            "target_impressions": "Target Impressions",
            "impressions": "Impressions",
            "reach": "Reach",
            "clicks": "Clicks",
            "views": "Views",
            "CTR": "CTR",
            "VTR": "VTR",
            "CPM": "CPM",
            "CPC": "CPC",
            "CPV": "CPV",
            "others": "Others",
            "sales": "Sales",
            "transactions": "Transactions",
            "items_sold": "Items Sold",
            "new_users": "New Users",
            "lapse_users": "Lapse Users",
            "existing_users": "Existing Users",
            "basket_size": "Basket Size",
            "service_area": "Service Area",
            "benchmarks": "Benchmarks"
          },
          "value": {
            "actual_impressions": "How many times your ads were seen.",
            "target_impressions": "Impression target based on ad order.",
            "impressions": "How many times your ads were seen.",
            "reach": "How many people see your ads.",
            "clicks": "How many times your ads were clicked.",
            "views": "How many times your ads were viewed.",
            "CTR": "Click Through Rate. Number of clicks your ads received divided by the number of times your ads are shown (impressions).",
            "VTR": "View Through Rate. Number of views your ads received divided by the number of times your ads are shown (impressions).",
            "CPM": "Cost per 1,000 Impressions; total amount spent divided by total impressions recorded, multiplied by 1,000.",
            "CPC": "Cost per Ads Click; total amount spent divided by total clicks recorded.",
            "CPV": "Cost per Ads View; total amount spent divided by total views recorded.",
            "others": "Some of each breakdown report might be different from the total summary due to coverage gaps and data overlapping.",
            "sales": "Revenue (IDR) generated from transactions (orders) during campaign.",
            "transactions": "Total unique orders during campaign.",
            "items_sold": "Total items sold from transactions (orders) during campaign.",
            "new_users": "Users who have never made any purchase on Merchant / Brand.",
            "lapse_users": "Users who have not made any purchase in the last 60 days, then made purchase(s) during campaign period.",
            "existing_users": "Users who made purchase within the last 60 days.",
            "basket_size": "Average sales value per order.",
            "service_area": "Gojek area of operation; area classification is based of Gojek's grouping."
          }
        }
      },
      "tenmax": {
        "header": {
          "title": "Hi {{advertiser}}! Please find your TenMax Report below!"
        }
      }
    }
  },
  "forgotPasswordPage": {
    "labels": {
      "hints": "To reset your password, please enter your email below. Password reset instructions will be sent to the email address associated with your account.",
      "sentMailTitle": "Password reset letter already sent !",
      "sentMailMessage": "Please check your inbox from PMAX and click the link in mail to reset password.",
      "backToLogin": "Back to login"
    }
  },
  "callToAction": {
    "learn_more": "Learn More",
    "shop_now": "Shop Now",
    "watch_more": "Watch More",
    "buy_now": "Buy Now"
  },
  "audienceInfo": {
    "labels": {
      "audienceSelection": "Audience Selection",
      "audienceEstimatedSize": "Estimated Audience Size",
      "audienceSizeTooSmall": "Your audience is too specific for your ads to be shown. Try making it broader."
    },
    "buttons": { "estimate": "Estimate" }
  },
  "taInfoCard": {
    "labels": {
      "saveTargeting": "Save targeting settings for quick import next time.",
      "title": "Save Targeting",
      "hint": "Save current targeting for reuse. Please choose.",
      "new": "Save as new targeting",
      "replace": "Replace the original targeting",
      "taName": "Targeting Name",
      "toReplacedTAName": "Targeting: <1>{{name}}</1>"
    },
    "buttons": { "saveTargeting": "Save Targeting for Reuse" },
    "placeholders": { "taName": "Enter Targeting Name" },
    "errors": { "taNameHasBeenUsed": "This Name has been used." },
    "messages": {
      "createSuccess": "Create Success",
      "updateSuccess": "Update Success",
      "createFailed": "Create Failed",
      "updateFailed": "Update Failed"
    }
  },
  "savedTAManagement": {
    "labels": {
      "title": "Import from Saved Targetings",
      "taOptions": "Saved Targeting"
    },
    "buttons": { "import": "Import", "delete": "Delete this targeting" },
    "placeholders": { "taOptions": "Please Choose" },
    "titles": {
      "import": "Import Saved Targeting",
      "delete": "Delete Saved Targeting"
    },
    "messages": {
      "import": "Are you sure to replace current targeting with the selected saved targeting?",
      "delete": "Are you sure you want to delete this saved targeting? \nThis action cannot be undone.",
      "outdate": "This saved targeting has been outdated due to platform migration.",
      "deleteSuccess": "Delete Success",
      "deleteFailed": "Delete Failed"
    }
  },
  "filterMenuTab": { "labels": { "filterList": "Filter Menu" } },
  "draftCreateModal": {
    "buttons": {
      "goSummary": "Summary",
      "createDraft": "Create Draft",
      "addTarget": "Add Another Camapign Group"
    },
    "titles": {
      "duplicate": "Duplicate {{number}} {{l2Object}}",
      "target": "{{channel}} Campaign",
      "chooseTargetState": "Choose Target Campaign Groups"
    },
    "labels": {
      "order": "Order",
      "l1Object": "Campaign Group",
      "numberOfCopies": "Number Of Copies",
      "includeBinding": "Bind Creatives"
    },
    "hints": {
      "cannotBindHint": "if the creative binding is not created from PMAX or has been edited on self-serve platform, it wll not be copied.",
      "l1ObjectNeedSameChannel": "Only campaign groups of the same channel can be chosen."
    }
  },
  "draftSummaryStateContent": {
    "labels": {
      "confirmationTitle": "Campaign Duplicate Confirmation",
      "description": "The source campaign will be copied into the following campaign groups as drafts.",
      "hints": "All associative information like basic Information, price model targeting and targeting will be duplicated. \nThe copies of campaign will be saved as drafts and deliveried after confirmation. \nIf the bid control is different from the campaign group you choose, it will change based on the group you selected."
    },
    "confirmations": {
      "labels": {
        "order": "Order",
        "l1Object": "Campaign Group",
        "channel": "Group Channel",
        "creative": "Creative",
        "copies": "Copies",
        "status": "Validation Status"
      }
    },
    "status": {
      "passed": "Passed",
      "error": {
        "endDate": "Destination order has ended.",
        "delivery": "There are some issues in copy destination.",
        "account": "The source and destination must belong to the same ad account."
      },
      "warning": {
        "bindings": "{{num}} creative bindings won’t be copied because source ads are either disapproved, edited on-self-serve platform, or with platform issues."
      }
    }
  },
  "draftSourceDetails": {
    "labels": {
      "sourceDetails": "Source Details",
      "orderName": "Order Name",
      "groupName": "Group Name",
      "channel": "Group Channel",
      "selectedOfCampaigns": "Selected Of Campaigns"
    }
  },
  "draftCamapignGroupOption": { "hints": { "selected": "Selected" } },
  "draftSummaryState": {
    "labels": { "createSuccess": "Draft Create Success" }
  },
  "campaignSetupFlow": {
    "messages": {
      "updateDraftSuccess": "Draft Update Success",
      "updateDraftFailed": "Draft Update Failed",
      "publishBindingFailed": "The RTB campaign was successfully created, but ad bindings creation failed. Don't forget to include some creatives later.",
      "publishL2L3Success": "The RTB campaign and ad bindings was successfully created.",
      "publishL2Success": "The RTB campaign was successfully created.",
      "publishL2L3Failed": "Failed to establish RTB campaign and ad binding."
    },
    "summaryStep": {
      "draftBindingTitle": "Creatives Binding",
      "labels": { "draftBinding": "Creative" },
      "message": {
        "willDeliverImmediately": "Because the campaign sschedule has been started, ads will start to deliver immediately after the draft is published."
      }
    }
  },
  "orderType": { "enums": { "tenmax": "TenMax" } },
  "rtbCampaign": {
    "billingEvent": {
      "rs": {
        "reach": "Impressions",
        "impressions": "Impressions",
        "clicks": "Clicks",
        "video_views": "Video Views",
        "video_views_reach": "Video Views",
        "sales": "Clicks",
        "acpm": "Impressions",
        "wcpm": "Impressions"
      },
      "rb": {
        "reach": "Impressions",
        "impressions": "Impressions",
        "clicks": "Clicks",
        "video_views": "Video Views",
        "sales": "Conversions"
      },
      "dcpm": "Impressions",
      "fcpm": "Impressions",
      "fcpv": "Video Views",
      "fcpc": "Clicks",
      "fvcpm": "Impressions",
      "facpm": "Impressions",
      "fwcpm": "Impressions",
      "fbcpm": "Cost Per Message",
      "unspecified": "Unspecified"
    },
    "limitation": {
      "operationSet": { "preferred": "Preferred", "include": "Selected" }
    }
  },
  "orderDownloadReportPanel": {
    "labels": {
      "audienceData": "Audience Data",
      "country": "Country",
      "domain": "Domain"
    }
  },
  "campaignDashboard": {
    "labels": {
      "future": "future",
      "ago": "ago",
      "endsin": "ends in",
      "days": "days",
      "impres": "Impressions",
      "clicks": "Clicks",
      "ctr": "CTR",
      "campaignCount": "Campaign Volume",
      "spent": "Spent",
      "orderTotalBudget": "Order Total Budget",
      "orderCount": "Order Volume",
      "orderTotalSpent": "Order Total Spent",
      "optimization": "Optimization",
      "bidStrategy": "Bid Strategy",
      "bidCap": "Bid Cap",
      "adType": "Ad Type",
      "campaignStatus": "Campaign Status",
      "pleaseSearch": "Please click search button to search for matching campaigns",
      "noData": "No data",
      "adjustmentNeeded": "Adjustment Needed",
      "allCampaigns": "All Campaigns"
    },
    "titles": {
      "main": "Campaign Dashboard",
      "today": "Today",
      "yesterday": "Yesterday"
    },
    "buttons": { "search": "Search", "download": "Download" },
    "placeholders": { "searchbar": "Search Campaign..." },
    "headers": {
      "campaignId": "Name",
      "adjustmentTags": "Adjustment Needed",
      "agencyName": "Agency",
      "advertiserName": "Advertiser",
      "orderName": "Order",
      "executeRate": "Progress",
      "ctr": "CTR",
      "bidPrice": "Bid Price",
      "startDate": "Start Date",
      "endDate": "End Date",
      "optimize": "Optimization & Bid Price",
      "magnificationRatio": "Weight",
      "orderId": "Order ID",
      "campaignId_excel": "Campaign ID",
      "campaignName": "Campaign Name",
      "adType": "Ad Type",
      "budget": "Budget",
      "spent": "Spent",
      "optimize_excel": "Optimization"
    },
    "fileNames": {
      "filterInfo": {
        "1": "ends_in_{{days}}_days",
        "-1": "ended_{{days}}_days_ago"
      },
      "allAdTypeInfo": "all_ad-types",
      "statusInfo": {
        "1": "active_campaign",
        "2": "inactive_campaign",
        "-1": "all_campaigns"
      }
    }
  },
  "adType": {
    "one_for_all_display": "One For All Display Ads",
    "display": "Display Ads",
    "third_party_bottom": "Mobile Footer Ads",
    "third_party_rectangle": "Medium Rectangle Ads",
    "video": "Video Ads",
    "combo": "Video + Image Ads",
    "pic_short": "PIC Outdoor 15s Ads",
    "pic_long": "PIC Outdoor 30s Ads",
    "pic_extended": "PIC Outdoor 60s Ads",
    "pic_broad": "PIC Outdoor 60+s Ads",
    "hwacom_short": "HwaCom 15s Ads",
    "hwacom_long": "HwaCom 30s Ads",
    "hwacom_extended": "HwaCom 60s Ads",
    "hwacom_broad": "HwaCom 60+s Ads",
    "fridge_broad": "WI Fridge 60+s Ads",
    "fridge_long": "WI Fridge 30s Ads",
    "fridge_extended": "WI Fridge 60s Ads",
    "pmp_fridge": "PMP WI Fridge Ads",
    "outdoor_line_message": "Outdoor Line Message Ads",
    "line_message": "Line Message Ads",
    "unknown": "Unknown Ads",
    "third_party": "Third Party Ads",
    "ctv": "CTV Ads",
    "message": "Message Ads",
    "pmp_pic": "PMP PIC Outdoor Ads",
    "sandbox_outdoor": "Sandbox Outdoor Ads",
    "sandbox_movable_outdoor": "Sandbox Movable Outdoor Ads"
  },
  "storedValueList": {
    "headers": {
      "adAgencyId": "Agency ID",
      "used": "Used Amount",
      "stored": "Total Amount",
      "remain": "Remain Amount"
    },
    "labels": { "title": "Stored Value", "noData": "No Stored Value Info" },
    "placeholders": { "searchbar": "Search Agency..." }
  },
  "storedValueDetail": {
    "labels": {
      "title": "Stored Value - {{agencyName}}",
      "remainValue": "Remain Amount",
      "totalValue": "Total Amount",
      "usedValue": "Used Amount"
    },
    "buttons": { "addValue": "Add Value", "editValue": "Edit Value" }
  },
  "storedValueLog": {
    "headers": {
      "createTime": "Date",
      "description": "Description",
      "comment": "Comment",
      "amount": "Amount",
      "remain": "Remain Amount"
    },
    "labels": { "noData": "No Data" }
  },
  "storedValueEditModal": {
    "labels": {
      "agency": "Agency",
      "amount": "Amount",
      "comment": "Comment",
      "editConfirm": "Are you sure you want to change stored value for {{agencyName}} ?"
    },
    "buttons": { "stored": "Store" },
    "titles": { "addValueTitle": "Add Value", "editValueTitle": "Edit Value" }
  },
  "sourceList": {
    "title": "Source List",
    "buttons": { "create": "+ Source" },
    "headers": {
      "name": "Name",
      "duration": "duration",
      "tags": "Segment Label",
      "countries": "Segment Country"
    },
    "placeholders": {
      "searchbar": "Search Source Name and ID...",
      "noData": "No data, let ’s add a new source"
    }
  },
  "source": {
    "labels": {
      "name": "Name",
      "duration": "duration",
      "tags": "Segment Label",
      "countries": "Segment Country"
    }
  },
  "sourceForm": {
    "titles": { "create": "Create Source", "edit": "Edit Source" },
    "hints": {
      "durationLimit": "The duration is limited to 30 days to 365 days"
    }
  },
  "sourceDetail": {
    "title": "Segment Information",
    "titles": { "info": "Segment Name: {{name}}" },
    "buttons": { "edit": "Edit Source" }
  },
  "categoryList": {
    "buttons": { "create": "+ Category" },
    "placeholders": {
      "noData": "No data, let ’s add a new category",
      "searchbar": "Search Category Name and ID and Category Type..."
    },
    "headers": {
      "name": "Name",
      "tenmaxCategory": "Category Type",
      "audienceCount": "Audience Count"
    },
    "hints": {
      "importCookie": "Import cookie",
      "importDeviceId": "Import device id",
      "export": "Export Segments",
      "importSuccess": "Import success!",
      "exportSuccess": "Export success!"
    }
  },
  "categoryForm": {
    "titles": { "edit": "Edit Category", "create": "Create Category" }
  },
  "category": {
    "labels": { "name": "Name", "tenmaxCategory": "Category Type" }
  },
  "customLayoutList": {
    "title": "Custom Layout",
    "tooltips": {
      "delete": "Delete custom layout",
      "deleteDisabled": "This custom layout cannot be deleted"
    },
    "alerts": {
      "delete": {
        "title": "Delete custom layout",
        "message": "Are you sure you want to delete custom layout: {{name}} ?"
      }
    },
    "placeholders": {
      "noData": "No data, let ’s create a new custom layout.",
      "searchbar": "Search custom layout name or id"
    },
    "buttons": {
      "create": "+ Custom Layout",
      "preview": "Preview custom layout"
    },
    "headers": {
      "name": "Layout Name",
      "previewUrl": "Layout Preivew",
      "layoutId": "Layout ID",
      "device": "Device Type",
      "type": "Layout Type"
    }
  },
  "customLayoutSetupFlowPage": {
    "labels": {
      "upload": "Upload Custom Layout",
      "setup": "Setup Macro",
      "preview": "Preview",
      "name": "Layout Name",
      "layoutId": "Layout ID",
      "previewUrl": "Preview URL",
      "type": "Layout Type",
      "device": "Device Type",
      "template": "Layout File",
      "desktop": "Desktop",
      "mobile": "Mobile",
      "rectangleLayout": "Custom Rectangle Layout",
      "bottomLayout": "Custom Bottom Layout"
    },
    "titles": { "create": "Create Custom Layout" },
    "breadcrumbs": { "home": "Custom Layouts", "create": "New" },
    "hints": { "templateContent": "The zip file needs to contain ad_tag.html" },
    "errors": {
      "zipContentError": "The zip file needs to contain ad_tag.html"
    },
    "buttons": { "configMacro": "Config Macro" }
  },
  "fieldConfigPage": {
    "labels": {
      "fieldName": "Field Name",
      "fieldDescription": "Field Description",
      "fieldType": "Field Type",
      "fileSize": "File Height & Width",
      "fileStorage": "File Storage",
      "fileRatio": "File Ratio",
      "fileType": "File Type",
      "videoDuration": "Video Duration",
      "textMinLength": "Minimum Words",
      "textMaxLength": "Maximum Words"
    }
  },
  "formikConfigInputField": {
    "errors": {
      "fileSize": "The size of this file is {{size1}}, and must be equal to {{size2}}",
      "fileRatio": "The ratio of this file must be {{ratio}}",
      "fileType": "The format of this file is {{type}} format, must be {{types}}",
      "fileStorage": "This size of this file is {{storage1}} and must be less than {{storage2}}",
      "minLength": "The word count must be larger than {{min}}",
      "maxLength": "The word count must be less than {{max}}",
      "videoDuration": "This length of this video is {{duration1}} seconds and must be less than {{duration2}} seconds"
    },
    "hints": {
      "fileSizeLimit": "The size of this file must be equal to {{limit}}",
      "fileRatioLimit": "The proportion of this file which must be {{limit}}",
      "fileStorageLimit": "This size of this file must be less than {{limit}} MB",
      "fileTypeLimit": "The format of this file must be {{limit}}",
      "videoDurationLimit": "The length of the video cannot exceed {{limit}} seconds",
      "textMinLengthLimit": "The word count must be larger than {{limit}}",
      "textMaxLengthLimit": "The word count must be less than {{limit}}"
    }
  },
  "macroFieldPlaceholder": {
    "hints": {
      "pleaseConfigMacro": "Please set the Macro name, description, type and other additional restrictions"
    }
  },
  "videoFormInput": {
    "errors": {
      "loadingVideo": "Unable to read the video, please provide a video with encoding format: av1, H.265 or H.264"
    }
  },
  "customLayoutForm": { "labels": { "customLayout": "Custom Layout" } },
  "fieldTypes": {
    "image": "Image",
    "video": "Video",
    "url": "Url",
    "text": "Text"
  },
  "messageSegments": { "title": "Message Segment" },
  "messageSegmentForm": {
    "titles": {
      "create": "Create Message Segment",
      "edit": "Edit Message Segment"
    },
    "fields": {
      "select": "Select Segments",
      "description": "Description",
      "name": "Segment Name",
      "advertiser": "Advertiser"
    },
    "hints": {
      "selectHint": "Generated audience brief",
      "emailCount": "The count of emails: {{count}}",
      "phoneCount": "The count of phones: {{count}}",
      "gIdCount": "The count of segments: {{count}}"
    },
    "inventory": {
      "titile": "Categories",
      "contentPlaceholder": "Choose a category to select segments",
      "segmentCount": "{{total}} segments"
    },
    "buttons": { "segmentCountBtn": "Show the Count of Audience Brief" }
  },
  "messageSegmentList": {
    "buttons": { "create": "+ Message Segment" },
    "placeholders": { "searchbar": "Search Message Segment Name and ID..." },
    "labels": {
      "deleteModalContent": "Are you sure you want to delete this segment?"
    },
    "hints": {
      "noData": "No data, let ’s add a new segment",
      "edit": "Edit Segment"
    },
    "headers": {
      "id": "Name",
      "description": "Description",
      "maxAliveDate": "Expiration date"
    }
  },
  "picFormModel": {
    "hints": {
      "videoDuration": "Video duration should be between {{min}} and {{max}} seconds",
      "audioDuration": "Audio duration should be between {{min}} and {{max}} seconds",
      "videoDurationMin": "Video length should be at least {{min}} seconds",
      "audioDurationMin": "Audio length should be at least {{min}} seconds"
    }
  },
  "customOutdoorDevice": {
    "buttons": {
      "switchToList": "Switch to Normal Mode",
      "switchToMap": "Open Map Mode",
      "previewRadius": "Show Area",
      "confirmRadius": "Confirm Add",
      "removeRadius": "Remove from Area",
      "viewDevices": "View Devices",
      "hideDevices": "Hide Devices"
    },
    "placeholder": { "searchGoogleMap": "Search Google Maps" },
    "popout": { "title": "Device Name" },
    "cluster": {
      "added": "Added",
      "filtered": "Filtered",
      "normal": "Normal",
      "full": "Over binding limit"
    }
  },
  "pmp": {
    "pmpTypes": { "buyout": "Buy Out", "sponsorship": "Sponsorship" },
    "labels": {
      "pmpType": "PMP Type",
      "budget": "Budget",
      "name": "PMP Order Name",
      "duration": "Duration",
      "dayparts": "Dayparts Setting",
      "spaces": "Devices",
      "agency": "Agency ID",
      "channelGroupId": "Channel",
      "noAgency": "No Agency Info"
    },
    "adminStatus": {
      "notBinding": "Not Bound",
      "binding": "Bound",
      "stop": "Inactive",
      "finish": "End",
      "expired": "Expired"
    }
  },
  "pmpList": {
    "title": "PMP Order",
    "buttons": {
      "create": "+ PMP Order",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "showDevices": "Show devices"
    },
    "placeholders": {
      "searchbar": "Search PMP Order Name...",
      "noData": "No data, let ’s add a new pmp order"
    },
    "headers": {
      "name": "PMP Order Name",
      "status": "Status",
      "adAgencyId": "Agency ID",
      "budget": "Budget and PMP Mode",
      "schedule": "Schedule",
      "space": "Outdoor Device",
      "channelGroupId": "Channel"
    },
    "hints": {
      "cannotEdit": "Deactivated, expired, or orders that have exceeded their last set time cannot be edited",
      "pmpStatus": "Cannot edit pmp order after binding by agency."
    },
    "labels": {
      "devicesInfo": "Outdoor Device Info",
      "deactivateSuccess": "Deactivate PMP Order Success"
    }
  },
  "pmpActivateModal": {
    "titles": { "sponsorshipConflict": "Conflicts with existing PMP orders" },
    "hints": {
      "conflictWith": "Conflicts due to",
      "durationConflict": "Duration overlap",
      "spaceConflict": "Space overlap",
      "boundPmpSuggest": "This is a bound PMP order. It is recommended to create a new order to meet the new needs.",
      "unboundPmpSuggest": "This is an unbound PMP order and can be opened after modifying the duration and placement."
    }
  },
  "pmpSetupFlowPage": {
    "titles": {
      "create": "Create PMP Order",
      "edit": "Edit PMP Order",
      "summary": "PMP Order Summary",
      "formSection": "PMP Order Setting",
      "summarySection": "PMP Order Summary"
    },
    "labels": {
      "createSuccess": "Create PMP Order Success",
      "updateSuccess": "Update PMP Order Success"
    }
  },
  "pmpForm": {
    "errors": {
      "sponsorshipConflict": "The selected space duration overlap",
      "createBeforeMinDate": "The start time must be after the day after tomorrow"
    },
    "hints": {
      "budget": "Based on current settings, the recommended budget is {{min}}",
      "dayparts": "※ When the dayparts is disabled, it means selecting all"
    }
  },
  "channelGroups": {
    "title": "Channel Group Management",
    "titles": {
      "epaperDefaultImageTab": "E-paper Default Image",
      "epaperDefaultImageContent": "E-paper Default Image",
      "basicTab": "Channel Group",
      "specialSettingsTab": "Campaign Special Settings",
      "reportTab": "Report Setting",
      "bidPriceTab": "Bid Price",
      "adTypesTab": "Ad Type Settings",
      "outdoorCreativeSizesTab": "Outdoor Creative Size Settings",
      "basicContent": "Channel Group Information",
      "specialSettingsContent": "Campaign Special Settings",
      "reportContent": "Report Setting",
      "bidPriceContent": "Bid Price",
      "edit": "Edit Channel Group",
      "derecognitionAgencyContent": "Sales Not Recognized Agencies",
      "adTypesContent": "Ad Type Settings",
      "outdoorCreativeSizesContent": "Outdoor Creative Size Settings",
      "defaultMargin": "Reconciliation Report Default Margin",
      "currencyContent": "Report Currency",
      "create": "Create Channel Group",
      "nonExpressPassCategoriesTab": "Non-Express-Pass Categories",
      "nonExpressPassCategoriesContent": "Non-Express-Pass Creative Categories",
      "auditLogTab": "Audit Log",
      "brandContent": "Channel Brand Information"
    }
  },
  "channelGroup": {
    "labels": {
      "name": "Channel Group",
      "publisherIds": "Publisher ID",
      "creativeSizes": "Creative Size Setting",
      "supportPMP": "Support PMP",
      "supportWeatherTargeting": "Weather Targeting",
      "isScreenSpliced": "Video Wall",
      "isMultiScreenSameVideo": "Synchronized Playback",
      "screenSplicedVerticalScreenCount": "Vertical Screen Count",
      "screenSplicedHorizontalScreenCount": "Horizontal Screen Count",
      "multiSplicedScreenCreativeSize": "Multi Spliced Screen Size",
      "singleScreenCreativeSize": "Single Screen Size",
      "deliveryUnit": "Delivery Unit",
      "alertEmails": "Alert Emails",
      "siteId": "Site ID",
      "archivedSuffix": "(Archived)",
      "isCompositeCreative": "Composite creative",
      "compositePixelSize": "Actual display size",
      "allowedVideoCodecs": "Supported Video Codecs",
      "allowedVideoCodecsAll": "All",
      "supportCBO": "Support CBO"
    },
    "compositeSettingError": {
      "notSynced": "Composite setting not yet synced from RMax",
      "sizeMissing": "Actual display size is missing",
      "sizeNotMultiple": "Actual display size is not a multiple of the slot size",
      "sizeTooSmall": "Actual display size is smaller than the total video wall size"
    },
    "filter": {
      "statusFilter": "Channel Status",
      "statusFilterMenuTitle": "Select Channel Status",
      "statusTag": "Status"
    },
    "status": { "active": "Active", "all": "All", "archived": "Deactivated" }
  },
  "channelGroupForm": {
    "labels": {
      "epaperDefaultImage": "Default Image",
      "epaperDefaultImageNoScreenSizeError": "This channel has no screen resolution synced yet; image size cannot be validated.",
      "name": "Channel Group Name",
      "nameI18n": {
        "ja": "Channel Group Name (Japanese)",
        "en": "Channel Group Name (English)",
        "zh-tw": "Channel Group Name (Traditional Chinese)"
      },
      "publisherIds": "Publisher ID",
      "salesChannelReportShowOverspend": "Deduct Overspending",
      "derecognitionAgencyIds": "Sales Not Recognized Agencies",
      "defaultMargin": "Reconciliation Report Default Margin",
      "limitPublisherId": "Limit Publisher",
      "publisherNotLimited": "Not limited",
      "supportPMP": "Support PMP",
      "supportWeatherTargeting": "Weather Targeting",
      "noPublisherIdWarning": "The RMax system administrator needs to be notified that the sales channel has not yet been assigned a publisher ID, which will affect PMax campaigns. Please adjust this as soon as possible to avoid delivery anomalies.",
      "alertEmails": "Alert Emails",
      "currency": "Report Currency",
      "nonExpressPassCategories": "Creative Categories",
      "supportCBO": "Support CBO",
      "supportCBOStaticChannelHint": "CBO is enabled by default for this channel and is not controlled by this switch.",
      "supportCBOUnsupportedChannelHint": "CBO is not available for this channel; this switch has no effect.",
      "brandNameI18n": {
        "ja": "Brand Name (Japanese)",
        "en": "Brand Name (English)",
        "zh-tw": "Brand Name (Traditional Chinese)"
      },
      "brandUrl": "Brand Link",
      "brandFilteredIcon": "Map Marker Image (Matches Filter)",
      "brandNormalIcon": "Map Marker Image (Not Matched / Full)",
      "brandIconTypeHint": "Supports SVG or PNG format",
      "brandIconPinHint": "The pin tip must be at the bottom center of the image",
      "brandIconTypeError": "Image format must be svg or png",
      "brandNameInvalidCharError": "Cannot contain line breaks, control or invisible characters, < or >",
      "brandNameUrlError": "Cannot contain URLs or email addresses",
      "brandUrlError": "Please enter a valid URL starting with http:// or https://"
    },
    "placeholders": { "alertEmails": "Press Enter to add an email" },
    "errors": {
      "publisherIdIsUsed": "Publisher ID is used by other channel group: {{overlapIds}}"
    }
  },
  "channelGroupList": {
    "placeholders": { "searchbar": "Search Channel Group's Name or ID" },
    "labels": {
      "noData": "No data",
      "archiveReasonPmax": "PMax: {{reason}}",
      "archiveReasonRmax": "RMax: {{reason}}"
    },
    "hints": { "edit": "Edit Channel Group" },
    "buttons": { "create": "+ Channel Group" },
    "headers": { "archiveReason": "Deactivation Reason", "status": "Status" }
  },
  "channelGroupDetail": {
    "labels": {
      "name": "Channel Group Name: {{name}}",
      "archiveConfirmTitle": "Deactivate this sales channel?",
      "archiveConfirmContent": "Active campaigns under this channel will be paused.\nPMP orders under this channel will be deactivated, and the corresponding deals on RMax will be deleted.\nReactivating the channel restores none of this — deleted deals have to be created again.",
      "unarchiveConfirmTitle": "Reactivate this sales channel?",
      "unarchiveConfirmContent": "The channel can be selected again.\nCampaigns and PMP orders deactivated earlier stay deactivated and have to be reopened by hand.\nDeals already deleted on RMax are not restored and have to be created again.",
      "archiveStatus": "Channel Status",
      "archiveStatusArchived": "Deactivated",
      "archiveStatusActive": "Active",
      "archiveReason": "Deactivation Reason"
    },
    "buttons": { "archive": "Deactivate", "unarchive": "Reactivate" },
    "placeholders": {
      "archiveReason": "Describe why this channel is deactivated"
    }
  },
  "channelGroupMembers": {
    "buttons": { "addMember": "+ Member" },
    "headers": {
      "id": "No.",
      "email": "Email",
      "name": "Name",
      "status": "Status",
      "permission": "Permission"
    },
    "active": "Enable",
    "inactive": "Disable",
    "permissions": {
      "RECONCILIATION_OFFICER": "Financial Personnel | Reconciliation Personnel",
      "BEACON_ADMIN": "Beacon Admin | System Admin",
      "BEACON_EXECUTIVE": "Beacon Executive | Focused on ad delivery and beacon maintenance, responsible for setting up push content."
    },
    "labels": { "noDataAvailable": "No data, let ’s add a new member" },
    "hints": { "delete": "Delete Account Permission" }
  },
  "beaconConnectionList": {
    "labels": {
      "newBeaconConnection": "+ Beacon Connection",
      "beaconType": "Beacon Type",
      "lineOAName": "Line OA name",
      "tenMaxBeaconName": "TenMax Beacon name"
    },
    "hints": { "edit": "Edit Beacon Connection" },
    "placeholders": {
      "noData": "No data, let ’s add a new beacon connection",
      "searchbar": "Search Beacon Connection's Name..."
    },
    "headers": {
      "beaconType": "Beacon Type",
      "name": "Name",
      "webhookType": "Webhook Type",
      "hardwareId": "Hardware ID",
      "otherInfo": "Other Beacon Info"
    }
  },
  "beaconConnectionForm": {
    "titles": {
      "create": "Create Beacon Connection",
      "edit": "Edit Beacon Connection"
    }
  },
  "beaconType": {
    "lineSimpleBeacon": "Line Simple Beacon",
    "tenmaxBeacon": "TenMax Beacon"
  },
  "beaconField": { "labels": { "messageType": "Message Type" } },
  "outdoorLineMessageField": {
    "labels": {
      "imageMessage": "Push Image",
      "videoMessage": "Push Video",
      "videoMessagePreview": "Push Video Preview",
      "textMessage": "Push Message",
      "messageTypes": {
        "text": "Text",
        "image": "Image",
        "video": "Video",
        "join": "Add Line Friend",
        "coupon": "Coupon"
      },
      "officialAccount": "Line Official Account",
      "coupon": "Coupon"
    },
    "hints": {
      "imageType": "Picture only supports png or jpg format",
      "storage": "File size must be less than {{storage}} MB",
      "imageRatio": "The ratio of this graph must be {{ratio}}",
      "videoType": "Video only supports mp4 format",
      "videoDuration": "Can use up to 120 seconds of video",
      "videoRatio": "The ratio of this video must be {{ratio}}",
      "officialAccount": "Please enter an official account that starts with @"
    }
  },
  "outdoorLineMessageFields": { "labels": { "addLineMessage": "Push Type" } },
  "creativeSummaryStep": {
    "labels": {
      "lineMessage": "Message",
      "beaconInfo": "Beacon Info",
      "beaconSetting": "Beacon Settings",
      "join": "Add Line Official Account <1>{{value}}</1>",
      "coupon": "Coupon <1>{{value}}</1>"
    }
  },
  "outdoorTenMaxBeaconMessageField": {
    "labels": {
      "messageTypes": { "text": "Text" },
      "messageType": "Message Type",
      "bundleIds": "Bundle ID",
      "deepLinkIOS": "iOS App Page Parameter",
      "deepLinkAndroid": "Android App Page Parameter",
      "dataIOS": "iOS App Page Parameter",
      "dataAndroid": "Android App Page Parameter",
      "title": "Notification Title",
      "message": "Notification Context"
    },
    "errors": {
      "data": "You need to fill in the App page parameters of iOS or Android",
      "bundleIdsUnique": "Bundle IDs should be unique"
    },
    "hints": { "inputLength": "You can fill in {{length}} characters" },
    "placeholders": {
      "bundleIds": "Enter the ID and complete the Bundle ID creation with Enter"
    }
  },
  "selectPmpStep": {
    "buttons": {
      "createNewCreative": "Create Creative",
      "bindCreative": "Bind Creative"
    }
  },
  "pmpComparingModal": {
    "title": "PMP View Changes",
    "labels": { "currentPmp": "Before", "newPmp": "After" }
  },
  "adminBidPriceModal": {
    "titles": { "manageAdminBidPrice": "{{id}} Modify Bid Price Setting" }
  },
  "adminBidPrice": { "labels": { "modifyAdminBidPrice": "Modify Amount" } },
  "modifyTrackingState": { "title": "Edit All Kinds of Tracking" },
  "modifyScheduleState": {
    "title": "Edit Schedule",
    "enableStartDate": "Start Date",
    "enableEndDate": "End Date",
    "startDateCannotModifyHint": "Cannot modify start date after started",
    "titles": { "conflictCampaigns": "Campaigns that will be ignored" },
    "hints": {
      "conflictCampaigns": "New settings conflict with original schedule of campaign, the original schedule will be retained"
    },
    "messages": { "scheduleUpdated": "Batch edit schedule success" }
  },
  "modifyLimitationState": {
    "titles": {
      "add": "Add Limitation",
      "remove": "Remove Limitation",
      "ignoreCampaigns": "Campaigns that will be ignored"
    },
    "hints": {
      "remove": "The selected items will be removed",
      "ignoreRemoveFromCampaigns": "You need to select at least one Adx to avoid delivery problems",
      "ignoreAddToCampaigns": "If the added settings conflict with the original settings of the campaign, the original settings will be retained"
    }
  },
  "ignoreCampaignSummary": {
    "headers": {
      "name": "Campaign Name",
      "limitation": "Original Settings",
      "originalSettings": "Original Settings"
    }
  },
  "limitationSummaryState": {
    "titles": { "add": "New Settings", "remove": "Removed Settings" }
  },
  "channelGroupAdTypeForm": {
    "titles": { "addAdType": "Add Ad Type" },
    "labels": {
      "screenDisplayType": "Playback characteristic",
      "name": "Name",
      "nameI18n": {
        "ja": "Name (Japanese)",
        "en": "Name (English)",
        "zh-tw": "Name (Traditional Chinese)"
      },
      "minDuration": "Creative Min Duration",
      "maxDuration": "Creative Max Duration",
      "width": "Creative Width",
      "height": "Creative Height",
      "outdoorType": "Outdoor Type",
      "pricingModel": "Price Model",
      "state": "Enable Campaign Ad Type",
      "duration": "Creative Duration"
    },
    "errors": {
      "duplicateName": "Duplicate Ad Type Name",
      "durationOverlap": "Duration overlap with ad type: {{adTypes}}",
      "cannotUseRsPricingModelAlone": "RS pricing mode cannot be selected alone.",
      "adTypeUsed": "Ad types that cannot be deleted once in use: {{adTypes}}"
    }
  },
  "channelGroupAdTypeList": {
    "buttons": { "new": "+ Ad Type" },
    "headers": {
      "id": "Name and ID",
      "screenDisplayType": "Playback characteristic",
      "duration": "Creative Duration",
      "size": "Creative Size",
      "state": "State",
      "pricingModel": "Price Model",
      "deliveryUnit": "Delivery Unit",
      "supportedOutdoorTypes": "Supported Outdoor Types"
    },
    "placeholders": { "noData": "No data, let ’s add a new ad type" },
    "labels": {
      "active": "Active",
      "inactive": "Inactive",
      "deleted": "Deleted"
    },
    "hints": { "edit": "Edit Ad Type", "delete": "Delete Ad Type" }
  },
  "outdoorCreativeSizeHint": {
    "labels": {
      "creativeInfoHint": "Creative Information Reminder",
      "sizeInstruction": "Size Instruction",
      "minSize": "Min Size",
      "maxSize": "Max Size"
    }
  },
  "outdoorDeviceReport": {
    "labels": {
      "metricType": "Data Type",
      "scheduledTimeRange": "Duration",
      "timeSlot": "Hour",
      "ePublisherImpresTotal": "Total Publisher Impressions",
      "impresTotal": "Total Impressions",
      "csvFileName": "device-delivery-performance_{{from}}-{{to}}_{{metric}}.csv",
      "backToTop": "Back to top"
    },
    "headers": { "storeName": "Store Name", "deviceName": "Device Name" },
    "title": "Outdoor Deliver Performance",
    "errors": {
      "maxQueryHours": "Day range must be less than {{hours}} hours"
    },
    "hints": {
      "filterRangeLimit": "When filtering by campaign or store, the date range can be at most {{days}} days and must be within the last {{months}} months"
    }
  },
  "outdoorDeviceMetric": {
    "labels": {
      "ePublisherImpres": "Publisher Impressions",
      "impres": "Impressions"
    }
  },
  "outdoorDeviceGran": {
    "labels": {
      "day": "Hourly Accumulation by Day",
      "hour": "Display by Day and Hour"
    }
  },
  "outdoorDeviceReportChart": {
    "title": {
      "ePublisherImpres": "People Distribution",
      "impres": "Impression Distribution"
    }
  },
  "merchantList": {
    "labels": {
      "agencyOptionsTitle": "Merchant",
      "nodata": "No data",
      "newMerchant": "+ Official Account"
    },
    "title": "Official Account",
    "headers": { "name": "Brand Name", "officialAccount": "Official Account" },
    "placeholers": { "searchBar": "Search Brand Name or Official Account..." }
  },
  "merchantDetail": {
    "labels": {
      "name": "Brand name: {{name}}",
      "title": "Official Account and Beacon List",
      "editMerchant": "Edit Official Account"
    }
  },
  "merchantForm": {
    "titles": {
      "create": "Create Official Account",
      "edit": "Edit Official Account"
    },
    "labels": {
      "id": "Official Account ID",
      "name": "Brand Name",
      "website": "Official Website",
      "category": "Creative Categories",
      "note": "Note",
      "agency": "Merchant"
    }
  },
  "beaconMessageList": {
    "title": "Beacon message settings",
    "labels": {
      "restaurantOptionsTitle": "Merchant",
      "beaconConnectionOptionsTitle": "Official Accounts",
      "nodata": "No data, let ’s add a new beacon message",
      "newBeaconMessage": "+ Message",
      "editHint": "Edit Beacon Message",
      "reportHint": "View Report",
      "summaryHint": "View Summary"
    },
    "headers": {
      "name": "Beacon Message Name",
      "merchant": "Brand",
      "beaconConnection": "Official Account",
      "state": "Status",
      "endDate": "End Date"
    },
    "buttons": { "activate": "Activate", "deactivate": "Deactivate" },
    "placeholers": {
      "searchBar": "Search Beacon Message Name, Brand or Official Account..."
    }
  },
  "beaconMessageSetupFlowPage": {
    "titles": {
      "create": "Create Beacon Message",
      "basicSection": "Basic",
      "creativeSection": "Message Basic",
      "deviceSetupSection": "Device Setting",
      "formStep": "Message Campaign Setting",
      "summaryStep": "Summary",
      "summarySection": "Message Campaign Summary",
      "edit": "Edit Beacon Message",
      "summary": "Beacon Message Summary"
    }
  },
  "beaconMessageForm": {
    "labels": {
      "name": "Message Campaign Name",
      "schedule": "Schedule",
      "dayparts": "Daypart",
      "channel": "Channel"
    }
  },
  "restaurantDetail": { "labels": { "title": "Merchant" } },
  "restaurants": {
    "home": { "title": "Merchant", "searchPlaceholder": "Search Merchant..." },
    "noDataAvailable": "No data",
    "headers": { "name": "Merchant Name" }
  },
  "beaconMessageFields": {
    "labels": {
      "frequencyCapSwitch": "Frequency Capping",
      "deviceSetting": "Beacon Device Setting"
    }
  },
  "screenDisplayType": {
    "movableOutdoor": { "single": "Movable single" },
    "outdoor": { "single": "Fixed single" },
    "multiSpliced": "Multi Spliced Screen",
    "synchronizedPlayback": "Synchronized Playback",
    "ePaper": { "single": "E-Paper single" }
  },
  "multiSplicedCreativeDetail": {
    "labels": {
      "toggleSingleVideo": "Source Video",
      "toggleMultiSplicedVideo": "Spliced Video",
      "toggleSingleImage": "Source Image",
      "toggleMultiSplicedImage": "Spliced Image",
      "playAll": "play",
      "pauseAll": "pause"
    }
  },
  "downloadOutdoorFinalReportPanel": {
    "title": "Outdoor Final Report",
    "buttons": { "generate": "Gengerate" },
    "labels": {
      "targetImpressions": "Target Impressions",
      "showTop20Stores": "Show the delivery performance of the top 20 delivery stores"
    }
  },
  "deliveryUnit": { "device": "Device", "store": "Store" },
  "collapsibleSection": {
    "labels": { "expand": "Complete Editing", "collapse": "Edit Settings" }
  },
  "spaceHealth": {
    "labels": {
      "banned": "Banned",
      "warmingUp": "Warming up",
      "noData": "No signal",
      "normal": "Normal",
      "lastUpdated": "Last updated: {{time}}",
      "deleted": "Deleted"
    },
    "descriptions": {
      "warmingUp": "Recently activated; ad delivery is gradually recovering.",
      "noData": "Ad delivery has been interrupted for over 2 hours; the team is investigating."
    }
  },
  "addUrlModal": {
    "title": "Insert External Link",
    "labels": { "clickUrl": "External Link", "addUrl": "Add External Link" }
  },
  "siteAnnouncementForm": {
    "titles": {
      "create": "Create Site Announcement",
      "edit": "Edit Site Announcement",
      "basicSettingSection": "Basic Settings",
      "agencySection": "Agency adjustment scope",
      "contentSection": "Announcement Content",
      "advancedSection": "Advanced Settings"
    },
    "labels": {
      "name": "Name",
      "publishTime": "Publish Time",
      "content": "Content",
      "duration": "Duration",
      "prefix": { "duration": "Announcement will last for" },
      "postfix": { "duration": "day{{plural}} and removed afterwards" },
      "chooseVendorStrategy": "Agency",
      "allAgencies": "All Agencies",
      "partialAgencies": "Designated Agency",
      "shouldResend": "Should resend announcement",
      "attachmentUrls": "Attachments",
      "type": "Type",
      "imageUrl": "Image"
    },
    "placeholders": {
      "agencies": "Please select agencies",
      "attachmentUrls": "Please select attachments"
    },
    "errors": {
      "nameLength": "Announcement name cannot exceed 50 characters",
      "contentLength": "Announcement content cannot exceed 300 characters",
      "nameInvalid": "Announcement name requires pure text or punctuation marks, other special characters will not showcased in the message, please adjust the name",
      "contentInvalid": "Announcement content requires pure text or punctuation marks, other special characters will not showcased in the message, please adjust the content",
      "publishTimeTooEarly": "Can only set future time"
    },
    "hints": {
      "allFileStorage": "The total size of all files must not exceed {{storage}}",
      "fileType": "Only supports {{type}} format"
    }
  },
  "siteAnnouncementList": {
    "title": "Site Announcement",
    "placeholders": {
      "adminNoData": "No site announcement, let ’s add a new site announcement",
      "noData": "No site announcement",
      "adminSearchbar": "Search Name, Message or Agency",
      "searchbar": "Search Name or Message"
    },
    "buttons": {
      "create": "+ Site Announcement",
      "showDetail": "Show announcement detail",
      "activate": "Activate",
      "deactivate": "Deactivate"
    },
    "headers": {
      "name": "Name",
      "content": "Content",
      "agencyIds": "Agencies",
      "publishTime": "Publish Time",
      "status": "Status",
      "creator": "Creator",
      "attachmentUrls": "Attachments",
      "type": "Type",
      "imageUrl": "Image"
    },
    "labels": {
      "allAgencies": "All Agencies",
      "published": "Published",
      "unpublished": "Unpublished",
      "inactive": "Inactive",
      "deleteModalTitle": "Delete Announcement",
      "deleteModalContent": "Are you sure you want to delete all selected campaigns?"
    },
    "hints": {
      "edit": "Edit announcement",
      "cannotDelete": "Published announcements cannot be deleted"
    },
    "messages": {
      "activateSuccess": "Activate Success",
      "deactivateSuccess": "Deactivate Success",
      "deleteSuccess": "Delete Success",
      "deleteError": "Delete Error"
    }
  },
  "siteAnnouncement": {
    "types": {
      "feature_update": "Feature Update",
      "system_maintenance": "System Maintenance",
      "policy_announcement": "Policy Announcement",
      "incident_report": "Incident Report",
      "general": "General"
    }
  },
  "siteAnnouncementDetailModal": {
    "labels": { "publishedTime": "Published at {{time}}" }
  },
  "versionChecker": {
    "title": "A new version (v{{version}}) is available",
    "message": "You're viewing an outdated version of this page. Please refresh to load the latest version and avoid errors.",
    "reload": "Refresh now"
  },
  "adjustmentTags": {
    "noCreativeBound": "No Creative Bound",
    "creativeRejected": "Creative Rejected",
    "notDelivering": "Not Delivering",
    "behindSchedule": "Behind Schedule",
    "severelyBehind": "Severely Behind Schedule",
    "storeBanned": "Store Closed",
    "budgetUnderspendRisk": "Budget Underspend Risk"
  },
  "weatherVerification": {
    "labels": {
      "reportType": "Report Type",
      "deliveryPerformance": "Device Delivery Performance",
      "deliveryVerification": "Device Delivery Verification",
      "timeSlot": "Time Slot",
      "campaign": "Campaign",
      "store": "Store",
      "maxQueryDaysHint": "Up to {{days}} days",
      "noConditions": "None",
      "noStatusData": "No device status available",
      "deviceStatus": "Status: {{status}}",
      "deviceStatusReason": "Reason: {{reason}}",
      "exportCsv": "Export CSV",
      "csvFileName": "weather-verification_{{campaign}}_{{from}}_{{to}}_p{{page}}.csv"
    },
    "headers": {
      "dataTime": "Time",
      "storeName": "Store",
      "result": "Result",
      "unmatchedReasons": "Reason Not Delivered",
      "targetOf": "{{dimension}} (Target)"
    },
    "filters": {
      "all": "All Time Slots",
      "delivered": "Deliverable",
      "weatherUnmatched": "Weather Unmatched - Not Delivered",
      "deviceAbnormal": "Device Abnormal - Not Delivered",
      "outsideBusinessHours": "Outside Business Hours - Not Delivered",
      "trafficOccupied": "Traffic Occupied - Not Delivered"
    },
    "results": {
      "delivered": "Deliverable",
      "weatherUnmatched": "Weather Unmatched",
      "deviceAbnormal": "Device Abnormal",
      "outsideBusinessHours": "Outside Business Hours",
      "trafficOccupied": "Traffic Occupied"
    },
    "reasons": {
      "weatherCode": "Weather Phenomenon Unmatched",
      "temperature": "Temperature Unmatched",
      "relativeHumidity": "Humidity Unmatched",
      "uvIndex": "UV Index Unmatched",
      "precipitation": "Precipitation Unmatched",
      "device": "Device Abnormal",
      "businessHours": "Outside Business Hours"
    },
    "descriptions": {
      "checkDevicePage": "Please check the device management page.",
      "unmatchedTarget": "Target: {{target}}",
      "unmatchedActual": "Actual: {{actual}}",
      "deviceAbnormalHint": "The device was abnormal during this time slot and did not deliver.",
      "queryWindowLimit": "Only data from the last {{months}} months can be queried",
      "noMatchingCampaign": "No matching campaigns in this campaign group",
      "trafficOccupiedHint": "Conditions met, but no impressions this hour"
    },
    "errors": {
      "maxQueryDays": "Please select a date range of no more than {{days}} days"
    },
    "summary": {
      "error": "Failed to load the summary. Please try again later.",
      "loading": "Loading summary…",
      "outsideHint": "Scheduled, but the store was closed",
      "outsideShare": "<b>{{percent}}</b> of scheduled slots",
      "scheduleAndBusinessHours": "Campaign schedule ∩ business hours",
      "sections": {
        "inBusinessHours": "Within business hours",
        "outsideBusinessHours": "Outside business hours"
      },
      "storesByDays": "{{stores}} × {{days}}",
      "titles": { "inspected": "Inspected slots" },
      "affectedStores_one": "Affects <b>{{num}}</b> store",
      "affectedStores_other": "Affects <b>{{num}}</b> stores",
      "dayCount_one": "{{num}} day",
      "dayCount_other": "{{num}} days",
      "openStores_one": "<b>{{open}}</b> of {{num}} store open",
      "openStores_other": "<b>{{open}}</b> of {{num}} stores open",
      "slotUnit_one": "store slot",
      "slotUnit_other": "store slots",
      "storeCount_one": "{{num}} store",
      "storeCount_other": "{{num}} stores"
    }
  },
  "deviceManagement": {
    "buttons": {
      "clearFilter": "Clear Filters",
      "downloadImportTemplate": "Download Template",
      "exitListMode": "Exit List Mode",
      "export": "Export List",
      "import": "Import List",
      "loadImportSample": "Load Sample List",
      "nextMonth": "Next month",
      "previousMonth": "Previous month",
      "startMatching": "Start Matching",
      "daypartAll": "Select all",
      "daypartCommute": "Weekday commute",
      "daypartNone": "Clear",
      "daypartWeekend": "Weekend, all day"
    },
    "headers": {
      "address": "Address",
      "availabilityRate": "Availability",
      "availableSeconds": "Available Seconds",
      "dailyAverageFootfall": "Daily Avg. Foot Traffic",
      "detail": "Details",
      "deviceCharacteristic": "Device Characteristic",
      "deviceName": "Device Name",
      "healthState": "Status",
      "lastReportedAt": "Last Reported",
      "soldSeconds": "Sold Seconds",
      "storeNum": "Store No.",
      "unitName": "Store Name",
      "agencyName": "Agency",
      "orderName": "Order",
      "pmpFlight": "Flight",
      "todayBusinessHours": "Today's Business Hours"
    },
    "hints": {
      "administrativeArea": "Checking a city includes every district in it",
      "exportConditionsInFileName": "The sort order and filters are written into the file name",
      "exportListColumnsOnly": "The exported file uses the list view columns; the flight period and availability figures are not included",
      "filterWithinList": "Filter within the list",
      "healthState": "Select none for all statuses",
      "importFormat": "Format: city_storeNo_storeName",
      "importMatchKey": "Matched by store number; city and store name are only validated",
      "placeCategory": "Checking a parent includes everything under it",
      "region": "Single level",
      "daypartsOutsideBusinessHours": "Some selected hours may fall outside certain devices' business hours. Please check each device's business hours."
    },
    "labels": {
      "availabilityCalendar": "Future Availability",
      "basicInformation": "Basic Information",
      "calendarRange": "{{startDate}} ~ {{endDate}} ({{days}} days)",
      "coordinates": "Coordinates",
      "dayparts": "Dayparts",
      "deliverableDevices": "Deliverable Devices",
      "deliverableStores": "Deliverable Stores",
      "detailTitle": "Device Details",
      "exportAll": "All {{total}} rows",
      "exportCount": "Number of rows",
      "exportDefaultSort": "the default order (units needing attention first)",
      "exportFilterApplied": "{{total}} filters applied",
      "exportListMode": "List mode {{fileName}}",
      "exportNoFilter": "No filters applied",
      "exportScope": "Range",
      "exportSortAsc": "{{field}} ascending",
      "exportSortBy": "Sorted by <1>{{sort}}</1>",
      "exportSortDesc": "{{field}} descending",
      "exportTopN": "Top N by current sort",
      "flightDayCount": "{{days}} days in total",
      "flightRange": "Flight Period",
      "importPastedName": "Pasted list",
      "importReadCount": "{{fileName}} — {{total}} rows read",
      "importRecognizedCount": "{{total}} rows recognized",
      "importSampleName": "Sample list",
      "importTitle": "Import Store List",
      "lastReportedAtValue": "Last reported {{value}}",
      "lastSynced": "Last synced {{time}}",
      "listMode": "List Mode",
      "listModeCount": "{{total}} imported / {{hit}} matched",
      "listModeIssueCount": "{{total}} to review",
      "overallAvailabilityRate": "Overall Availability",
      "region": "Region",
      "resolution": "Resolution",
      "secondsValue": "{{value}} sec",
      "selectedHoursPerWeek": "{{hours}} hours/week selected",
      "statusReason": "Status Note",
      "weeklyFootTraffic": "Foot Traffic (Last 7 Days)",
      "pmpBookings": "PMP Bookings",
      "weeklyFootTrafficPeak": "Peak {{day}} at {{value}}",
      "businessHours": "Business Hours",
      "openAllDay": "24 Hours",
      "closedForDay": "Closed",
      "weekdayShort": {
        "1": "Mon",
        "2": "Tue",
        "3": "Wed",
        "4": "Thu",
        "5": "Fri",
        "6": "Sat",
        "7": "Sun"
      }
    },
    "legends": {
      "ample": "Ample",
      "low": "Below 30%",
      "medium": "Below 60%",
      "notScheduled": "Not scheduled",
      "outOfRange": "Outside flight",
      "soldOut": "Sold out"
    },
    "messages": {
      "calendarNoBusinessHours": "This unit has no business hours data, so availability cannot be calculated.",
      "exportInvalidCount": "Enter a number of rows greater than 0",
      "exportUnknownScope": "Choose a range to export",
      "calendarLoadFailed": "Failed to load the availability calendar",
      "noPmpBooking": "No PMP has booked this unit within the flight",
      "pmpBookingsLoadFailed": "Failed to load the PMP bookings",
      "listLoadFailed": "Failed to load the list",
      "importAmbiguous": "Two segments cannot tell which one is the store number; use city_storeNo_storeName, or the store number alone",
      "importInvalidStoreNum": "The store number must be digits",
      "importMismatch": "City or store name does not match the store found",
      "importNotFound": "No store with this number in this sales channel",
      "insufficientBusinessHours": "Insufficient data",
      "loadingFilterOptions": "Loading options...",
      "missingBusinessHoursDevices": "{{total}} more devices have no business hours data",
      "missingBusinessHoursStores": "{{total}} more stores have no business hours data",
      "noFilterOption": "No matching option",
      "noFootTrafficData": "No foot traffic data available",
      "noUnit": "No data matches the current filters",
      "selectChannelFirst": "Select a sales channel first",
      "uncomputableCampaigns": "{{total}} campaigns could not be counted into sold seconds",
      "filterOptionsLoadFailed": "Failed to load options"
    },
    "placeholders": {
      "filterSearch": "Search options",
      "importPaste": "One store per line, e.g.\n臺北市_177463_天福\nor just the store number: 177463",
      "searchbar": "Search store name, store no. or address"
    },
    "tabs": {
      "availability": "Device Availability",
      "importFile": "Upload File",
      "importPaste": "Paste Store No.",
      "list": "Device List View"
    },
    "title": "Device Management"
  },
  "key": "en",
  "apiTokens": {
    "buttons": {
      "copiedAndClose": "I've copied it, close",
      "copy": "Copy",
      "create": "New Token"
    },
    "columns": {
      "actions": "Actions",
      "createdAt": "Created at",
      "expiredAt": "Expiration date",
      "lastUsedAt": "Last used",
      "name": "Name",
      "status": "Status",
      "tokenPrefix": "Token"
    },
    "createModal": {
      "resultTitle": "API Token created",
      "resultWarning": "This token is shown only once. You cannot view it again after closing, so copy and save it now.",
      "title": "New API Token"
    },
    "deleteModal": {
      "content": "Delete {{name}} ({{tokenPrefix}})? Any system using this token will lose access immediately.",
      "title": "Delete API Token"
    },
    "errors": {
      "expiredAtRequired": "Please select an expiration date",
      "nameRequired": "Please enter a name",
      "nameTooLong": "Name cannot exceed 50 characters"
    },
    "hints": {
      "copied": "Copied to clipboard",
      "delete": "Delete",
      "reachLimit": "You have reached the limit of 10 tokens. Delete one first.",
      "sudo": "API tokens cannot be created or deleted while using Sudo.",
      "copyFailed": "Copy failed. Please select the token and copy it manually."
    },
    "labels": {
      "active": "Active",
      "expired": "Expired",
      "expiredAt": "Expiration date",
      "name": "Name",
      "neverExpires": "Never expires",
      "neverUsed": "Never used",
      "token": "Token"
    },
    "placeholders": { "noData": "No API tokens yet" },
    "title": "API Token",
    "links": { "viewDocs": "View API Docs" }
  },
  "apiDocs": {
    "buttons": { "download": "Download OpenAPI JSON", "reload": "Reload" },
    "errors": {
      "network": "Unable to connect. Please check your network and try again."
    },
    "links": { "manageTokens": "Manage API Tokens" },
    "placeholders": { "loadFailed": "Unable to load the API docs" },
    "title": "API Docs"
  }
}
